import { reactive as _a, ref as G, defineComponent as Ge, useSlots as jt, toRef as ya, getCurrentInstance as Xr, onMounted as Je, nextTick as dt, onUnmounted as ua, watch as ft, computed as W, createElementBlock as H, openBlock as D, unref as d, normalizeClass as ke, createVNode as ut, createBlock as Ae, mergeProps as je, isRef as Rn, createSlots as at, renderList as Ie, withCtx as _e, renderSlot as se, normalizeProps as Qe, guardReactiveProps as ot, resolveDynamicComponent as Sa, Teleport as jr, Transition as da, createCommentVNode as z, h as Qr, render as Yn, createElementVNode as ge, withModifiers as ga, normalizeStyle as vt, Fragment as be, toDisplayString as tt, useAttrs as Gr, createTextVNode as Ot, toValue as Jr, getCurrentScope as Kr, onScopeDispose as Zr, onBeforeUpdate as el, withDirectives as $a, vShow as Oa, withKeys as tl } from "vue";
const er = 6048e5, al = 864e5, nl = 6e4, tr = 36e5, rl = 1e3, Sn = /* @__PURE__ */ Symbol.for("constructDateFrom");
function Ce(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Sn in e ? e[Sn](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function pe(e, t) {
  return Ce(t || e, e);
}
function ct(e, t, n) {
  const a = pe(e, n?.in);
  return isNaN(t) ? Ce(n?.in || e, NaN) : (t && a.setDate(a.getDate() + t), a);
}
function bt(e, t, n) {
  const a = pe(e, n?.in);
  if (isNaN(t)) return Ce(e, NaN);
  if (!t)
    return a;
  const r = a.getDate(), l = Ce(e, a.getTime());
  l.setMonth(a.getMonth() + t + 1, 0);
  const o = l.getDate();
  return r >= o ? l : (a.setFullYear(
    l.getFullYear(),
    l.getMonth(),
    r
  ), a);
}
function ar(e, t, n) {
  const {
    years: a = 0,
    months: r = 0,
    weeks: l = 0,
    days: o = 0,
    hours: v = 0,
    minutes: u = 0,
    seconds: x = 0
  } = t, f = pe(e, n?.in), p = r || a ? bt(f, r + a * 12) : f, h = o || l ? ct(p, o + l * 7) : p, _ = u + v * 60, Y = (x + _ * 60) * 1e3;
  return Ce(e, +h + Y);
}
function ll(e, t, n) {
  return Ce(e, +pe(e) + t);
}
function ol(e, t, n) {
  return ll(e, t * tr);
}
let sl = {};
function Qt() {
  return sl;
}
function _t(e, t) {
  const n = Qt(), a = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = pe(e, t?.in), l = r.getDay(), o = (l < a ? 7 : 0) + l - a;
  return r.setDate(r.getDate() - o), r.setHours(0, 0, 0, 0), r;
}
function na(e, t) {
  return _t(e, { ...t, weekStartsOn: 1 });
}
function nr(e, t) {
  const n = pe(e, t?.in), a = n.getFullYear(), r = Ce(n, 0);
  r.setFullYear(a + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const l = na(r), o = Ce(n, 0);
  o.setFullYear(a, 0, 4), o.setHours(0, 0, 0, 0);
  const v = na(o);
  return n.getTime() >= l.getTime() ? a + 1 : n.getTime() >= v.getTime() ? a : a - 1;
}
function Ca(e) {
  const t = pe(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function ka(e, ...t) {
  const n = Ce.bind(
    null,
    t.find((a) => typeof a == "object")
  );
  return t.map(n);
}
function In(e, t) {
  const n = pe(e, t?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function rr(e, t, n) {
  const [a, r] = ka(
    n?.in,
    e,
    t
  ), l = In(a), o = In(r), v = +l - Ca(l), u = +o - Ca(o);
  return Math.round((v - u) / al);
}
function il(e, t) {
  const n = nr(e, t), a = Ce(e, 0);
  return a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0), na(a);
}
function ul(e, t, n) {
  return bt(e, t * 3, n);
}
function fn(e, t, n) {
  return bt(e, t * 12, n);
}
function Nn(e, t) {
  const n = +pe(e) - +pe(t);
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function lr(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function pa(e) {
  return !(!lr(e) && typeof e != "number" || isNaN(+pe(e)));
}
function Vn(e, t) {
  const n = pe(e, t?.in);
  return Math.trunc(n.getMonth() / 3) + 1;
}
function dl(e, t, n) {
  const [a, r] = ka(
    n?.in,
    e,
    t
  );
  return a.getFullYear() - r.getFullYear();
}
function cl(e, t, n) {
  const [a, r] = ka(
    n?.in,
    e,
    t
  ), l = Nn(a, r), o = Math.abs(dl(a, r));
  a.setFullYear(1584), r.setFullYear(1584);
  const v = Nn(a, r) === -l, u = l * (o - +v);
  return u === 0 ? 0 : u;
}
function or(e, t) {
  const [n, a] = ka(e, t.start, t.end);
  return { start: n, end: a };
}
function sr(e, t) {
  const { start: n, end: a } = or(t?.in, e);
  let r = +n > +a;
  const l = r ? +n : +a, o = r ? a : n;
  o.setHours(0, 0, 0, 0);
  let v = 1;
  const u = [];
  for (; +o <= l; )
    u.push(Ce(n, o)), o.setDate(o.getDate() + v), o.setHours(0, 0, 0, 0);
  return r ? u.reverse() : u;
}
function qt(e, t) {
  const n = pe(e, t?.in), a = n.getMonth(), r = a - a % 3;
  return n.setMonth(r, 1), n.setHours(0, 0, 0, 0), n;
}
function vl(e, t) {
  const { start: n, end: a } = or(t?.in, e);
  let r = +n > +a;
  const l = r ? +qt(n) : +qt(a);
  let o = qt(r ? a : n), v = 1;
  const u = [];
  for (; +o <= l; )
    u.push(Ce(n, o)), o = ul(o, v);
  return r ? u.reverse() : u;
}
function fl(e, t) {
  const n = pe(e, t?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function ir(e, t) {
  const n = pe(e, t?.in), a = n.getFullYear();
  return n.setFullYear(a + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function ta(e, t) {
  const n = pe(e, t?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function ur(e, t) {
  const n = Qt(), a = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = pe(e, t?.in), l = r.getDay(), o = (l < a ? -7 : 0) + 6 - (l - a);
  return r.setDate(r.getDate() + o), r.setHours(23, 59, 59, 999), r;
}
function Fn(e, t) {
  const n = pe(e, t?.in), a = n.getMonth(), r = a - a % 3 + 3;
  return n.setMonth(r, 0), n.setHours(23, 59, 59, 999), n;
}
const ml = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, pl = (e, t, n) => {
  let a;
  const r = ml[e];
  return typeof r == "string" ? a = r : t === 1 ? a = r.one : a = r.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
function Xa(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const hl = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, yl = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, gl = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, wl = {
  date: Xa({
    formats: hl,
    defaultWidth: "full"
  }),
  time: Xa({
    formats: yl,
    defaultWidth: "full"
  }),
  dateTime: Xa({
    formats: gl,
    defaultWidth: "full"
  })
}, bl = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, _l = (e, t, n, a) => bl[e];
function va(e) {
  return (t, n) => {
    const a = n?.context ? String(n.context) : "standalone";
    let r;
    if (a === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, v = n?.width ? String(n.width) : o;
      r = e.formattingValues[v] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, v = n?.width ? String(n.width) : e.defaultWidth;
      r = e.values[v] || e.values[o];
    }
    const l = e.argumentCallback ? e.argumentCallback(t) : t;
    return r[l];
  };
}
const kl = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Ml = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, xl = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Tl = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Dl = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Pl = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Al = (e, t) => {
  const n = Number(e), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, $l = {
  ordinalNumber: Al,
  era: va({
    values: kl,
    defaultWidth: "wide"
  }),
  quarter: va({
    values: Ml,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: va({
    values: xl,
    defaultWidth: "wide"
  }),
  day: va({
    values: Tl,
    defaultWidth: "wide"
  }),
  dayPeriod: va({
    values: Dl,
    defaultWidth: "wide",
    formattingValues: Pl,
    defaultFormattingWidth: "wide"
  })
};
function fa(e) {
  return (t, n = {}) => {
    const a = n.width, r = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], l = t.match(r);
    if (!l)
      return null;
    const o = l[0], v = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(v) ? Cl(v, (p) => p.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      Ol(v, (p) => p.test(o))
    );
    let x;
    x = e.valueCallback ? e.valueCallback(u) : u, x = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(x)
    ) : x;
    const f = t.slice(o.length);
    return { value: x, rest: f };
  };
}
function Ol(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function Cl(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function Rl(e) {
  return (t, n = {}) => {
    const a = t.match(e.matchPattern);
    if (!a) return null;
    const r = a[0], l = t.match(e.parsePattern);
    if (!l) return null;
    let o = e.valueCallback ? e.valueCallback(l[0]) : l[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    const v = t.slice(r.length);
    return { value: o, rest: v };
  };
}
const Yl = /^(\d+)(th|st|nd|rd)?/i, Sl = /\d+/i, Il = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Nl = {
  any: [/^b/i, /^(a|c)/i]
}, Vl = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Fl = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, El = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Ll = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Bl = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Hl = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Wl = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ql = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, zl = {
  ordinalNumber: Rl({
    matchPattern: Yl,
    parsePattern: Sl,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: fa({
    matchPatterns: Il,
    defaultMatchWidth: "wide",
    parsePatterns: Nl,
    defaultParseWidth: "any"
  }),
  quarter: fa({
    matchPatterns: Vl,
    defaultMatchWidth: "wide",
    parsePatterns: Fl,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: fa({
    matchPatterns: El,
    defaultMatchWidth: "wide",
    parsePatterns: Ll,
    defaultParseWidth: "any"
  }),
  day: fa({
    matchPatterns: Bl,
    defaultMatchWidth: "wide",
    parsePatterns: Hl,
    defaultParseWidth: "any"
  }),
  dayPeriod: fa({
    matchPatterns: Wl,
    defaultMatchWidth: "any",
    parsePatterns: ql,
    defaultParseWidth: "any"
  })
}, dr = {
  code: "en-US",
  formatDistance: pl,
  formatLong: wl,
  formatRelative: _l,
  localize: $l,
  match: zl,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Ul(e, t) {
  const n = pe(e, t?.in);
  return rr(n, ta(n)) + 1;
}
function mn(e, t) {
  const n = pe(e, t?.in), a = +na(n) - +il(n);
  return Math.round(a / er) + 1;
}
function pn(e, t) {
  const n = pe(e, t?.in), a = n.getFullYear(), r = Qt(), l = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, o = Ce(t?.in || e, 0);
  o.setFullYear(a + 1, 0, l), o.setHours(0, 0, 0, 0);
  const v = _t(o, t), u = Ce(t?.in || e, 0);
  u.setFullYear(a, 0, l), u.setHours(0, 0, 0, 0);
  const x = _t(u, t);
  return +n >= +v ? a + 1 : +n >= +x ? a : a - 1;
}
function Xl(e, t) {
  const n = Qt(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, r = pn(e, t), l = Ce(t?.in || e, 0);
  return l.setFullYear(r, 0, a), l.setHours(0, 0, 0, 0), _t(l, t);
}
function hn(e, t) {
  const n = pe(e, t?.in), a = +_t(n, t) - +Xl(n, t);
  return Math.round(a / er) + 1;
}
function Oe(e, t) {
  const n = e < 0 ? "-" : "", a = Math.abs(e).toString().padStart(t, "0");
  return n + a;
}
const St = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
    return Oe(t === "yy" ? a % 100 : a, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Oe(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Oe(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Oe(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Oe(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Oe(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Oe(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, a = e.getMilliseconds(), r = Math.trunc(
      a * Math.pow(10, n - 3)
    );
    return Oe(r, t.length);
  }
}, Jt = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, En = {
  // Era
  G: function(e, t, n) {
    const a = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(a, { width: "narrow" });
      default:
        return n.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const a = e.getFullYear(), r = a > 0 ? a : 1 - a;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return St.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, a) {
    const r = pn(e, a), l = r > 0 ? r : 1 - r;
    if (t === "YY") {
      const o = l % 100;
      return Oe(o, 2);
    }
    return t === "Yo" ? n.ordinalNumber(l, { unit: "year" }) : Oe(l, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = nr(e);
    return Oe(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Oe(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(a);
      // 01, 02, 03, 04
      case "QQ":
        return Oe(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(a);
      // 01, 02, 03, 04
      case "qq":
        return Oe(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const a = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return St.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const a = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(a + 1);
      // 01, 02, ..., 12
      case "LL":
        return Oe(a + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, a) {
    const r = hn(e, a);
    return t === "wo" ? n.ordinalNumber(r, { unit: "week" }) : Oe(r, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const a = mn(e);
    return t === "Io" ? n.ordinalNumber(a, { unit: "week" }) : Oe(a, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : St.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const a = Ul(e);
    return t === "Do" ? n.ordinalNumber(a, { unit: "dayOfYear" }) : Oe(a, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const a = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, a) {
    const r = e.getDay(), l = (r - a.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(l);
      // Padded numerical value
      case "ee":
        return Oe(l, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(l, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, a) {
    const r = e.getDay(), l = (r - a.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(l);
      // Padded numerical value
      case "cc":
        return Oe(l, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(l, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const a = e.getDay(), r = a === 0 ? 7 : a;
    switch (t) {
      // 2
      case "i":
        return String(r);
      // 02
      case "ii":
        return Oe(r, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      // Tue
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const a = e.getHours();
    let r;
    switch (a === 12 ? r = Jt.noon : a === 0 ? r = Jt.midnight : r = a / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const a = e.getHours();
    let r;
    switch (a >= 17 ? r = Jt.evening : a >= 12 ? r = Jt.afternoon : a >= 4 ? r = Jt.morning : r = Jt.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let a = e.getHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, { unit: "hour" });
    }
    return St.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : St.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const a = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(a, { unit: "hour" }) : Oe(a, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let a = e.getHours();
    return a === 0 && (a = 24), t === "ko" ? n.ordinalNumber(a, { unit: "hour" }) : Oe(a, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : St.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : St.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return St.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const a = e.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Bn(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Wt(a);
      // Hours and minutes with `:` delimiter
      default:
        return Wt(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Bn(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Wt(a);
      // Hours and minutes with `:` delimiter
      default:
        return Wt(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ln(a, ":");
      default:
        return "GMT" + Wt(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ln(a, ":");
      default:
        return "GMT" + Wt(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const a = Math.trunc(+e / 1e3);
    return Oe(a, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return Oe(+e, t.length);
  }
};
function Ln(e, t = "") {
  const n = e > 0 ? "-" : "+", a = Math.abs(e), r = Math.trunc(a / 60), l = a % 60;
  return l === 0 ? n + String(r) : n + String(r) + t + Oe(l, 2);
}
function Bn(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Oe(Math.abs(e) / 60, 2) : Wt(e, t);
}
function Wt(e, t = "") {
  const n = e > 0 ? "-" : "+", a = Math.abs(e), r = Oe(Math.trunc(a / 60), 2), l = Oe(a % 60, 2);
  return n + r + t + l;
}
const Hn = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    default:
      return t.date({ width: "full" });
  }
}, cr = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    default:
      return t.time({ width: "full" });
  }
}, jl = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], a = n[1], r = n[2];
  if (!r)
    return Hn(e, t);
  let l;
  switch (a) {
    case "P":
      l = t.dateTime({ width: "short" });
      break;
    case "PP":
      l = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      l = t.dateTime({ width: "long" });
      break;
    default:
      l = t.dateTime({ width: "full" });
      break;
  }
  return l.replace("{{date}}", Hn(a, t)).replace("{{time}}", cr(r, t));
}, ln = {
  p: cr,
  P: jl
}, Ql = /^D+$/, Gl = /^Y+$/, Jl = ["D", "DD", "YY", "YYYY"];
function vr(e) {
  return Ql.test(e);
}
function fr(e) {
  return Gl.test(e);
}
function on(e, t, n) {
  const a = Kl(e, t, n);
  if (console.warn(a), Jl.includes(e)) throw new RangeError(a);
}
function Kl(e, t, n) {
  const a = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${a} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Zl = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, eo = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, to = /^'([^]*?)'?$/, ao = /''/g, no = /[a-zA-Z]/;
function Dt(e, t, n) {
  const a = Qt(), r = n?.locale ?? a.locale ?? dr, l = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? a.firstWeekContainsDate ?? a.locale?.options?.firstWeekContainsDate ?? 1, o = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? a.weekStartsOn ?? a.locale?.options?.weekStartsOn ?? 0, v = pe(e, n?.in);
  if (!pa(v))
    throw new RangeError("Invalid time value");
  let u = t.match(eo).map((f) => {
    const p = f[0];
    if (p === "p" || p === "P") {
      const h = ln[p];
      return h(f, r.formatLong);
    }
    return f;
  }).join("").match(Zl).map((f) => {
    if (f === "''")
      return { isToken: !1, value: "'" };
    const p = f[0];
    if (p === "'")
      return { isToken: !1, value: ro(f) };
    if (En[p])
      return { isToken: !0, value: f };
    if (p.match(no))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + p + "`"
      );
    return { isToken: !1, value: f };
  });
  r.localize.preprocessor && (u = r.localize.preprocessor(v, u));
  const x = {
    firstWeekContainsDate: l,
    weekStartsOn: o,
    locale: r
  };
  return u.map((f) => {
    if (!f.isToken) return f.value;
    const p = f.value;
    (!n?.useAdditionalWeekYearTokens && fr(p) || !n?.useAdditionalDayOfYearTokens && vr(p)) && on(p, t, String(e));
    const h = En[p[0]];
    return h(v, p, r.localize, x);
  }).join("");
}
function ro(e) {
  const t = e.match(to);
  return t ? t[1].replace(ao, "'") : e;
}
function lo(e, t) {
  return pe(e, t?.in).getDay();
}
function oo(e, t) {
  const n = pe(e, t?.in), a = n.getFullYear(), r = n.getMonth(), l = Ce(n, 0);
  return l.setFullYear(a, r + 1, 0), l.setHours(0, 0, 0, 0), l.getDate();
}
function so() {
  return Object.assign({}, Qt());
}
function Ct(e, t) {
  return pe(e, t?.in).getHours();
}
function io(e, t) {
  const n = pe(e, t?.in).getDay();
  return n === 0 ? 7 : n;
}
function Et(e, t) {
  return pe(e, t?.in).getMinutes();
}
function Te(e, t) {
  return pe(e, t?.in).getMonth();
}
function ra(e) {
  return pe(e).getSeconds();
}
function ye(e, t) {
  return pe(e, t?.in).getFullYear();
}
function Xt(e, t) {
  return +pe(e) > +pe(t);
}
function la(e, t) {
  return +pe(e) < +pe(t);
}
function ea(e, t) {
  return +pe(e) == +pe(t);
}
function uo(e, t) {
  const n = co(t) ? new t(0) : Ce(t, 0);
  return n.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), n.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), n;
}
function co(e) {
  return typeof e == "function" && e.prototype?.constructor === e;
}
const vo = 10;
class mr {
  subPriority = 0;
  validate(t, n) {
    return !0;
  }
}
class fo extends mr {
  constructor(t, n, a, r, l) {
    super(), this.value = t, this.validateValue = n, this.setValue = a, this.priority = r, l && (this.subPriority = l);
  }
  validate(t, n) {
    return this.validateValue(t, this.value, n);
  }
  set(t, n, a) {
    return this.setValue(t, n, this.value, a);
  }
}
class mo extends mr {
  priority = vo;
  subPriority = -1;
  constructor(t, n) {
    super(), this.context = t || ((a) => Ce(n, a));
  }
  set(t, n) {
    return n.timestampIsSet ? t : Ce(t, uo(t, this.context));
  }
}
class $e {
  run(t, n, a, r) {
    const l = this.parse(t, n, a, r);
    return l ? {
      setter: new fo(
        l.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: l.rest
    } : null;
  }
  validate(t, n, a) {
    return !0;
  }
}
class po extends $e {
  priority = 140;
  parse(t, n, a) {
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return a.era(t, { width: "abbreviated" }) || a.era(t, { width: "narrow" });
      // A, B
      case "GGGGG":
        return a.era(t, { width: "narrow" });
      default:
        return a.era(t, { width: "wide" }) || a.era(t, { width: "abbreviated" }) || a.era(t, { width: "narrow" });
    }
  }
  set(t, n, a) {
    return n.era = a, t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = ["R", "u", "t", "T"];
}
const We = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, xt = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function qe(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function Ve(e, t) {
  const n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function Tt(e, t) {
  const n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const a = n[1] === "+" ? 1 : -1, r = n[2] ? parseInt(n[2], 10) : 0, l = n[3] ? parseInt(n[3], 10) : 0, o = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: a * (r * tr + l * nl + o * rl),
    rest: t.slice(n[0].length)
  };
}
function pr(e) {
  return Ve(We.anyDigitsSigned, e);
}
function Ee(e, t) {
  switch (e) {
    case 1:
      return Ve(We.singleDigit, t);
    case 2:
      return Ve(We.twoDigits, t);
    case 3:
      return Ve(We.threeDigits, t);
    case 4:
      return Ve(We.fourDigits, t);
    default:
      return Ve(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function Ra(e, t) {
  switch (e) {
    case 1:
      return Ve(We.singleDigitSigned, t);
    case 2:
      return Ve(We.twoDigitsSigned, t);
    case 3:
      return Ve(We.threeDigitsSigned, t);
    case 4:
      return Ve(We.fourDigitsSigned, t);
    default:
      return Ve(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function yn(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    default:
      return 0;
  }
}
function hr(e, t) {
  const n = t > 0, a = n ? t : 1 - t;
  let r;
  if (a <= 50)
    r = e || 100;
  else {
    const l = a + 50, o = Math.trunc(l / 100) * 100, v = e >= l % 100;
    r = e + o - (v ? 100 : 0);
  }
  return n ? r : 1 - r;
}
function yr(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class ho extends $e {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];
  parse(t, n, a) {
    const r = (l) => ({
      year: l,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return qe(Ee(4, t), r);
      case "yo":
        return qe(
          a.ordinalNumber(t, {
            unit: "year"
          }),
          r
        );
      default:
        return qe(Ee(n.length, t), r);
    }
  }
  validate(t, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(t, n, a) {
    const r = t.getFullYear();
    if (a.isTwoDigitYear) {
      const o = hr(
        a.year,
        r
      );
      return t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const l = !("era" in n) || n.era === 1 ? a.year : 1 - a.year;
    return t.setFullYear(l, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class yo extends $e {
  priority = 130;
  parse(t, n, a) {
    const r = (l) => ({
      year: l,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return qe(Ee(4, t), r);
      case "Yo":
        return qe(
          a.ordinalNumber(t, {
            unit: "year"
          }),
          r
        );
      default:
        return qe(Ee(n.length, t), r);
    }
  }
  validate(t, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(t, n, a, r) {
    const l = pn(t, r);
    if (a.isTwoDigitYear) {
      const v = hr(
        a.year,
        l
      );
      return t.setFullYear(
        v,
        0,
        r.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), _t(t, r);
    }
    const o = !("era" in n) || n.era === 1 ? a.year : 1 - a.year;
    return t.setFullYear(o, 0, r.firstWeekContainsDate), t.setHours(0, 0, 0, 0), _t(t, r);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
class go extends $e {
  priority = 130;
  parse(t, n) {
    return Ra(n === "R" ? 4 : n.length, t);
  }
  set(t, n, a) {
    const r = Ce(t, 0);
    return r.setFullYear(a, 0, 4), r.setHours(0, 0, 0, 0), na(r);
  }
  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
class wo extends $e {
  priority = 130;
  parse(t, n) {
    return Ra(n === "u" ? 4 : n.length, t);
  }
  set(t, n, a) {
    return t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}
class bo extends $e {
  priority = 120;
  parse(t, n, a) {
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return Ee(n.length, t);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return a.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return a.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return a.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return a.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || a.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 4;
  }
  set(t, n, a) {
    return t.setMonth((a - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class _o extends $e {
  priority = 120;
  parse(t, n, a) {
    switch (n) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return Ee(n.length, t);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return a.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return a.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return a.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return a.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || a.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 4;
  }
  set(t, n, a) {
    return t.setMonth((a - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class ko extends $e {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
  priority = 110;
  parse(t, n, a) {
    const r = (l) => l - 1;
    switch (n) {
      // 1, 2, ..., 12
      case "M":
        return qe(
          Ve(We.month, t),
          r
        );
      // 01, 02, ..., 12
      case "MM":
        return qe(Ee(2, t), r);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return qe(
          a.ordinalNumber(t, {
            unit: "month"
          }),
          r
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return a.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.month(t, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return a.month(t, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return a.month(t, { width: "wide", context: "formatting" }) || a.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, a) {
    return t.setMonth(a, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Mo extends $e {
  priority = 110;
  parse(t, n, a) {
    const r = (l) => l - 1;
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return qe(
          Ve(We.month, t),
          r
        );
      // 01, 02, ..., 12
      case "LL":
        return qe(Ee(2, t), r);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return qe(
          a.ordinalNumber(t, {
            unit: "month"
          }),
          r
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return a.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.month(t, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return a.month(t, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return a.month(t, { width: "wide", context: "standalone" }) || a.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, a) {
    return t.setMonth(a, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function xo(e, t, n) {
  const a = pe(e, n?.in), r = hn(a, n) - t;
  return a.setDate(a.getDate() - r * 7), pe(a, n?.in);
}
class To extends $e {
  priority = 100;
  parse(t, n, a) {
    switch (n) {
      case "w":
        return Ve(We.week, t);
      case "wo":
        return a.ordinalNumber(t, { unit: "week" });
      default:
        return Ee(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 53;
  }
  set(t, n, a, r) {
    return _t(xo(t, a, r), r);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
function Do(e, t, n) {
  const a = pe(e, n?.in), r = mn(a, n) - t;
  return a.setDate(a.getDate() - r * 7), a;
}
class Po extends $e {
  priority = 100;
  parse(t, n, a) {
    switch (n) {
      case "I":
        return Ve(We.week, t);
      case "Io":
        return a.ordinalNumber(t, { unit: "week" });
      default:
        return Ee(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 53;
  }
  set(t, n, a) {
    return na(Do(t, a));
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
const Ao = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], $o = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Oo extends $e {
  priority = 90;
  subPriority = 1;
  parse(t, n, a) {
    switch (n) {
      case "d":
        return Ve(We.date, t);
      case "do":
        return a.ordinalNumber(t, { unit: "date" });
      default:
        return Ee(n.length, t);
    }
  }
  validate(t, n) {
    const a = t.getFullYear(), r = yr(a), l = t.getMonth();
    return r ? n >= 1 && n <= $o[l] : n >= 1 && n <= Ao[l];
  }
  set(t, n, a) {
    return t.setDate(a), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class Co extends $e {
  priority = 90;
  subpriority = 1;
  parse(t, n, a) {
    switch (n) {
      case "D":
      case "DD":
        return Ve(We.dayOfYear, t);
      case "Do":
        return a.ordinalNumber(t, { unit: "date" });
      default:
        return Ee(n.length, t);
    }
  }
  validate(t, n) {
    const a = t.getFullYear();
    return yr(a) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(t, n, a) {
    return t.setMonth(0, a), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function gn(e, t, n) {
  const a = Qt(), r = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? a.weekStartsOn ?? a.locale?.options?.weekStartsOn ?? 0, l = pe(e, n?.in), o = l.getDay(), u = (t % 7 + 7) % 7, x = 7 - r, f = t < 0 || t > 6 ? t - (o + x) % 7 : (u + x) % 7 - (o + x) % 7;
  return ct(l, f, n);
}
class Ro extends $e {
  priority = 90;
  parse(t, n, a) {
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return a.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return a.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
      default:
        return a.day(t, { width: "wide", context: "formatting" }) || a.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, a, r) {
    return t = gn(t, a, r), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}
class Yo extends $e {
  priority = 90;
  parse(t, n, a, r) {
    const l = (o) => {
      const v = Math.floor((o - 1) / 7) * 7;
      return (o + r.weekStartsOn + 6) % 7 + v;
    };
    switch (n) {
      // 3
      case "e":
      case "ee":
        return qe(Ee(n.length, t), l);
      // 3rd
      case "eo":
        return qe(
          a.ordinalNumber(t, {
            unit: "day"
          }),
          l
        );
      // Tue
      case "eee":
        return a.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return a.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
      default:
        return a.day(t, { width: "wide", context: "formatting" }) || a.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, a, r) {
    return t = gn(t, a, r), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T"
  ];
}
class So extends $e {
  priority = 90;
  parse(t, n, a, r) {
    const l = (o) => {
      const v = Math.floor((o - 1) / 7) * 7;
      return (o + r.weekStartsOn + 6) % 7 + v;
    };
    switch (n) {
      // 3
      case "c":
      case "cc":
        return qe(Ee(n.length, t), l);
      // 3rd
      case "co":
        return qe(
          a.ordinalNumber(t, {
            unit: "day"
          }),
          l
        );
      // Tue
      case "ccc":
        return a.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.day(t, { width: "short", context: "standalone" }) || a.day(t, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return a.day(t, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return a.day(t, { width: "short", context: "standalone" }) || a.day(t, { width: "narrow", context: "standalone" });
      default:
        return a.day(t, { width: "wide", context: "standalone" }) || a.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.day(t, { width: "short", context: "standalone" }) || a.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, a, r) {
    return t = gn(t, a, r), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T"
  ];
}
function Io(e, t, n) {
  const a = pe(e, n?.in), r = io(a, n), l = t - r;
  return ct(a, l, n);
}
class No extends $e {
  priority = 90;
  parse(t, n, a) {
    const r = (l) => l === 0 ? 7 : l;
    switch (n) {
      // 2
      case "i":
      case "ii":
        return Ee(n.length, t);
      // 2nd
      case "io":
        return a.ordinalNumber(t, { unit: "day" });
      // Tue
      case "iii":
        return qe(
          a.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      // T
      case "iiiii":
        return qe(
          a.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      // Tu
      case "iiiiii":
        return qe(
          a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      default:
        return qe(
          a.day(t, {
            width: "wide",
            context: "formatting"
          }) || a.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 7;
  }
  set(t, n, a) {
    return t = Io(t, a), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T"
  ];
}
class Vo extends $e {
  priority = 80;
  parse(t, n, a) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return a.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, a) {
    return t.setHours(yn(a), 0, 0, 0), t;
  }
  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}
class Fo extends $e {
  priority = 80;
  parse(t, n, a) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return a.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, a) {
    return t.setHours(yn(a), 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}
class Eo extends $e {
  priority = 80;
  parse(t, n, a) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return a.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, a) {
    return t.setHours(yn(a), 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "b", "t", "T"];
}
class Lo extends $e {
  priority = 70;
  parse(t, n, a) {
    switch (n) {
      case "h":
        return Ve(We.hour12h, t);
      case "ho":
        return a.ordinalNumber(t, { unit: "hour" });
      default:
        return Ee(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 12;
  }
  set(t, n, a) {
    const r = t.getHours() >= 12;
    return r && a < 12 ? t.setHours(a + 12, 0, 0, 0) : !r && a === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(a, 0, 0, 0), t;
  }
  incompatibleTokens = ["H", "K", "k", "t", "T"];
}
class Bo extends $e {
  priority = 70;
  parse(t, n, a) {
    switch (n) {
      case "H":
        return Ve(We.hour23h, t);
      case "Ho":
        return a.ordinalNumber(t, { unit: "hour" });
      default:
        return Ee(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 23;
  }
  set(t, n, a) {
    return t.setHours(a, 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}
class Ho extends $e {
  priority = 70;
  parse(t, n, a) {
    switch (n) {
      case "K":
        return Ve(We.hour11h, t);
      case "Ko":
        return a.ordinalNumber(t, { unit: "hour" });
      default:
        return Ee(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, a) {
    return t.getHours() >= 12 && a < 12 ? t.setHours(a + 12, 0, 0, 0) : t.setHours(a, 0, 0, 0), t;
  }
  incompatibleTokens = ["h", "H", "k", "t", "T"];
}
class Wo extends $e {
  priority = 70;
  parse(t, n, a) {
    switch (n) {
      case "k":
        return Ve(We.hour24h, t);
      case "ko":
        return a.ordinalNumber(t, { unit: "hour" });
      default:
        return Ee(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 24;
  }
  set(t, n, a) {
    const r = a <= 24 ? a % 24 : a;
    return t.setHours(r, 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}
class qo extends $e {
  priority = 60;
  parse(t, n, a) {
    switch (n) {
      case "m":
        return Ve(We.minute, t);
      case "mo":
        return a.ordinalNumber(t, { unit: "minute" });
      default:
        return Ee(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 59;
  }
  set(t, n, a) {
    return t.setMinutes(a, 0, 0), t;
  }
  incompatibleTokens = ["t", "T"];
}
class zo extends $e {
  priority = 50;
  parse(t, n, a) {
    switch (n) {
      case "s":
        return Ve(We.second, t);
      case "so":
        return a.ordinalNumber(t, { unit: "second" });
      default:
        return Ee(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 59;
  }
  set(t, n, a) {
    return t.setSeconds(a, 0), t;
  }
  incompatibleTokens = ["t", "T"];
}
class Uo extends $e {
  priority = 30;
  parse(t, n) {
    const a = (r) => Math.trunc(r * Math.pow(10, -n.length + 3));
    return qe(Ee(n.length, t), a);
  }
  set(t, n, a) {
    return t.setMilliseconds(a), t;
  }
  incompatibleTokens = ["t", "T"];
}
class Xo extends $e {
  priority = 10;
  parse(t, n) {
    switch (n) {
      case "X":
        return Tt(
          xt.basicOptionalMinutes,
          t
        );
      case "XX":
        return Tt(xt.basic, t);
      case "XXXX":
        return Tt(
          xt.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return Tt(
          xt.extendedOptionalSeconds,
          t
        );
      default:
        return Tt(xt.extended, t);
    }
  }
  set(t, n, a) {
    return n.timestampIsSet ? t : Ce(
      t,
      t.getTime() - Ca(t) - a
    );
  }
  incompatibleTokens = ["t", "T", "x"];
}
class jo extends $e {
  priority = 10;
  parse(t, n) {
    switch (n) {
      case "x":
        return Tt(
          xt.basicOptionalMinutes,
          t
        );
      case "xx":
        return Tt(xt.basic, t);
      case "xxxx":
        return Tt(
          xt.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return Tt(
          xt.extendedOptionalSeconds,
          t
        );
      default:
        return Tt(xt.extended, t);
    }
  }
  set(t, n, a) {
    return n.timestampIsSet ? t : Ce(
      t,
      t.getTime() - Ca(t) - a
    );
  }
  incompatibleTokens = ["t", "T", "X"];
}
class Qo extends $e {
  priority = 40;
  parse(t) {
    return pr(t);
  }
  set(t, n, a) {
    return [Ce(t, a * 1e3), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
class Go extends $e {
  priority = 20;
  parse(t) {
    return pr(t);
  }
  set(t, n, a) {
    return [Ce(t, a), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
const Jo = {
  G: new po(),
  y: new ho(),
  Y: new yo(),
  R: new go(),
  u: new wo(),
  Q: new bo(),
  q: new _o(),
  M: new ko(),
  L: new Mo(),
  w: new To(),
  I: new Po(),
  d: new Oo(),
  D: new Co(),
  E: new Ro(),
  e: new Yo(),
  c: new So(),
  i: new No(),
  a: new Vo(),
  b: new Fo(),
  B: new Eo(),
  h: new Lo(),
  H: new Bo(),
  K: new Ho(),
  k: new Wo(),
  m: new qo(),
  s: new zo(),
  S: new Uo(),
  X: new Xo(),
  x: new jo(),
  t: new Qo(),
  T: new Go()
}, Ko = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Zo = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, es = /^'([^]*?)'?$/, ts = /''/g, as = /\S/, ns = /[a-zA-Z]/;
function sn(e, t, n, a) {
  const r = () => Ce(a?.in || n, NaN), l = so(), o = a?.locale ?? l.locale ?? dr, v = a?.firstWeekContainsDate ?? a?.locale?.options?.firstWeekContainsDate ?? l.firstWeekContainsDate ?? l.locale?.options?.firstWeekContainsDate ?? 1, u = a?.weekStartsOn ?? a?.locale?.options?.weekStartsOn ?? l.weekStartsOn ?? l.locale?.options?.weekStartsOn ?? 0;
  if (!t)
    return e ? r() : pe(n, a?.in);
  const x = {
    firstWeekContainsDate: v,
    weekStartsOn: u,
    locale: o
  }, f = [new mo(a?.in, n)], p = t.match(Zo).map((P) => {
    const O = P[0];
    if (O in ln) {
      const R = ln[O];
      return R(P, o.formatLong);
    }
    return P;
  }).join("").match(Ko), h = [];
  for (let P of p) {
    !a?.useAdditionalWeekYearTokens && fr(P) && on(P, t, e), !a?.useAdditionalDayOfYearTokens && vr(P) && on(P, t, e);
    const O = P[0], R = Jo[O];
    if (R) {
      const { incompatibleTokens: k } = R;
      if (Array.isArray(k)) {
        const X = h.find(
          (S) => k.includes(S.token) || S.token === O
        );
        if (X)
          throw new RangeError(
            `The format string mustn't contain \`${X.fullToken}\` and \`${P}\` at the same time`
          );
      } else if (R.incompatibleTokens === "*" && h.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${P}\` and any other token at the same time`
        );
      h.push({ token: O, fullToken: P });
      const E = R.run(
        e,
        P,
        o.match,
        x
      );
      if (!E)
        return r();
      f.push(E.setter), e = E.rest;
    } else {
      if (O.match(ns))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + O + "`"
        );
      if (P === "''" ? P = "'" : O === "'" && (P = rs(P)), e.indexOf(P) === 0)
        e = e.slice(P.length);
      else
        return r();
    }
  }
  if (e.length > 0 && as.test(e))
    return r();
  const _ = f.map((P) => P.priority).sort((P, O) => O - P).filter((P, O, R) => R.indexOf(P) === O).map(
    (P) => f.filter((O) => O.priority === P).sort((O, R) => R.subPriority - O.subPriority)
  ).map((P) => P[0]);
  let C = pe(n, a?.in);
  if (isNaN(+C)) return r();
  const Y = {};
  for (const P of _) {
    if (!P.validate(C, x))
      return r();
    const O = P.set(C, Y, x);
    Array.isArray(O) ? (C = O[0], Object.assign(Y, O[1])) : C = O;
  }
  return C;
}
function rs(e) {
  return e.match(es)[1].replace(ts, "'");
}
function Wn(e, t, n) {
  const [a, r] = ka(
    n?.in,
    e,
    t
  );
  return +qt(a) == +qt(r);
}
function gr(e, t, n) {
  return ct(e, -t, n);
}
function wr(e, t, n) {
  const a = pe(e, n?.in), r = a.getFullYear(), l = a.getDate(), o = Ce(e, 0);
  o.setFullYear(r, t, 15), o.setHours(0, 0, 0, 0);
  const v = oo(o);
  return a.setMonth(t, Math.min(l, v)), a;
}
function Re(e, t, n) {
  let a = pe(e, n?.in);
  return isNaN(+a) ? Ce(e, NaN) : (t.year != null && a.setFullYear(t.year), t.month != null && (a = wr(a, t.month)), t.date != null && a.setDate(t.date), t.hours != null && a.setHours(t.hours), t.minutes != null && a.setMinutes(t.minutes), t.seconds != null && a.setSeconds(t.seconds), t.milliseconds != null && a.setMilliseconds(t.milliseconds), a);
}
function ls(e, t, n) {
  const a = pe(e, n?.in);
  return a.setHours(t), a;
}
function br(e, t, n) {
  const a = pe(e, n?.in);
  return a.setMilliseconds(t), a;
}
function os(e, t, n) {
  const a = pe(e, n?.in);
  return a.setMinutes(t), a;
}
function _r(e, t, n) {
  const a = pe(e, n?.in);
  return a.setSeconds(t), a;
}
function gt(e, t, n) {
  const a = pe(e, n?.in);
  return isNaN(+a) ? Ce(e, NaN) : (a.setFullYear(t), a);
}
function oa(e, t, n) {
  return bt(e, -t, n);
}
function ss(e, t, n) {
  const {
    years: a = 0,
    months: r = 0,
    weeks: l = 0,
    days: o = 0,
    hours: v = 0,
    minutes: u = 0,
    seconds: x = 0
  } = t, f = oa(e, r + a * 12, n), p = gr(f, o + l * 7, n), h = u + v * 60, C = (x + h * 60) * 1e3;
  return Ce(e, +p - C);
}
function kr(e, t, n) {
  return fn(e, -t, n);
}
function ca() {
  const e = Gr();
  return D(), H(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img",
      ...e
    },
    [
      ge("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      ge("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      ge("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      ge("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
ca.compatConfig = {
  MODE: 3
};
function Mr() {
  return D(), H(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      ge("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      ge("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Mr.compatConfig = {
  MODE: 3
};
function wn() {
  return D(), H(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      ge("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
wn.compatConfig = {
  MODE: 3
};
function bn() {
  return D(), H(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      ge("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
bn.compatConfig = {
  MODE: 3
};
function _n() {
  return D(), H(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      ge("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      ge("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
_n.compatConfig = {
  MODE: 3
};
function kn() {
  return D(), H(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      ge("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
kn.compatConfig = {
  MODE: 3
};
function Mn() {
  return D(), H(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      ge("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Mn.compatConfig = {
  MODE: 3
};
const st = (e, t) => t ? new Date(e.toLocaleString("en-US", { timeZone: t })) : new Date(e), xn = (e, t, n) => un(e, t, n) || B(), is = (e, t, n) => {
  const a = t.dateInTz ? st(new Date(e), t.dateInTz) : B(e);
  return n ? Ue(a, !0) : a;
}, un = (e, t, n) => {
  if (!e) return null;
  const a = n ? Ue(B(e), !0) : B(e);
  return t ? t.exactMatch ? is(e, t, n) : st(a, t.timezone) : a;
}, us = (e) => {
  const t = new Date(e.getFullYear(), 0, 1).getTimezoneOffset();
  return e.getTimezoneOffset() < t;
}, ds = (e, t) => {
  if (!e) return 0;
  const n = /* @__PURE__ */ new Date(), a = new Date(n.toLocaleString("en-US", { timeZone: "UTC" })), r = new Date(n.toLocaleString("en-US", { timeZone: e })), l = (us(t ?? r) ? r : t ?? r).getTimezoneOffset() / 60;
  return (+a - +r) / (1e3 * 60 * 60) - l;
};
var ht = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(ht || {}), yt = /* @__PURE__ */ ((e) => (e.top = "top", e.bottom = "bottom", e))(yt || {}), zt = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(zt || {}), et = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(et || {});
const cs = ["timestamp", "date", "iso"];
var nt = /* @__PURE__ */ ((e) => (e.up = "up", e.down = "down", e.left = "left", e.right = "right", e))(nt || {}), Se = /* @__PURE__ */ ((e) => (e.arrowUp = "ArrowUp", e.arrowDown = "ArrowDown", e.arrowLeft = "ArrowLeft", e.arrowRight = "ArrowRight", e.enter = "Enter", e.space = " ", e.esc = "Escape", e.tab = "Tab", e.home = "Home", e.end = "End", e.pageUp = "PageUp", e.pageDown = "PageDown", e))(Se || {}), aa = /* @__PURE__ */ ((e) => (e.MONTH_AND_YEAR = "MM-yyyy", e.YEAR = "yyyy", e.DATE = "dd-MM-yyyy", e))(aa || {});
function qn(e) {
  return (t) => {
    const n = new Intl.DateTimeFormat(e, {
      weekday: "short",
      timeZone: "UTC"
    }).format(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`));
    return e === "ar" ? n.slice(2, 5) : n.slice(0, 2);
  };
}
function vs(e) {
  return (t) => Dt(st(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`), "UTC"), "EEEEEE", { locale: e });
}
const fs = (e, t, n) => {
  const a = [1, 2, 3, 4, 5, 6, 7];
  let r;
  if (e !== null)
    try {
      r = a.map(vs(e));
    } catch {
      r = a.map(qn(t));
    }
  else
    r = a.map(qn(t));
  const l = r.slice(0, n), o = r.slice(n + 1, r.length);
  return [r[n]].concat(...o).concat(...l);
}, Tn = (e, t, n) => {
  const a = [];
  for (let r = +e[0]; r <= +e[1]; r++)
    a.push({ value: +r, text: Pn(r, t) });
  return n ? a.reverse() : a;
}, xr = (e, t, n) => {
  const a = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((l) => {
    const o = l < 10 ? `0${l}` : l;
    return /* @__PURE__ */ new Date(`2017-${o}-01T00:00:00+00:00`);
  });
  if (e !== null)
    try {
      const l = n === "long" ? "LLLL" : "LLL";
      return a.map((o, v) => {
        const u = Dt(st(o, "UTC"), l, { locale: e });
        return {
          text: u.charAt(0).toUpperCase() + u.substring(1),
          value: v
        };
      });
    } catch {
    }
  const r = new Intl.DateTimeFormat(t, { month: n, timeZone: "UTC" });
  return a.map((l, o) => {
    const v = r.format(l);
    return {
      text: v.charAt(0).toUpperCase() + v.substring(1),
      value: o
    };
  });
}, ms = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], ze = (e) => {
  const t = d(e);
  return t?.$el ? t?.$el : t;
}, ps = (e) => ({ type: "dot", ...e ?? {} }), Tr = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, Dn = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, Xe = (e) => e, zn = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, Un = (e) => e === null, Dr = (e) => {
  if (e)
    return [...e.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, hs = (e) => {
  const t = [], n = (a) => a.filter((r) => r);
  for (let a = 0; a < e.length; a += 3) {
    const r = [e[a], e[a + 1], e[a + 2]];
    t.push(n(r));
  }
  return t;
}, wa = (e, t, n) => {
  const a = n != null, r = t != null;
  if (!a && !r) return !1;
  const l = +n, o = +t;
  return a && r ? +e > l || +e < o : a ? +e > l : r ? +e < o : !1;
}, sa = (e, t) => hs(e).map((n) => n.map((a) => {
  const { active: r, disabled: l, isBetween: o, highlighted: v } = t(a);
  return {
    ...a,
    active: r,
    disabled: l,
    className: {
      dp__overlay_cell_active: r,
      dp__overlay_cell: !r,
      dp__overlay_cell_disabled: l,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: l && r,
      dp__cell_in_between: o,
      "dp--highlighted": v
    }
  };
})), Vt = (e, t, n = !1) => {
  e && t.allowStopPropagation && (n && e.stopImmediatePropagation(), e.stopPropagation());
}, ys = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function gs(e, t) {
  let n = [...document.querySelectorAll(ys())];
  n = n.filter((r) => !e.contains(r) || r.hasAttribute("data-datepicker-instance"));
  const a = n.indexOf(e);
  if (a >= 0 && (t ? a - 1 >= 0 : a + 1 <= n.length))
    return n[a + (t ? -1 : 1)];
}
const dn = (e, t) => e?.querySelector(`[data-dp-element="${t}"]`), Pn = (e, t) => new Intl.NumberFormat(t, { useGrouping: !1, style: "decimal" }).format(e), An = (e, t) => Dt(e, t ?? aa.DATE), ja = (e) => Array.isArray(e), Ya = (e, t, n) => t.get(An(e, n)), ws = (e, t) => e ? t ? t instanceof Map ? !!Ya(e, t) : t(B(e)) : !1 : !0, rt = (e, t, n = !1, a) => {
  if (e.key === Se.enter || e.key === Se.space)
    return n && e.preventDefault(), t();
  if (a) return a(e);
}, bs = () => "ontouchstart" in window || navigator.maxTouchPoints > 0, Pr = (e, t) => e ? aa.MONTH_AND_YEAR : t ? aa.YEAR : aa.DATE, Ar = (e) => e < 10 ? `0${e}` : e, Xn = (e, t, n, a, r, l) => {
  const o = sn(e, t.slice(0, e.length), /* @__PURE__ */ new Date(), { locale: l });
  return pa(o) && lr(o) ? a || r ? o : Re(o, {
    hours: +n.hours,
    minutes: +n?.minutes,
    seconds: +n?.seconds,
    milliseconds: 0
  }) : null;
}, _s = (e, t, n, a, r, l) => {
  const o = Array.isArray(n) ? n[0] : n;
  if (typeof t == "string")
    return Xn(e, t, o, a, r, l);
  if (Array.isArray(t)) {
    let v = null;
    for (const u of t)
      if (v = Xn(e, u, o, a, r, l), v)
        break;
    return v;
  }
  return typeof t == "function" ? t(e) : null;
}, B = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), ks = (e, t, n) => {
  if (t) {
    const r = (e.getMonth() + 1).toString().padStart(2, "0"), l = e.getDate().toString().padStart(2, "0"), o = e.getHours().toString().padStart(2, "0"), v = e.getMinutes().toString().padStart(2, "0"), u = n ? e.getSeconds().toString().padStart(2, "0") : "00";
    return `${e.getFullYear()}-${r}-${l}T${o}:${v}:${u}.000Z`;
  }
  const a = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(a).toISOString();
}, Ue = (e, t) => {
  const n = B(JSON.parse(JSON.stringify(e))), a = Re(n, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
  return t ? fl(a) : a;
}, Ft = (e, t, n, a) => {
  let r = e ? B(e) : B();
  return (t || t === 0) && (r = ls(r, +t)), (n || n === 0) && (r = os(r, +n)), (a || a === 0) && (r = _r(r, +a)), br(r, 0);
}, Fe = (e, t) => !e || !t ? !1 : la(Ue(e), Ue(t)), De = (e, t) => !e || !t ? !1 : ea(Ue(e), Ue(t)), He = (e, t) => !e || !t ? !1 : Xt(Ue(e), Ue(t)), ba = (e, t, n) => e?.[0] && e?.[1] ? He(n, e[0]) && Fe(n, e[1]) : e?.[0] && t ? He(n, e[0]) && Fe(n, t) || Fe(n, e[0]) && He(n, t) : !1, wt = (e) => {
  const t = Re(new Date(e), { date: 1 });
  return Ue(t);
}, Qa = (e, t, n) => t && (n || n === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((a) => a === t ? [a, n] : [a, isNaN(+e[a]) ? void 0 : +e[a]])
) : {
  hours: isNaN(+e.hours) ? void 0 : +e.hours,
  minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
  seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
}, Ut = (e) => ({
  hours: Ct(e),
  minutes: Et(e),
  seconds: ra(e)
}), $r = (e, t) => {
  if (t) {
    const n = ye(B(t));
    if (n > e) return 12;
    if (n === e) return Te(B(t));
  }
}, Or = (e, t) => {
  if (t) {
    const n = ye(B(t));
    return n < e ? -1 : n === e ? Te(B(t)) : void 0;
  }
}, ia = (e) => {
  if (e) return ye(B(e));
}, Cr = (e, t) => {
  const n = He(e, t) ? t : e, a = He(t, e) ? t : e;
  return sr({ start: n, end: a });
}, Ms = (e) => {
  const t = bt(e, 1);
  return { month: Te(t), year: ye(t) };
}, At = (e, t) => {
  const n = _t(e, { weekStartsOn: +t }), a = ur(e, { weekStartsOn: +t });
  return [n, a];
}, Rr = (e, t) => {
  const n = {
    hours: Ct(B()),
    minutes: Et(B()),
    seconds: t ? ra(B()) : 0
  };
  return Object.assign(n, e);
}, Nt = (e, t, n) => [Re(B(e), { date: 1 }), Re(B(), { month: t, year: n, date: 1 })], $t = (e, t, n) => {
  let a = e ? B(e) : B();
  return (t || t === 0) && (a = wr(a, t)), n && (a = gt(a, n)), a;
}, Yr = (e, t, n, a, r) => {
  if (!a || r && !t || !r && !n) return !1;
  const l = r ? bt(e, 1) : oa(e, 1), o = [Te(l), ye(l)];
  return r ? !Ts(...o, t) : !xs(...o, n);
}, xs = (e, t, n) => Fe(...Nt(n, e, t)) || De(...Nt(n, e, t)), Ts = (e, t, n) => He(...Nt(n, e, t)) || De(...Nt(n, e, t)), Sr = (e, t, n, a, r, l, o) => {
  if (typeof t == "function" && !o) return t(e);
  const v = n ? { locale: n } : void 0;
  return Array.isArray(e) ? `${Dt(e[0], l, v)}${r && !e[1] ? "" : a}${e[1] ? Dt(e[1], l, v) : ""}` : Dt(e, l, v);
}, Kt = (e) => {
  if (e) return null;
  throw new Error(Dn.prop("partial-range"));
}, Pa = (e, t) => {
  if (t) return e();
  throw new Error(Dn.prop("range"));
}, cn = (e) => Array.isArray(e) ? pa(e[0]) && (e[1] ? pa(e[1]) : !0) : e ? pa(e) : !1, Ds = (e, t) => Re(t ?? B(), {
  hours: +e.hours || 0,
  minutes: +e.minutes || 0,
  seconds: +e.seconds || 0
}), Ga = (e, t, n, a) => {
  if (!e) return !0;
  if (a) {
    const r = n === "max" ? la(e, t) : Xt(e, t), l = { seconds: 0, milliseconds: 0 };
    return r || ea(Re(e, l), Re(t, l));
  }
  return n === "max" ? e.getTime() <= t.getTime() : e.getTime() >= t.getTime();
}, Ja = (e, t, n) => e ? Ds(e, t) : B(n ?? t), jn = (e, t, n, a, r) => {
  if (Array.isArray(a)) {
    const o = Ja(e, a[0], t), v = Ja(e, a[1], t);
    return Ga(a[0], o, n, !!t) && Ga(a[1], v, n, !!t) && r;
  }
  const l = Ja(e, a, t);
  return Ga(a, l, n, !!t) && r;
}, Ka = (e) => Re(B(), Ut(e)), Ps = (e, t, n) => {
  if (e instanceof Map) {
    const a = `${Ar(n + 1)}-${t}`;
    return e.size ? e.has(a) : !1;
  }
  return typeof e == "function" ? e(Ue(Re(B(), { month: n, year: t }), !0)) : !1;
}, As = (e, t, n) => {
  if (e instanceof Map) {
    const a = `${Ar(n + 1)}-${t}`;
    return e.size ? e.has(a) : !0;
  }
  return !0;
}, Ir = (e, t, n) => typeof e == "function" ? e({ month: t, year: n }) : !!e.months.find((a) => a.month === t && a.year === n), $n = (e, t) => typeof e == "function" ? e(t) : e.years.includes(t), vn = (e) => `dp-${Dt(e, "yyyy-MM-dd")}`, Qn = (e, t) => {
  const n = gr(Ue(t), e), a = ct(Ue(t), e);
  return { before: n, after: a };
}, Nr = (e, t) => t < +e[0] || t > +e[1], ma = _a({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), Vr = () => {
  const e = (n) => {
    ma.menuFocused = n;
  }, t = (n) => {
    ma.shiftKeyInMenu !== n && (ma.shiftKeyInMenu = n);
  };
  return {
    control: W(() => ({ shiftKeyInMenu: ma.shiftKeyInMenu, menuFocused: ma.menuFocused })),
    setMenuFocused: e,
    setShiftKey: t
  };
}, Ye = _a({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), Za = G(null), Aa = G(!1), en = G(!1), tn = G(!1), an = G(!1), Ze = G(0), Be = G(0), Lt = () => {
  const e = W(() => Aa.value ? [...Ye.selectionGrid, Ye.actionRow].filter((p) => p.length) : en.value ? [
    ...Ye.timePicker[0],
    ...Ye.timePicker[1],
    an.value ? [] : [Za.value],
    Ye.actionRow
  ].filter((p) => p.length) : tn.value ? [...Ye.monthPicker, Ye.actionRow] : [Ye.monthYear, ...Ye.calendar, Ye.time, Ye.actionRow].filter((p) => p.length)), t = (p) => {
    Ze.value = p ? Ze.value + 1 : Ze.value - 1;
    let h = null;
    e.value[Be.value] && (h = e.value[Be.value][Ze.value]), !h && e.value[Be.value + (p ? 1 : -1)] ? (Be.value = Be.value + (p ? 1 : -1), Ze.value = p ? 0 : e.value[Be.value].length - 1) : h || (Ze.value = p ? Ze.value - 1 : Ze.value + 1);
  }, n = (p) => {
    Be.value === 0 && !p || Be.value === e.value.length && p || (Be.value = p ? Be.value + 1 : Be.value - 1, e.value[Be.value] ? e.value[Be.value] && !e.value[Be.value][Ze.value] && Ze.value !== 0 && (Ze.value = e.value[Be.value].length - 1) : Be.value = p ? Be.value - 1 : Be.value + 1);
  }, a = (p) => {
    let h = null;
    e.value[Be.value] && (h = e.value[Be.value][Ze.value]), h ? h.focus({ preventScroll: !Aa.value }) : Ze.value = p ? Ze.value - 1 : Ze.value + 1;
  }, r = () => {
    t(!0), a(!0);
  }, l = () => {
    t(!1), a(!1);
  }, o = () => {
    n(!1), a(!0);
  }, v = () => {
    n(!0), a(!0);
  }, u = (p, h) => {
    Ye[h] = p;
  }, x = (p, h) => {
    Ye[h] = p;
  }, f = () => {
    Ze.value = 0, Be.value = 0;
  };
  return {
    buildMatrix: u,
    buildMultiLevelMatrix: x,
    setTimePickerBackRef: (p) => {
      Za.value = p;
    },
    setSelectionGrid: (p) => {
      Aa.value = p, f(), p || (Ye.selectionGrid = []);
    },
    setTimePicker: (p, h = !1) => {
      en.value = p, an.value = h, f(), p || (Ye.timePicker[0] = [], Ye.timePicker[1] = []);
    },
    setTimePickerElements: (p, h = 0) => {
      Ye.timePicker[h] = p;
    },
    arrowRight: r,
    arrowLeft: l,
    arrowUp: o,
    arrowDown: v,
    clearArrowNav: () => {
      Ye.monthYear = [], Ye.calendar = [], Ye.time = [], Ye.actionRow = [], Ye.selectionGrid = [], Ye.timePicker[0] = [], Ye.timePicker[1] = [], Aa.value = !1, en.value = !1, an.value = !1, tn.value = !1, f(), Za.value = null;
    },
    setMonthPicker: (p) => {
      tn.value = p, f();
    },
    refSets: Ye
    // exposed for testing
  };
}, Gn = (e) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...e ?? {}
}), $s = (e) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (t) => `Increment ${t}`,
  decrementValue: (t) => `Decrement ${t}`,
  openTpOverlay: (t) => `Open ${t} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  clearInput: "Clear value",
  calendarIcon: "Calendar icon",
  timePicker: "Time picker",
  monthPicker: (t) => `Month picker${t ? " overlay" : ""}`,
  yearPicker: (t) => `Year picker${t ? " overlay" : ""}`,
  timeOverlay: (t) => `${t} overlay`,
  ...e ?? {}
}), Jn = (e) => e ? typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2 : 0, Os = (e) => {
  const t = typeof e == "object" && e, n = {
    static: !0,
    solo: !1
  };
  if (!e) return { ...n, count: Jn(!1) };
  const a = t ? e : {}, r = t ? a.count ?? !0 : e, l = Jn(r);
  return Object.assign(n, a, { count: l });
}, Cs = (e, t, n) => e || (typeof n == "string" ? n : t), Rs = (e) => typeof e == "boolean" ? e ? Gn({}) : !1 : Gn(e), Ys = (e) => {
  const t = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: "open",
    selectOnFocus: !1,
    rangeSeparator: " - ",
    escClose: !0
  };
  return typeof e == "object" ? { ...t, ...e ?? {}, enabled: !0 } : { ...t, enabled: e };
}, Ss = (e) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...e ?? {}
}), Is = (e) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...e ?? {}
}), Ns = (e) => {
  const t = { input: !1 };
  return typeof e == "object" ? { ...t, ...e ?? {}, enabled: !0 } : {
    enabled: e,
    ...t
  };
}, Vs = (e) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, arrowLeft: void 0, keepViewOnOffsetClick: !1, timeArrowHoldThreshold: 0, shadowDom: !1, mobileBreakpoint: 600, setDateOnMenuClose: !1, ...e ?? {} }), Fs = (e) => {
  const t = {
    dates: Array.isArray(e) ? e.map((n) => B(n)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: [],
    options: { highlightDisabled: !1 }
  };
  return typeof e == "function" ? e : { ...t, ...e ?? {} };
}, Es = (e) => typeof e == "object" ? {
  type: e?.type ?? "local",
  hideOnOffsetDates: e?.hideOnOffsetDates ?? !1
} : {
  type: e,
  hideOnOffsetDates: !1
}, Ls = (e) => {
  const t = {
    noDisabledRange: !1,
    showLastInRange: !0,
    minMaxRawRange: !1,
    partialRange: !0,
    disableTimeRangeValidation: !1,
    maxRange: void 0,
    minRange: void 0,
    autoRange: void 0,
    fixedStart: !1,
    fixedEnd: !1
  };
  return typeof e == "object" ? { enabled: !0, ...t, ...e } : {
    enabled: e,
    ...t
  };
}, Bs = (e) => e ? typeof e == "string" ? {
  timezone: e,
  exactMatch: !1,
  dateInTz: void 0,
  emitTimezone: void 0,
  convertModel: !0
} : {
  timezone: e.timezone,
  exactMatch: e.exactMatch ?? !1,
  dateInTz: e.dateInTz ?? void 0,
  emitTimezone: e.emitTimezone ?? void 0,
  convertModel: e.convertModel ?? !0
} : { timezone: void 0, exactMatch: !1, emitTimezone: void 0 }, nn = (e, t, n, a) => new Map(
  e.map((r) => {
    const l = xn(r, t, a);
    return [An(l, n), l];
  })
), Hs = (e, t) => e.length ? new Map(
  e.map((n) => {
    const a = xn(n.date, t);
    return [An(a, aa.DATE), n];
  })
) : null, Ws = (e) => {
  const t = Pr(e.isMonthPicker, e.isYearPicker);
  return {
    minDate: un(e.minDate, e.timezone, e.isSpecific),
    maxDate: un(e.maxDate, e.timezone, e.isSpecific),
    disabledDates: ja(e.disabledDates) ? nn(e.disabledDates, e.timezone, t, e.isSpecific) : e.disabledDates,
    allowedDates: ja(e.allowedDates) ? nn(e.allowedDates, e.timezone, t, e.isSpecific) : null,
    highlight: typeof e.highlight == "object" && ja(e.highlight?.dates) ? nn(e.highlight.dates, e.timezone, t) : e.highlight,
    markers: Hs(e.markers, e.timezone)
  };
}, qs = (e) => typeof e == "boolean" ? { enabled: e, dragSelect: !0, limit: null } : {
  enabled: !!e,
  limit: e.limit ? +e.limit : null,
  dragSelect: e.dragSelect ?? !0
}, zs = (e) => ({
  ...Object.fromEntries(
    Object.keys(e).map((t) => {
      const n = t, a = e[n], r = typeof e[n] == "string" ? { [a]: !0 } : Object.fromEntries(a.map((l) => [l, !0]));
      return [t, r];
    })
  )
}), Ne = (e) => {
  const t = () => {
    const S = e.enableSeconds ? ":ss" : "", N = e.enableMinutes ? ":mm" : "";
    return e.is24 ? `HH${N}${S}` : `hh${N}${S} aa`;
  }, n = () => e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? t() : e.weekPicker ? `${P.value?.type === "iso" ? "II" : "ww"}-RR` : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${t()}` : "MM/dd/yyyy", a = (S) => Rr(S, e.enableSeconds), r = () => E.value.enabled ? e.startTime && Array.isArray(e.startTime) ? [a(e.startTime[0]), a(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? a(e.startTime) : null, l = W(() => Os(e.multiCalendars)), o = W(() => r()), v = W(() => $s(e.ariaLabels)), u = W(() => Ss(e.filters)), x = W(() => Rs(e.transitions)), f = W(() => Is(e.actionRow)), p = W(
    () => Cs(e.previewFormat, e.format, n())
  ), h = W(() => Ys(e.textInput)), _ = W(() => Ns(e.inline)), C = W(() => Vs(e.config)), Y = W(() => Fs(e.highlight)), P = W(() => Es(e.weekNumbers)), O = W(() => Bs(e.timezone)), R = W(() => qs(e.multiDates)), k = W(
    () => Ws({
      minDate: e.minDate,
      maxDate: e.maxDate,
      disabledDates: e.disabledDates,
      allowedDates: e.allowedDates,
      highlight: Y.value,
      markers: e.markers,
      timezone: O.value,
      isSpecific: e.monthPicker || e.yearPicker || e.quarterPicker,
      isMonthPicker: e.monthPicker,
      isYearPicker: e.yearPicker
    })
  ), E = W(() => Ls(e.range)), X = W(() => zs(e.ui));
  return {
    defaultedTransitions: x,
    defaultedMultiCalendars: l,
    defaultedStartTime: o,
    defaultedAriaLabels: v,
    defaultedFilters: u,
    defaultedActionRow: f,
    defaultedPreviewFormat: p,
    defaultedTextInput: h,
    defaultedInline: _,
    defaultedConfig: C,
    defaultedHighlight: Y,
    defaultedWeekNumbers: P,
    defaultedRange: E,
    propDates: k,
    defaultedTz: O,
    defaultedMultiDates: R,
    defaultedUI: X,
    getDefaultPattern: n,
    getDefaultStartTime: r,
    handleEventPropagation: (S) => {
      C.value.allowStopPropagation && S.stopPropagation(), C.value.allowPreventDefault && S.preventDefault();
    }
  };
}, Us = (e, t, { isInputFocused: n, isTextInputDate: a }) => {
  const r = G(), { defaultedTextInput: l, defaultedRange: o, defaultedTz: v, defaultedMultiDates: u, getDefaultPattern: x } = Ne(t), f = G(""), p = ya(t, "format"), h = ya(t, "formatLocale");
  ft(
    r,
    () => {
      typeof t.onInternalModelChange == "function" && e("internal-model-change", r.value, c(!0));
    },
    { deep: !0 }
  ), ft(o, (i, U) => {
    i.enabled !== U.enabled && (r.value = null);
  }), ft(p, () => {
    V();
  });
  const _ = (i) => v.value.timezone && v.value.convertModel ? st(i, v.value.timezone) : i, C = (i) => {
    if (v.value.timezone && v.value.convertModel) {
      const U = ds(v.value.timezone, i);
      return ol(i, U);
    }
    return i;
  }, Y = (i, U, Pe = !1) => Sr(
    i,
    t.format,
    t.formatLocale,
    l.value.rangeSeparator,
    t.modelAuto,
    U ?? x(),
    Pe
  ), P = (i) => i ? t.modelType ? T(i) : {
    hours: Ct(i),
    minutes: Et(i),
    seconds: t.enableSeconds ? ra(i) : 0
  } : null, O = (i) => t.modelType ? T(i) : { month: Te(i), year: ye(i) }, R = (i) => Array.isArray(i) ? u.value.enabled ? i.map((U) => k(U, gt(B(), U))) : Pa(
    () => [
      gt(B(), i[0]),
      i[1] ? gt(B(), i[1]) : Kt(o.value.partialRange)
    ],
    o.value.enabled
  ) : gt(B(), +i), k = (i, U) => (typeof i == "string" || typeof i == "number") && t.modelType ? K(i) : U, E = (i) => Array.isArray(i) ? [
    k(
      i[0],
      Ft(null, +i[0].hours, +i[0].minutes, i[0].seconds)
    ),
    k(
      i[1],
      Ft(null, +i[1].hours, +i[1].minutes, i[1].seconds)
    )
  ] : k(i, Ft(null, i.hours, i.minutes, i.seconds)), X = (i) => {
    const U = Re(B(), { date: 1 });
    return Array.isArray(i) ? u.value.enabled ? i.map((Pe) => k(Pe, $t(U, +Pe.month, +Pe.year))) : Pa(
      () => [
        k(i[0], $t(U, +i[0].month, +i[0].year)),
        k(
          i[1],
          i[1] ? $t(U, +i[1].month, +i[1].year) : Kt(o.value.partialRange)
        )
      ],
      o.value.enabled
    ) : k(i, $t(U, +i.month, +i.year));
  }, S = (i) => {
    if (Array.isArray(i))
      return i.map((U) => K(U));
    throw new Error(Dn.dateArr("multi-dates"));
  }, N = (i) => {
    if (Array.isArray(i) && o.value.enabled) {
      const U = i[0], Pe = i[1];
      return [
        B(Array.isArray(U) ? U[0] : null),
        Array.isArray(Pe) && Pe.length ? B(Pe[0]) : null
      ];
    }
    return B(i[0]);
  }, ae = (i) => t.modelAuto ? Array.isArray(i) ? [K(i[0]), K(i[1])] : t.autoApply ? [K(i)] : [K(i), null] : Array.isArray(i) ? Pa(
    () => i[1] ? [
      K(i[0]),
      i[1] ? K(i[1]) : Kt(o.value.partialRange)
    ] : [K(i[0])],
    o.value.enabled
  ) : K(i), q = () => {
    Array.isArray(r.value) && o.value.enabled && r.value.length === 1 && r.value.push(Kt(o.value.partialRange));
  }, F = () => {
    const i = r.value;
    return [
      T(i[0]),
      i[1] ? T(i[1]) : Kt(o.value.partialRange)
    ];
  }, ne = () => Array.isArray(r.value) ? r.value[1] ? F() : T(Xe(r.value[0])) : [], ue = () => (r.value || []).map((i) => T(i)), he = (i = !1) => (i || q(), t.modelAuto ? ne() : u.value.enabled ? ue() : Array.isArray(r.value) ? Pa(() => F(), o.value.enabled) : T(Xe(r.value))), y = (i) => !i || Array.isArray(i) && !i.length ? null : t.timePicker ? E(Xe(i)) : t.monthPicker ? X(Xe(i)) : t.yearPicker ? R(Xe(i)) : u.value.enabled ? S(Xe(i)) : t.weekPicker ? N(Xe(i)) : ae(Xe(i)), b = (i) => {
    if (a.value) return;
    const U = y(i);
    cn(Xe(U)) ? (r.value = Xe(U), V()) : (r.value = null, f.value = "");
  }, g = () => {
    const i = (U) => Dt(U, l.value.format);
    return `${i(r.value[0])} ${l.value.rangeSeparator} ${r.value[1] ? i(r.value[1]) : ""}`;
  }, L = () => n.value && r.value ? Array.isArray(r.value) ? g() : Dt(r.value, l.value.format) : Y(r.value), ee = () => r.value ? u.value.enabled ? r.value.map((i) => Y(i)).join("; ") : l.value.enabled && typeof l.value.format == "string" ? L() : Y(r.value) : "", V = () => {
    !t.format || typeof t.format == "string" || l.value.enabled && typeof l.value.format == "string" ? f.value = ee() : f.value = t.format(r.value);
  }, K = (i) => {
    if (t.utc) {
      const U = new Date(i);
      return t.utc === "preserve" ? new Date(U.getTime() + U.getTimezoneOffset() * 6e4) : U;
    }
    return t.modelType ? cs.includes(t.modelType) ? _(new Date(i)) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? _(
      sn(i, x(), /* @__PURE__ */ new Date(), { locale: h.value })
    ) : _(
      sn(i, t.modelType, /* @__PURE__ */ new Date(), { locale: h.value })
    ) : _(new Date(i));
  }, T = (i) => i ? t.utc ? ks(i, t.utc === "preserve", t.enableSeconds) : t.modelType ? t.modelType === "timestamp" ? +C(i) : t.modelType === "iso" ? C(i).toISOString() : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? Y(C(i)) : Y(C(i), t.modelType, !0) : C(i) : "", ie = (i, U = !1, Pe = !1) => {
    if (Pe) return i;
    if (e("update:model-value", i), v.value.emitTimezone && U) {
      const j = Array.isArray(i) ? i.map((we) => st(Xe(we), v.value.emitTimezone)) : st(Xe(i), v.value.emitTimezone);
      e("update:model-timezone-value", j);
    }
  }, m = (i) => Array.isArray(r.value) ? u.value.enabled ? r.value.map((U) => i(U)) : [
    i(r.value[0]),
    r.value[1] ? i(r.value[1]) : Kt(o.value.partialRange)
  ] : i(Xe(r.value)), I = () => {
    if (Array.isArray(r.value)) {
      const i = At(r.value[0], t.weekStart), U = r.value[1] ? At(r.value[1], t.weekStart) : [];
      return [i.map((Pe) => B(Pe)), U.map((Pe) => B(Pe))];
    }
    return At(r.value, t.weekStart).map((i) => B(i));
  }, M = (i, U) => ie(Xe(m(i)), !1, U), re = (i) => {
    const U = I();
    return i ? U : e("update:model-value", I());
  }, c = (i = !1) => (i || V(), t.monthPicker ? M(O, i) : t.timePicker ? M(P, i) : t.yearPicker ? M(ye, i) : t.weekPicker ? re(i) : ie(he(i), !0, i));
  return {
    inputValue: f,
    internalModelValue: r,
    checkBeforeEmit: () => r.value ? o.value.enabled ? o.value.partialRange ? r.value.length >= 1 : r.value.length === 2 : !!r.value : !1,
    parseExternalModelValue: b,
    formatInputValue: V,
    emitModelValue: c
  };
}, Xs = (e, t) => {
  const { defaultedFilters: n, propDates: a } = Ne(e), { validateMonthYearInRange: r } = Bt(e), l = (f, p) => {
    let h = f;
    return n.value.months.includes(Te(h)) ? (h = p ? bt(f, 1) : oa(f, 1), l(h, p)) : h;
  }, o = (f, p) => {
    let h = f;
    return n.value.years.includes(ye(h)) ? (h = p ? fn(f, 1) : kr(f, 1), o(h, p)) : h;
  }, v = (f, p = !1) => {
    const h = Re(B(), { month: e.month, year: e.year });
    let _ = f ? bt(h, 1) : oa(h, 1);
    e.disableYearSelect && (_ = gt(_, e.year));
    let C = Te(_), Y = ye(_);
    n.value.months.includes(C) && (_ = l(_, f), C = Te(_), Y = ye(_)), n.value.years.includes(Y) && (_ = o(_, f), Y = ye(_)), r(C, Y, f, e.preventMinMaxNavigation) && u(C, Y, p);
  }, u = (f, p, h) => {
    t("update-month-year", { month: f, year: p, fromNav: h });
  }, x = W(() => (f) => Yr(
    Re(B(), { month: e.month, year: e.year }),
    a.value.maxDate,
    a.value.minDate,
    e.preventMinMaxNavigation,
    f
  ));
  return { handleMonthYearChange: v, isDisabled: x, updateMonthYear: u };
}, Ia = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: [Boolean, String], default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: [String, Object], default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  dayClass: {
    type: Function,
    default: null
  },
  yearRange: { type: Array, default: () => [1900, 2100] },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  highlight: {
    type: [Function, Object],
    default: null
  },
  teleport: { type: [Boolean, String, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: [Object, Boolean], default: !1 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  alwaysClearable: { type: Boolean, default: !1 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: [Boolean, Object], default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 },
  loading: { type: Boolean, default: !1 },
  onInternalModelChange: { type: [Function, Object], default: null },
  enableMinutes: { type: Boolean, default: !0 },
  ui: { type: Object, default: () => ({}) }
}, kt = {
  ...Ia,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  noOverlayFocus: { type: Boolean, default: !1 },
  collapse: { type: Boolean, default: !1 },
  menuWrapRef: { type: Object, default: null },
  getInputRect: { type: Function, default: () => ({}) },
  isTextInputDate: { type: Boolean, default: !1 },
  isMobile: { type: Boolean, default: void 0 }
}, js = ["title"], Qs = ["disabled"], Gs = /* @__PURE__ */ Ge({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...kt
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(e, { emit: t }) {
    const n = t, a = e, {
      defaultedActionRow: r,
      defaultedPreviewFormat: l,
      defaultedMultiCalendars: o,
      defaultedTextInput: v,
      defaultedInline: u,
      defaultedRange: x,
      defaultedMultiDates: f
    } = Ne(a), { isTimeValid: p, isMonthValid: h } = Bt(a), { buildMatrix: _ } = Lt(), C = G(null), Y = G(null), P = G(!1), O = G({}), R = G(null), k = G(null);
    Je(() => {
      a.arrowNavigation && _([ze(C), ze(Y)], "actionRow"), E(), window.addEventListener("resize", E);
    }), ua(() => {
      window.removeEventListener("resize", E);
    });
    const E = () => {
      P.value = !1, setTimeout(() => {
        const y = R.value?.getBoundingClientRect(), b = k.value?.getBoundingClientRect();
        y && b && (O.value.maxWidth = `${b.width - y.width - 20}px`), P.value = !0;
      }, 0);
    }, X = W(() => x.value.enabled && !x.value.partialRange && a.internalModelValue ? a.internalModelValue.length === 2 : !0), S = W(
      () => !p.value(a.internalModelValue) || !h.value(a.internalModelValue) || !X.value
    ), N = () => {
      const y = l.value;
      return a.timePicker || a.monthPicker, y(Xe(a.internalModelValue));
    }, ae = () => {
      const y = a.internalModelValue;
      return o.value.count > 0 ? `${q(y[0])} - ${q(y[1])}` : [q(y[0]), q(y[1])];
    }, q = (y) => Sr(
      y,
      l.value,
      a.formatLocale,
      v.value.rangeSeparator,
      a.modelAuto,
      l.value
    ), F = W(() => !a.internalModelValue || !a.menuMount ? "" : typeof l.value == "string" ? Array.isArray(a.internalModelValue) ? a.internalModelValue.length === 2 && a.internalModelValue[1] ? ae() : f.value.enabled ? a.internalModelValue.map((y) => `${q(y)}`) : a.modelAuto ? `${q(a.internalModelValue[0])}` : `${q(a.internalModelValue[0])} -` : q(a.internalModelValue) : N()), ne = () => f.value.enabled ? "; " : " - ", ue = W(
      () => Array.isArray(F.value) ? F.value.join(ne()) : F.value
    ), he = () => {
      p.value(a.internalModelValue) && h.value(a.internalModelValue) && X.value ? n("select-date") : n("invalid-select");
    };
    return (y, b) => (D(), H("div", {
      ref_key: "actionRowRef",
      ref: k,
      class: "dp__action_row"
    }, [
      y.$slots["action-row"] ? se(y.$slots, "action-row", Qe(je({ key: 0 }, {
        internalModelValue: y.internalModelValue,
        disabled: S.value,
        selectDate: () => y.$emit("select-date"),
        closePicker: () => y.$emit("close-picker")
      }))) : (D(), H(be, { key: 1 }, [
        d(r).showPreview ? (D(), H("div", {
          key: 0,
          class: "dp__selection_preview",
          title: ue.value,
          style: vt(O.value)
        }, [
          y.$slots["action-preview"] && P.value ? se(y.$slots, "action-preview", {
            key: 0,
            value: y.internalModelValue
          }) : z("", !0),
          !y.$slots["action-preview"] && P.value ? (D(), H(be, { key: 1 }, [
            Ot(tt(ue.value), 1)
          ], 64)) : z("", !0)
        ], 12, js)) : z("", !0),
        ge("div", {
          ref_key: "actionBtnContainer",
          ref: R,
          class: "dp__action_buttons",
          "data-dp-element": "action-row"
        }, [
          y.$slots["action-buttons"] ? se(y.$slots, "action-buttons", {
            key: 0,
            value: y.internalModelValue
          }) : z("", !0),
          y.$slots["action-buttons"] ? z("", !0) : (D(), H(be, { key: 1 }, [
            !d(u).enabled && d(r).showCancel ? (D(), H("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: C,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: b[0] || (b[0] = (g) => y.$emit("close-picker")),
              onKeydown: b[1] || (b[1] = (g) => d(rt)(g, () => y.$emit("close-picker")))
            }, tt(y.cancelText), 545)) : z("", !0),
            d(r).showNow ? (D(), H("button", {
              key: 1,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: b[2] || (b[2] = (g) => y.$emit("select-now")),
              onKeydown: b[3] || (b[3] = (g) => d(rt)(g, () => y.$emit("select-now")))
            }, tt(y.nowButtonLabel), 33)) : z("", !0),
            d(r).showSelect ? (D(), H("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: Y,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: S.value,
              "data-test-id": "select-button",
              onKeydown: b[4] || (b[4] = (g) => d(rt)(g, () => he())),
              onClick: he
            }, tt(y.selectText), 41, Qs)) : z("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), Js = ["role", "aria-label", "tabindex"], Ks = { class: "dp__selection_grid_header" }, Zs = ["aria-selected", "aria-disabled", "data-test-id", "onClick", "onKeydown", "onMouseover"], ei = ["aria-label"], Ma = /* @__PURE__ */ Ge({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {},
    menuWrapRef: {},
    ariaLabels: {},
    overlayLabel: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { expose: t, emit: n }) {
    const { setSelectionGrid: a, buildMultiLevelMatrix: r, setMonthPicker: l } = Lt(), o = n, v = e, { defaultedAriaLabels: u, defaultedTextInput: x, defaultedConfig: f, handleEventPropagation: p } = Ne(
      v
    ), { hideNavigationButtons: h } = Fa(), _ = G(!1), C = G(null), Y = G(null), P = G([]), O = G(), R = G(null), k = G(0), E = G(null);
    el(() => {
      C.value = null;
    }), Je(() => {
      dt().then(() => ue()), v.noOverlayFocus || S(), X(!0);
    }), ua(() => X(!1));
    const X = (m) => {
      v.arrowNavigation && (v.headerRefs?.length ? l(m) : a(m));
    }, S = () => {
      const m = ze(Y);
      m && (x.value.enabled || (C.value ? C.value?.focus({ preventScroll: !0 }) : m.focus({ preventScroll: !0 })), _.value = m.clientHeight < m.scrollHeight);
    }, N = W(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !v.useRelative,
        "dp--overlay-relative": v.useRelative
      })
    ), ae = W(
      () => v.useRelative ? { height: `${v.height}px`, width: "var(--dp-menu-min-width)" } : void 0
    ), q = W(() => ({
      dp__overlay_col: !0
    })), F = W(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: _.value,
        dp__button_bottom: v.isLast
      })
    ), ne = W(() => ({
      dp__overlay_container: !0,
      dp__container_flex: v.items?.length <= 6,
      dp__container_block: v.items?.length > 6
    }));
    ft(
      () => v.items,
      () => ue(!1),
      { deep: !0 }
    );
    const ue = (m = !0) => {
      dt().then(() => {
        const I = ze(C), M = ze(Y), re = ze(R), c = ze(E), i = re ? re.getBoundingClientRect().height : 0;
        M && (M.getBoundingClientRect().height ? k.value = M.getBoundingClientRect().height - i : k.value = f.value.modeHeight - i), I && c && m && (c.scrollTop = I.offsetTop - c.offsetTop - (k.value / 2 - I.getBoundingClientRect().height) - i);
      });
    }, he = (m) => {
      m.disabled || o("selected", m.value);
    }, y = () => {
      o("toggle"), o("reset-flow");
    }, b = (m) => {
      v.escClose && (y(), p(m));
    }, g = (m, I, M, re) => {
      m && ((I.active || I.value === v.focusValue) && (C.value = m), v.arrowNavigation && (Array.isArray(P.value[M]) ? P.value[M][re] = m : P.value[M] = [m], L()));
    }, L = () => {
      const m = v.headerRefs?.length ? [v.headerRefs].concat(P.value) : P.value.concat([v.skipButtonRef ? [] : [R.value]]);
      r(Xe(m), v.headerRefs?.length ? "monthPicker" : "selectionGrid");
    }, ee = (m) => {
      v.arrowNavigation || Vt(m, f.value, !0);
    }, V = (m) => {
      O.value = m, o("hover-value", m);
    }, K = () => {
      if (y(), !v.isLast) {
        const m = dn(v.menuWrapRef ?? null, "action-row");
        m && Dr(m)?.focus();
      }
    }, T = (m) => {
      switch (m.key) {
        case Se.esc:
          return b(m);
        case Se.arrowLeft:
          return ee(m);
        case Se.arrowRight:
          return ee(m);
        case Se.arrowUp:
          return ee(m);
        case Se.arrowDown:
          return ee(m);
        default:
          return;
      }
    }, ie = (m) => {
      if (m.key === Se.enter) return y();
      if (m.key === Se.tab) return K();
    };
    return t({ focusGrid: S }), (m, I) => (D(), H("div", {
      ref_key: "gridWrapRef",
      ref: Y,
      class: ke(N.value),
      style: vt(ae.value),
      role: e.useRelative ? void 0 : "dialog",
      "aria-label": e.overlayLabel,
      tabindex: e.useRelative ? void 0 : "0",
      onKeydown: T,
      onClick: I[0] || (I[0] = ga(() => {
      }, ["prevent"]))
    }, [
      ge("div", {
        ref_key: "containerRef",
        ref: E,
        class: ke(ne.value),
        style: vt({ "--dp-overlay-height": `${k.value}px` }),
        role: "grid"
      }, [
        ge("div", Ks, [
          se(m.$slots, "header")
        ]),
        m.$slots.overlay ? se(m.$slots, "overlay", { key: 0 }) : (D(!0), H(be, { key: 1 }, Ie(e.items, (M, re) => (D(), H("div", {
          key: re,
          class: ke(["dp__overlay_row", { dp__flex_row: e.items.length >= 3 }]),
          role: "row"
        }, [
          (D(!0), H(be, null, Ie(M, (c, i) => (D(), H("div", {
            key: c.value,
            ref_for: !0,
            ref: (U) => g(U, c, re, i),
            role: "gridcell",
            class: ke(q.value),
            "aria-selected": c.active || void 0,
            "aria-disabled": c.disabled || void 0,
            tabindex: "0",
            "data-test-id": c.text,
            onClick: ga((U) => he(c), ["prevent"]),
            onKeydown: (U) => d(rt)(U, () => he(c), !0),
            onMouseover: (U) => V(c.value)
          }, [
            ge("div", {
              class: ke(c.className)
            }, [
              m.$slots.item ? se(m.$slots, "item", {
                key: 0,
                item: c
              }) : z("", !0),
              m.$slots.item ? z("", !0) : (D(), H(be, { key: 1 }, [
                Ot(tt(c.text), 1)
              ], 64))
            ], 2)
          ], 42, Zs))), 128))
        ], 2))), 128))
      ], 6),
      m.$slots["button-icon"] ? $a((D(), H("button", {
        key: 0,
        ref_key: "toggleButton",
        ref: R,
        type: "button",
        "aria-label": d(u)?.toggleOverlay,
        class: ke(F.value),
        tabindex: "0",
        onClick: y,
        onKeydown: ie
      }, [
        se(m.$slots, "button-icon")
      ], 42, ei)), [
        [Oa, !d(h)(e.hideNavigation, e.type)]
      ]) : z("", !0)
    ], 46, Js));
  }
}), ti = ["data-dp-mobile"], Na = /* @__PURE__ */ Ge({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean },
    collapse: { type: Boolean },
    isMobile: { type: Boolean }
  },
  setup(e) {
    const t = e, n = W(
      () => t.multiCalendars > 0 ? [...Array(t.multiCalendars).keys()] : [0]
    ), a = W(() => ({
      dp__instance_calendar: t.multiCalendars > 0
    }));
    return (r, l) => (D(), H("div", {
      class: ke({
        dp__menu_inner: !e.stretch,
        "dp--menu--inner-stretched": e.stretch,
        dp__flex_display: e.multiCalendars > 0,
        "dp--flex-display-collapsed": e.collapse
      }),
      "data-dp-mobile": e.isMobile
    }, [
      (D(!0), H(be, null, Ie(n.value, (o, v) => (D(), H("div", {
        key: o,
        class: ke(a.value)
      }, [
        se(r.$slots, "default", {
          instance: o,
          index: v
        })
      ], 2))), 128))
    ], 10, ti));
  }
}), ai = ["data-dp-element", "aria-label", "aria-disabled"], ha = /* @__PURE__ */ Ge({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    elName: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: t }) {
    const n = t, a = G(null);
    return Je(() => n("set-ref", a)), (r, l) => (D(), H("button", {
      ref_key: "elRef",
      ref: a,
      type: "button",
      "data-dp-element": e.elName,
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": e.ariaLabel,
      "aria-disabled": e.disabled || void 0,
      onClick: l[0] || (l[0] = (o) => n("activate")),
      onKeydown: l[1] || (l[1] = (o) => d(rt)(o, () => n("activate"), !0))
    }, [
      ge("span", {
        class: ke(["dp__inner_nav", { dp__inner_nav_disabled: e.disabled }])
      }, [
        se(r.$slots, "default")
      ], 2)
    ], 40, ai));
  }
}), ni = ["aria-label", "data-test-id"], Fr = /* @__PURE__ */ Ge({
  __name: "YearModePicker",
  props: {
    ...kt,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(e, { emit: t }) {
    const n = t, a = e, { showRightIcon: r, showLeftIcon: l } = Fa(), { defaultedConfig: o, defaultedMultiCalendars: v, defaultedAriaLabels: u, defaultedTransitions: x, defaultedUI: f } = Ne(a), { showTransition: p, transitionName: h } = xa(x), _ = G(!1), C = W(() => Pn(a.year, a.locale)), Y = (R = !1, k) => {
      _.value = !_.value, n("toggle-year-picker", { flow: R, show: k });
    }, P = (R) => {
      _.value = !1, n("year-select", R);
    }, O = (R = !1) => {
      n("handle-year", R);
    };
    return (R, k) => (D(), H(be, null, [
      ge("div", {
        class: ke(["dp--year-mode-picker", { "dp--hidden-el": _.value }])
      }, [
        d(l)(d(v), e.instance) ? (D(), Ae(ha, {
          key: 0,
          ref: "mpPrevIconRef",
          "aria-label": d(u)?.prevYear,
          disabled: e.isDisabled(!1),
          class: ke(d(f)?.navBtnPrev),
          onActivate: k[0] || (k[0] = (E) => O(!1))
        }, {
          default: _e(() => [
            R.$slots["arrow-left"] ? se(R.$slots, "arrow-left", { key: 0 }) : z("", !0),
            R.$slots["arrow-left"] ? z("", !0) : (D(), Ae(d(wn), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled", "class"])) : z("", !0),
        ge("button", {
          ref: "mpYearButtonRef",
          class: "dp__btn dp--year-select",
          type: "button",
          "aria-label": `${e.year}-${d(u)?.openYearsOverlay}`,
          "data-test-id": `year-mode-btn-${e.instance}`,
          onClick: k[1] || (k[1] = () => Y(!1)),
          onKeydown: k[2] || (k[2] = tl(() => Y(!1), ["enter"]))
        }, [
          R.$slots.year ? se(R.$slots, "year", {
            key: 0,
            year: e.year,
            text: C.value,
            value: e.year
          }) : z("", !0),
          R.$slots.year ? z("", !0) : (D(), H(be, { key: 1 }, [
            Ot(tt(C.value), 1)
          ], 64))
        ], 40, ni),
        d(r)(d(v), e.instance) ? (D(), Ae(ha, {
          key: 1,
          ref: "mpNextIconRef",
          "aria-label": d(u)?.nextYear,
          disabled: e.isDisabled(!0),
          class: ke(d(f)?.navBtnNext),
          onActivate: k[3] || (k[3] = (E) => O(!0))
        }, {
          default: _e(() => [
            R.$slots["arrow-right"] ? se(R.$slots, "arrow-right", { key: 0 }) : z("", !0),
            R.$slots["arrow-right"] ? z("", !0) : (D(), Ae(d(bn), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled", "class"])) : z("", !0)
      ], 2),
      ut(da, {
        name: d(h)(e.showYearPicker),
        css: d(p)
      }, {
        default: _e(() => [
          e.showYearPicker ? (D(), Ae(Ma, {
            key: 0,
            items: e.items,
            "text-input": R.textInput,
            "esc-close": R.escClose,
            config: R.config,
            "is-last": R.autoApply && !d(o).keepActionRow,
            "hide-navigation": R.hideNavigation,
            "aria-labels": R.ariaLabels,
            "overlay-label": d(u)?.yearPicker?.(!0),
            type: "year",
            onToggle: Y,
            onSelected: k[4] || (k[4] = (E) => P(E))
          }, at({
            "button-icon": _e(() => [
              R.$slots["calendar-icon"] ? se(R.$slots, "calendar-icon", { key: 0 }) : z("", !0),
              R.$slots["calendar-icon"] ? z("", !0) : (D(), Ae(d(ca), { key: 1 }))
            ]),
            _: 2
          }, [
            R.$slots["year-overlay-value"] ? {
              name: "item",
              fn: _e(({ item: E }) => [
                se(R.$slots, "year-overlay-value", {
                  text: E.text,
                  value: E.value
                })
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation", "aria-labels", "overlay-label"])) : z("", !0)
        ]),
        _: 3
      }, 8, ["name", "css"])
    ], 64));
  }
}), On = (e, t, n) => {
  if (t.value && Array.isArray(t.value))
    if (t.value.some((a) => De(e, a))) {
      const a = t.value.filter((r) => !De(r, e));
      t.value = a.length ? a : null;
    } else (n && +n > t.value.length || !n) && t.value.push(e);
  else
    t.value = [e];
}, Cn = (e, t, n) => {
  let a = e.value ? e.value.slice() : [];
  return a.length === 2 && a[1] !== null && (a = []), a.length ? (Fe(t, a[0]) ? a.unshift(t) : a[1] = t, n("range-end", t)) : (a = [t], n("range-start", t)), a;
}, Va = (e, t, n, a) => {
  e && (e[0] && e[1] && n && t("auto-apply"), e[0] && !e[1] && a && n && t("auto-apply"));
}, Er = (e) => {
  Array.isArray(e.value) && e.value.length <= 2 && e.range ? e.modelValue.value = e.value.map((t) => st(B(t), e.timezone)) : Array.isArray(e.value) || (e.modelValue.value = st(B(e.value), e.timezone));
}, Lr = (e, t, n, a) => Array.isArray(t.value) && (t.value.length === 2 || t.value.length === 1 && a.value.partialRange) ? a.value.fixedStart && (He(e, t.value[0]) || De(e, t.value[0])) ? [t.value[0], e] : a.value.fixedEnd && (Fe(e, t.value[1]) || De(e, t.value[1])) ? [e, t.value[1]] : (n("invalid-fixed-range", e), t.value) : [], Br = ({
  multiCalendars: e,
  range: t,
  highlight: n,
  propDates: a,
  calendars: r,
  modelValue: l,
  props: o,
  filters: v,
  year: u,
  month: x,
  emit: f
}) => {
  const p = W(() => Tn(o.yearRange, o.locale, o.reverseYears)), h = G([!1]), _ = W(() => (F, ne) => {
    const ue = Re(wt(/* @__PURE__ */ new Date()), {
      month: x.value(F),
      year: u.value(F)
    }), he = ne ? ir(ue) : ta(ue);
    return Yr(
      he,
      a.value.maxDate,
      a.value.minDate,
      o.preventMinMaxNavigation,
      ne
    );
  }), C = () => Array.isArray(l.value) && e.value.solo && l.value[1], Y = () => {
    for (let F = 0; F < e.value.count; F++)
      if (F === 0)
        r.value[F] = r.value[0];
      else if (F === e.value.count - 1 && C())
        r.value[F] = {
          month: Te(l.value[1]),
          year: ye(l.value[1])
        };
      else {
        const ne = Re(B(), r.value[F - 1]);
        r.value[F] = { month: Te(ne), year: ye(fn(ne, 1)) };
      }
  }, P = (F) => {
    if (!F) return Y();
    const ne = Re(B(), r.value[F]);
    return r.value[0].year = ye(kr(ne, e.value.count - 1)), Y();
  }, O = (F, ne) => {
    const ue = cl(ne, F);
    return t.value.showLastInRange && ue > 1 ? ne : F;
  }, R = (F) => o.focusStartDate || e.value.solo ? F[0] : F[1] ? O(F[0], F[1]) : F[0], k = () => {
    if (l.value) {
      const F = Array.isArray(l.value) ? R(l.value) : l.value;
      r.value[0] = { month: Te(F), year: ye(F) };
    }
  }, E = () => {
    k(), e.value.count && Y();
  };
  ft(l, (F, ne) => {
    o.isTextInputDate && JSON.stringify(F ?? {}) !== JSON.stringify(ne ?? {}) && E();
  }), Je(() => {
    E();
  });
  const X = (F, ne) => {
    r.value[ne].year = F, f("update-month-year", { instance: ne, year: F, month: r.value[ne].month }), e.value.count && !e.value.solo && P(ne);
  }, S = W(() => (F) => sa(p.value, (ne) => {
    const ue = u.value(F) === ne.value, he = wa(
      ne.value,
      ia(a.value.minDate),
      ia(a.value.maxDate)
    ) || v.value.years?.includes(u.value(F)), y = $n(n.value, ne.value);
    return { active: ue, disabled: he, highlighted: y };
  })), N = (F, ne) => {
    X(F, ne), q(ne);
  }, ae = (F, ne = !1) => {
    if (!_.value(F, ne)) {
      const ue = ne ? u.value(F) + 1 : u.value(F) - 1;
      X(ue, F);
    }
  }, q = (F, ne = !1, ue) => {
    ne || f("reset-flow"), ue !== void 0 ? h.value[F] = ue : h.value[F] = !h.value[F], h.value[F] ? f("overlay-toggle", { open: !0, overlay: et.year }) : (f("overlay-closed"), f("overlay-toggle", { open: !1, overlay: et.year }));
  };
  return {
    isDisabled: _,
    groupedYears: S,
    showYearPicker: h,
    selectYear: X,
    toggleYearPicker: q,
    handleYearSelect: N,
    handleYear: ae
  };
}, ri = (e, t) => {
  const {
    defaultedMultiCalendars: n,
    defaultedAriaLabels: a,
    defaultedTransitions: r,
    defaultedConfig: l,
    defaultedRange: o,
    defaultedHighlight: v,
    propDates: u,
    defaultedTz: x,
    defaultedFilters: f,
    defaultedMultiDates: p
  } = Ne(e), h = () => {
    e.isTextInputDate && E(ye(B(e.startDate)), 0);
  }, { modelValue: _, year: C, month: Y, calendars: P } = Ta(e, t, h), O = W(() => xr(e.formatLocale, e.locale, e.monthNameFormat)), R = G(null), { checkMinMaxRange: k } = Bt(e), {
    selectYear: E,
    groupedYears: X,
    showYearPicker: S,
    toggleYearPicker: N,
    handleYearSelect: ae,
    handleYear: q,
    isDisabled: F
  } = Br({
    modelValue: _,
    multiCalendars: n,
    range: o,
    highlight: v,
    calendars: P,
    year: C,
    propDates: u,
    month: Y,
    filters: f,
    props: e,
    emit: t
  });
  Je(() => {
    e.startDate && (_.value && e.focusStartDate || !_.value) && E(ye(B(e.startDate)), 0);
  });
  const ne = (I) => I ? { month: Te(I), year: ye(I) } : { month: null, year: null }, ue = () => _.value ? Array.isArray(_.value) ? _.value.map((I) => ne(I)) : ne(_.value) : ne(), he = (I, M) => {
    const re = P.value[I], c = ue();
    return Array.isArray(c) ? c.some((i) => i.year === re?.year && i.month === M) : re?.year === c.year && M === c.month;
  }, y = (I, M, re) => {
    const c = ue();
    return Array.isArray(c) ? C.value(M) === c[re]?.year && I === c[re]?.month : !1;
  }, b = (I, M) => {
    if (o.value.enabled) {
      const re = ue();
      if (Array.isArray(_.value) && Array.isArray(re)) {
        const c = y(I, M, 0) || y(I, M, 1), i = $t(wt(B()), I, C.value(M));
        return ba(_.value, R.value, i) && !c;
      }
      return !1;
    }
    return !1;
  }, g = W(() => (I) => sa(O.value, (M) => {
    const re = he(I, M.value), c = wa(
      M.value,
      $r(C.value(I), u.value.minDate),
      Or(C.value(I), u.value.maxDate)
    ) || Ps(u.value.disabledDates, C.value(I), M.value) || f.value.months?.includes(M.value) || !As(u.value.allowedDates, C.value(I), M.value) || Nr(e.yearRange, C.value(I)), i = b(M.value, I), U = Ir(v.value, M.value, C.value(I));
    return { active: re, disabled: c, isBetween: i, highlighted: U };
  })), L = (I, M) => $t(wt(B()), I, C.value(M)), ee = (I, M) => {
    const re = _.value ? _.value : wt(/* @__PURE__ */ new Date());
    _.value = $t(re, I, C.value(M)), t("auto-apply"), t("update-flow-step");
  }, V = (I, M) => {
    const re = L(I, M);
    o.value.fixedEnd || o.value.fixedStart ? _.value = Lr(re, _, t, o) : _.value ? k(re, _.value) && (_.value = Cn(_, L(I, M), t)) : _.value = [L(I, M)], dt().then(() => {
      Va(_.value, t, e.autoApply, e.modelAuto);
    });
  }, K = (I, M) => {
    On(L(I, M), _, p.value.limit), t("auto-apply", !0);
  }, T = (I, M) => (P.value[M].month = I, m(M, P.value[M].year, I), p.value.enabled ? K(I, M) : o.value.enabled ? V(I, M) : ee(I, M)), ie = (I, M) => {
    E(I, M), m(M, I, null);
  }, m = (I, M, re) => {
    let c = re;
    if (!c && c !== 0) {
      const i = ue();
      c = Array.isArray(i) ? i[I].month : i.month;
    }
    t("update-month-year", { instance: I, year: M, month: c });
  };
  return {
    groupedMonths: g,
    groupedYears: X,
    year: C,
    isDisabled: F,
    defaultedMultiCalendars: n,
    defaultedAriaLabels: a,
    defaultedTransitions: r,
    defaultedConfig: l,
    showYearPicker: S,
    modelValue: _,
    presetDate: (I, M) => {
      Er({
        value: I,
        modelValue: _,
        range: o.value.enabled,
        timezone: M ? void 0 : x.value.timezone
      }), t("auto-apply");
    },
    setHoverDate: (I, M) => {
      R.value = L(I, M);
    },
    selectMonth: T,
    selectYear: ie,
    toggleYearPicker: N,
    handleYearSelect: ae,
    handleYear: q,
    getModelMonthYear: ue
  };
}, li = /* @__PURE__ */ Ge({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...kt
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "update-flow-step",
    "mount",
    "invalid-fixed-range",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, r = jt(), l = it(r, "yearMode"), o = e;
    Je(() => {
      o.shadow || a("mount", null);
    });
    const {
      groupedMonths: v,
      groupedYears: u,
      year: x,
      isDisabled: f,
      defaultedMultiCalendars: p,
      defaultedConfig: h,
      showYearPicker: _,
      modelValue: C,
      presetDate: Y,
      setHoverDate: P,
      selectMonth: O,
      selectYear: R,
      toggleYearPicker: k,
      handleYearSelect: E,
      handleYear: X,
      getModelMonthYear: S
    } = ri(o, a);
    return t({ getSidebarProps: () => ({
      modelValue: C,
      year: x,
      getModelMonthYear: S,
      selectMonth: O,
      selectYear: R,
      handleYear: X
    }), presetDate: Y, toggleYearPicker: (N) => k(0, N) }), (N, ae) => (D(), Ae(Na, {
      "multi-calendars": d(p).count,
      collapse: N.collapse,
      stretch: "",
      "is-mobile": N.isMobile
    }, {
      default: _e(({ instance: q }) => [
        N.$slots["top-extra"] ? se(N.$slots, "top-extra", {
          key: 0,
          value: N.internalModelValue
        }) : z("", !0),
        N.$slots["month-year"] ? se(N.$slots, "month-year", Qe(je({ key: 1 }, {
          year: d(x),
          months: d(v)(q),
          years: d(u)(q),
          selectMonth: d(O),
          selectYear: d(R),
          instance: q
        }))) : (D(), Ae(Ma, {
          key: 2,
          items: d(v)(q),
          "arrow-navigation": N.arrowNavigation,
          "is-last": N.autoApply && !d(h).keepActionRow,
          "esc-close": N.escClose,
          height: d(h).modeHeight,
          config: N.config,
          "no-overlay-focus": !!(N.noOverlayFocus || N.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (F) => d(O)(F, q),
          onHoverValue: (F) => d(P)(F, q)
        }, at({
          header: _e(() => [
            ut(Fr, je(N.$props, {
              items: d(u)(q),
              instance: q,
              "show-year-picker": d(_)[q],
              year: d(x)(q),
              "is-disabled": (F) => d(f)(q, F),
              onHandleYear: (F) => d(X)(q, F),
              onYearSelect: (F) => d(E)(F, q),
              onToggleYearPicker: (F) => d(k)(q, F?.flow, F?.show)
            }), at({ _: 2 }, [
              Ie(d(l), (F, ne) => ({
                name: F,
                fn: _e((ue) => [
                  se(N.$slots, F, Qe(ot(ue)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, [
          N.$slots["month-overlay-value"] ? {
            name: "item",
            fn: _e(({ item: F }) => [
              se(N.$slots, "month-overlay-value", {
                text: F.text,
                value: F.value
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), oi = (e, t) => {
  const n = () => {
    e.isTextInputDate && (f.value = ye(B(e.startDate)));
  }, { modelValue: a } = Ta(e, t, n), r = G(null), { defaultedHighlight: l, defaultedMultiDates: o, defaultedFilters: v, defaultedRange: u, propDates: x } = Ne(e), f = G();
  Je(() => {
    e.startDate && (a.value && e.focusStartDate || !a.value) && (f.value = ye(B(e.startDate)));
  });
  const p = (O) => Array.isArray(a.value) ? a.value.some((R) => ye(R) === O) : a.value ? ye(a.value) === O : !1, h = (O) => u.value.enabled && Array.isArray(a.value) ? ba(a.value, r.value, P(O)) : !1, _ = (O) => x.value.allowedDates instanceof Map ? x.value.allowedDates.size ? x.value.allowedDates.has(`${O}`) : !1 : !0, C = (O) => x.value.disabledDates instanceof Map ? x.value.disabledDates.size ? x.value.disabledDates.has(`${O}`) : !1 : typeof x.value.disabledDates == "function" ? x.value.disabledDates(gt(Ue(ta(B())), O)) : !0, Y = W(() => sa(Tn(e.yearRange, e.locale, e.reverseYears), (O) => {
    const R = p(O.value), k = wa(
      O.value,
      ia(x.value.minDate),
      ia(x.value.maxDate)
    ) || v.value.years.includes(O.value) || !_(O.value) || C(O.value), E = h(O.value) && !R, X = $n(l.value, O.value);
    return { active: R, disabled: k, isBetween: E, highlighted: X };
  })), P = (O) => gt(wt(ta(/* @__PURE__ */ new Date())), O);
  return {
    groupedYears: Y,
    modelValue: a,
    focusYear: f,
    setHoverValue: (O) => {
      r.value = gt(wt(/* @__PURE__ */ new Date()), O);
    },
    selectYear: (O) => {
      if (t("update-month-year", { instance: 0, year: O }), o.value.enabled)
        return a.value ? Array.isArray(a.value) && ((a.value?.map((R) => ye(R))).includes(O) ? a.value = a.value.filter((R) => ye(R) !== O) : a.value.push(gt(Ue(B()), O))) : a.value = [gt(Ue(ta(B())), O)], t("auto-apply", !0);
      u.value.enabled ? (a.value = Cn(a, P(O), t), dt().then(() => {
        Va(a.value, t, e.autoApply, e.modelAuto);
      })) : (a.value = P(O), t("auto-apply"));
    }
  };
}, si = /* @__PURE__ */ Ge({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...kt
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, r = e, { groupedYears: l, modelValue: o, focusYear: v, selectYear: u, setHoverValue: x } = oi(r, a), { defaultedConfig: f } = Ne(r);
    return t({ getSidebarProps: () => ({
      modelValue: o,
      selectYear: u
    }) }), (p, h) => (D(), H("div", null, [
      p.$slots["top-extra"] ? se(p.$slots, "top-extra", {
        key: 0,
        value: p.internalModelValue
      }) : z("", !0),
      p.$slots["month-year"] ? se(p.$slots, "month-year", Qe(je({ key: 1 }, {
        years: d(l),
        selectYear: d(u)
      }))) : (D(), Ae(Ma, {
        key: 2,
        items: d(l),
        "is-last": p.autoApply && !d(f).keepActionRow,
        height: d(f).modeHeight,
        config: p.config,
        "no-overlay-focus": !!(p.noOverlayFocus || p.textInput),
        "focus-value": d(v),
        type: "year",
        "use-relative": "",
        onSelected: d(u),
        onHoverValue: d(x)
      }, at({ _: 2 }, [
        p.$slots["year-overlay-value"] ? {
          name: "item",
          fn: _e(({ item: _ }) => [
            se(p.$slots, "year-overlay-value", {
              text: _.text,
              value: _.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), ii = {
  key: 0,
  class: "dp__time_input"
}, ui = ["data-compact", "data-collapsed"], di = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], ci = ["aria-label", "disabled", "data-test-id", "onKeydown", "onClick"], vi = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], fi = { key: 0 }, mi = ["aria-label", "data-compact"], pi = /* @__PURE__ */ Ge({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...kt
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "overlay-opened",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, r = e, { setTimePickerElements: l, setTimePickerBackRef: o } = Lt(), {
      defaultedAriaLabels: v,
      defaultedTransitions: u,
      defaultedFilters: x,
      defaultedConfig: f,
      defaultedRange: p,
      defaultedMultiCalendars: h
    } = Ne(r), { transitionName: _, showTransition: C } = xa(u), Y = _a({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), P = G("AM"), O = G(null), R = G([]), k = G(), E = G(!1);
    Je(() => {
      a("mounted");
    });
    const X = (s) => Re(/* @__PURE__ */ new Date(), {
      hours: s.hours,
      minutes: s.minutes,
      seconds: r.enableSeconds ? s.seconds : 0,
      milliseconds: 0
    }), S = W(
      () => (s) => V(s, r[s]) || ae(s, r[s])
    ), N = W(() => ({ hours: r.hours, minutes: r.minutes, seconds: r.seconds })), ae = (s, le) => p.value.enabled && !p.value.disableTimeRangeValidation ? !r.validateTime(s, le) : !1, q = (s, le) => {
      if (p.value.enabled && !p.value.disableTimeRangeValidation) {
        const $ = le ? +r[`${s}Increment`] : -+r[`${s}Increment`], Me = r[s] + $;
        return !r.validateTime(s, Me);
      }
      return !1;
    }, F = W(() => (s) => !I(+r[s] + +r[`${s}Increment`], s) || q(s, !0)), ne = W(() => (s) => !I(+r[s] - +r[`${s}Increment`], s) || q(s, !1)), ue = (s, le) => ar(Re(B(), s), le), he = (s, le) => ss(Re(B(), s), le), y = W(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !r.timePickerInline,
        dp__time_col_reg_block: !r.enableSeconds && r.is24 && !r.timePickerInline,
        dp__time_col_reg_inline: !r.enableSeconds && r.is24 && r.timePickerInline,
        dp__time_col_reg_with_button: !r.enableSeconds && !r.is24,
        dp__time_col_sec: r.enableSeconds && r.is24,
        dp__time_col_sec_with_button: r.enableSeconds && !r.is24
      })
    ), b = W(
      () => r.timePickerInline && p.value.enabled && !h.value.count
    ), g = W(() => {
      const s = [{ type: "hours" }];
      return r.enableMinutes && s.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), r.enableSeconds && s.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), s;
    }), L = W(() => g.value.filter((s) => !s.separator)), ee = W(() => (s) => {
      if (s === "hours") {
        const le = Pe(+r.hours);
        return { text: le < 10 ? `0${le}` : `${le}`, value: le };
      }
      return { text: r[s] < 10 ? `0${r[s]}` : `${r[s]}`, value: r[s] };
    }), V = (s, le) => {
      if (!r.disabledTimesConfig) return !1;
      const $ = r.disabledTimesConfig(r.order, s === "hours" ? le : void 0);
      return $[s] ? !!$[s]?.includes(le) : !0;
    }, K = (s, le) => le !== "hours" || P.value === "AM" ? s : s + 12, T = (s) => {
      const le = r.is24 ? 24 : 12, $ = s === "hours" ? le : 60, Me = +r[`${s}GridIncrement`], fe = s === "hours" && !r.is24 ? Me : 0, Ke = [];
      for (let Le = fe; Le < $; Le += Me)
        Ke.push({ value: r.is24 ? Le : K(Le, s), text: Le < 10 ? `0${Le}` : `${Le}` });
      return s === "hours" && !r.is24 && Ke.unshift({ value: P.value === "PM" ? 12 : 0, text: "12" }), sa(Ke, (Le) => ({ active: !1, disabled: x.value.times[s].includes(Le.value) || !I(Le.value, s) || V(s, Le.value) || ae(s, Le.value) }));
    }, ie = (s) => s >= 0 ? s : 59, m = (s) => s >= 0 ? s : 23, I = (s, le) => {
      const $ = r.minTime ? X(Qa(r.minTime)) : null, Me = r.maxTime ? X(Qa(r.maxTime)) : null, fe = X(
        Qa(
          N.value,
          le,
          le === "minutes" || le === "seconds" ? ie(s) : m(s)
        )
      );
      return $ && Me ? (la(fe, Me) || ea(fe, Me)) && (Xt(fe, $) || ea(fe, $)) : $ ? Xt(fe, $) || ea(fe, $) : Me ? la(fe, Me) || ea(fe, Me) : !0;
    }, M = (s) => r[`no${s[0].toUpperCase() + s.slice(1)}Overlay`], re = (s) => {
      M(s) || (Y[s] = !Y[s], Y[s] ? (E.value = !0, a("overlay-opened", s)) : (E.value = !1, a("overlay-closed", s)));
    }, c = (s) => s === "hours" ? Ct : s === "minutes" ? Et : ra, i = () => {
      k.value && clearTimeout(k.value);
    }, U = (s, le = !0, $) => {
      const Me = le ? ue : he, fe = le ? +r[`${s}Increment`] : -+r[`${s}Increment`];
      I(+r[s] + fe, s) && a(
        `update:${s}`,
        c(s)(Me({ [s]: +r[s] }, { [s]: +r[`${s}Increment`] }))
      ), !$?.keyboard && f.value.timeArrowHoldThreshold && (k.value = setTimeout(() => {
        U(s, le);
      }, f.value.timeArrowHoldThreshold));
    }, Pe = (s) => r.is24 ? s : (s >= 12 ? P.value = "PM" : P.value = "AM", ms(s)), j = () => {
      P.value === "PM" ? (P.value = "AM", a("update:hours", r.hours - 12)) : (P.value = "PM", a("update:hours", r.hours + 12)), a("am-pm-change", P.value);
    }, we = (s) => {
      Y[s] = !0;
    }, J = (s, le, $) => {
      if (s && r.arrowNavigation) {
        Array.isArray(R.value[le]) ? R.value[le][$] = s : R.value[le] = [s];
        const Me = R.value.reduce(
          (fe, Ke) => Ke.map((Le, mt) => [...fe[mt] || [], Ke[mt]]),
          []
        );
        o(r.closeTimePickerBtn), O.value && (Me[1] = Me[1].concat(O.value)), l(Me, r.order);
      }
    }, te = (s, le) => (re(s), a(`update:${s}`, le));
    return t({ openChildCmp: we }), (s, le) => s.disabled ? z("", !0) : (D(), H("div", ii, [
      (D(!0), H(be, null, Ie(g.value, ($, Me) => (D(), H("div", {
        key: Me,
        class: ke(y.value),
        "data-compact": b.value && !s.enableSeconds,
        "data-collapsed": b.value && s.enableSeconds
      }, [
        $.separator ? (D(), H(be, { key: 0 }, [
          E.value ? z("", !0) : (D(), H(be, { key: 0 }, [
            Ot(":")
          ], 64))
        ], 64)) : (D(), H(be, { key: 1 }, [
          ge("button", {
            ref_for: !0,
            ref: (fe) => J(fe, Me, 0),
            type: "button",
            class: ke({
              dp__btn: !0,
              dp__inc_dec_button: !s.timePickerInline,
              dp__inc_dec_button_inline: s.timePickerInline,
              dp__tp_inline_btn_top: s.timePickerInline,
              dp__inc_dec_button_disabled: F.value($.type),
              "dp--hidden-el": E.value
            }),
            "data-test-id": `${$.type}-time-inc-btn-${r.order}`,
            "aria-label": d(v)?.incrementValue($.type),
            tabindex: "0",
            onKeydown: (fe) => d(rt)(fe, () => U($.type, !0, { keyboard: !0 }), !0),
            onClick: (fe) => d(f).timeArrowHoldThreshold ? void 0 : U($.type, !0),
            onMousedown: (fe) => d(f).timeArrowHoldThreshold ? U($.type, !0) : void 0,
            onMouseup: i
          }, [
            r.timePickerInline ? (D(), H(be, { key: 1 }, [
              s.$slots["tp-inline-arrow-up"] ? se(s.$slots, "tp-inline-arrow-up", { key: 0 }) : (D(), H(be, { key: 1 }, [
                le[2] || (le[2] = ge("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                le[3] || (le[3] = ge("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
              ], 64))
            ], 64)) : (D(), H(be, { key: 0 }, [
              s.$slots["arrow-up"] ? se(s.$slots, "arrow-up", { key: 0 }) : z("", !0),
              s.$slots["arrow-up"] ? z("", !0) : (D(), Ae(d(kn), { key: 1 }))
            ], 64))
          ], 42, di),
          ge("button", {
            ref_for: !0,
            ref: (fe) => J(fe, Me, 1),
            type: "button",
            "aria-label": `${ee.value($.type).text}-${d(v)?.openTpOverlay($.type)}`,
            class: ke({
              dp__time_display: !0,
              dp__time_display_block: !s.timePickerInline,
              dp__time_display_inline: s.timePickerInline,
              "dp--time-invalid": S.value($.type),
              "dp--time-overlay-btn": !S.value($.type),
              "dp--hidden-el": E.value
            }),
            disabled: M($.type),
            tabindex: "0",
            "data-test-id": `${$.type}-toggle-overlay-btn-${r.order}`,
            onKeydown: (fe) => d(rt)(fe, () => re($.type), !0),
            onClick: (fe) => re($.type)
          }, [
            s.$slots[$.type] ? se(s.$slots, $.type, {
              key: 0,
              text: ee.value($.type).text,
              value: ee.value($.type).value
            }) : z("", !0),
            s.$slots[$.type] ? z("", !0) : (D(), H(be, { key: 1 }, [
              Ot(tt(ee.value($.type).text), 1)
            ], 64))
          ], 42, ci),
          ge("button", {
            ref_for: !0,
            ref: (fe) => J(fe, Me, 2),
            type: "button",
            class: ke({
              dp__btn: !0,
              dp__inc_dec_button: !s.timePickerInline,
              dp__inc_dec_button_inline: s.timePickerInline,
              dp__tp_inline_btn_bottom: s.timePickerInline,
              dp__inc_dec_button_disabled: ne.value($.type),
              "dp--hidden-el": E.value
            }),
            "data-test-id": `${$.type}-time-dec-btn-${r.order}`,
            "aria-label": d(v)?.decrementValue($.type),
            tabindex: "0",
            onKeydown: (fe) => d(rt)(fe, () => U($.type, !1, { keyboard: !0 }), !0),
            onClick: (fe) => d(f).timeArrowHoldThreshold ? void 0 : U($.type, !1),
            onMousedown: (fe) => d(f).timeArrowHoldThreshold ? U($.type, !1) : void 0,
            onMouseup: i
          }, [
            r.timePickerInline ? (D(), H(be, { key: 1 }, [
              s.$slots["tp-inline-arrow-down"] ? se(s.$slots, "tp-inline-arrow-down", { key: 0 }) : (D(), H(be, { key: 1 }, [
                le[4] || (le[4] = ge("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                le[5] || (le[5] = ge("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
              ], 64))
            ], 64)) : (D(), H(be, { key: 0 }, [
              s.$slots["arrow-down"] ? se(s.$slots, "arrow-down", { key: 0 }) : z("", !0),
              s.$slots["arrow-down"] ? z("", !0) : (D(), Ae(d(Mn), { key: 1 }))
            ], 64))
          ], 42, vi)
        ], 64))
      ], 10, ui))), 128)),
      s.is24 ? z("", !0) : (D(), H("div", fi, [
        s.$slots["am-pm-button"] ? se(s.$slots, "am-pm-button", {
          key: 0,
          toggle: j,
          value: P.value
        }) : z("", !0),
        s.$slots["am-pm-button"] ? z("", !0) : (D(), H("button", {
          key: 1,
          ref_key: "amPmButton",
          ref: O,
          type: "button",
          class: "dp__pm_am_button",
          role: "button",
          "aria-label": d(v)?.amPmButton,
          tabindex: "0",
          "data-compact": b.value,
          onClick: j,
          onKeydown: le[0] || (le[0] = ($) => d(rt)($, () => j(), !0))
        }, tt(P.value), 41, mi))
      ])),
      (D(!0), H(be, null, Ie(L.value, ($, Me) => (D(), Ae(da, {
        key: Me,
        name: d(_)(Y[$.type]),
        css: d(C)
      }, {
        default: _e(() => [
          Y[$.type] ? (D(), Ae(Ma, {
            key: 0,
            items: T($.type),
            "is-last": s.autoApply && !d(f).keepActionRow,
            "esc-close": s.escClose,
            type: $.type,
            "text-input": s.textInput,
            config: s.config,
            "arrow-navigation": s.arrowNavigation,
            "aria-labels": s.ariaLabels,
            "overlay-label": d(v).timeOverlay?.($.type),
            onSelected: (fe) => te($.type, fe),
            onToggle: (fe) => re($.type),
            onResetFlow: le[1] || (le[1] = (fe) => s.$emit("reset-flow"))
          }, at({
            "button-icon": _e(() => [
              s.$slots["clock-icon"] ? se(s.$slots, "clock-icon", { key: 0 }) : z("", !0),
              s.$slots["clock-icon"] ? z("", !0) : (D(), Ae(Sa(s.timePickerInline ? d(ca) : d(_n)), { key: 1 }))
            ]),
            _: 2
          }, [
            s.$slots[`${$.type}-overlay-value`] ? {
              name: "item",
              fn: _e(({ item: fe }) => [
                se(s.$slots, `${$.type}-overlay-value`, {
                  text: fe.text,
                  value: fe.value
                })
              ]),
              key: "0"
            } : void 0,
            s.$slots[`${$.type}-overlay-header`] ? {
              name: "header",
              fn: _e(() => [
                se(s.$slots, `${$.type}-overlay-header`, {
                  toggle: () => re($.type)
                })
              ]),
              key: "1"
            } : void 0
          ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : z("", !0)
        ]),
        _: 2
      }, 1032, ["name", "css"]))), 128))
    ]));
  }
}), hi = ["data-dp-mobile"], yi = ["aria-label", "tabindex"], gi = ["role", "aria-label", "tabindex"], wi = ["aria-label"], Hr = /* @__PURE__ */ Ge({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...kt
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, r = e, { buildMatrix: l, setTimePicker: o } = Lt(), v = jt(), { defaultedTransitions: u, defaultedAriaLabels: x, defaultedTextInput: f, defaultedConfig: p, defaultedRange: h } = Ne(r), { transitionName: _, showTransition: C } = xa(u), { hideNavigationButtons: Y } = Fa(), P = G(null), O = G(null), R = G([]), k = G(null), E = G(!1);
    Je(() => {
      a("mount"), !r.timePicker && r.arrowNavigation ? l([ze(P.value)], "time") : o(!0, r.timePicker);
    });
    const X = W(() => h.value.enabled && r.modelAuto ? Tr(r.internalModelValue) : !0), S = G(!1), N = (V) => ({
      hours: Array.isArray(r.hours) ? r.hours[V] : r.hours,
      minutes: Array.isArray(r.minutes) ? r.minutes[V] : r.minutes,
      seconds: Array.isArray(r.seconds) ? r.seconds[V] : r.seconds
    }), ae = W(() => {
      const V = [];
      if (h.value.enabled)
        for (let K = 0; K < 2; K++)
          V.push(N(K));
      else
        V.push(N(0));
      return V;
    }), q = (V, K = !1, T = "") => {
      K || a("reset-flow"), S.value = V, a(V ? "overlay-opened" : "overlay-closed", et.time), r.arrowNavigation && o(V), dt(() => {
        T !== "" && R.value[0] && R.value[0].openChildCmp(T);
      });
    }, F = W(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: r.autoApply && !p.value.keepActionRow
    })), ne = it(v, "timePicker"), ue = (V, K, T) => h.value.enabled ? K === 0 ? [V, ae.value[1][T]] : [ae.value[0][T], V] : V, he = (V) => {
      a("update:hours", V);
    }, y = (V) => {
      a("update:minutes", V);
    }, b = (V) => {
      a("update:seconds", V);
    }, g = () => {
      if (k.value && !f.value.enabled && !r.noOverlayFocus) {
        const V = Dr(k.value);
        V && V.focus({ preventScroll: !0 });
      }
    }, L = (V) => {
      E.value = !1, a("overlay-closed", V);
    }, ee = (V) => {
      E.value = !0, a("overlay-opened", V);
    };
    return t({ toggleTimePicker: q }), (V, K) => (D(), H("div", {
      class: "dp--tp-wrap",
      "data-dp-mobile": V.isMobile
    }, [
      !V.timePicker && !V.timePickerInline ? $a((D(), H("button", {
        key: 0,
        ref_key: "openTimePickerBtn",
        ref: P,
        type: "button",
        class: ke({ ...F.value, "dp--hidden-el": S.value }),
        "aria-label": d(x)?.openTimePicker,
        tabindex: V.noOverlayFocus ? void 0 : 0,
        "data-test-id": "open-time-picker-btn",
        onKeydown: K[0] || (K[0] = (T) => d(rt)(T, () => q(!0))),
        onClick: K[1] || (K[1] = (T) => q(!0))
      }, [
        V.$slots["clock-icon"] ? se(V.$slots, "clock-icon", { key: 0 }) : z("", !0),
        V.$slots["clock-icon"] ? z("", !0) : (D(), Ae(d(_n), { key: 1 }))
      ], 42, yi)), [
        [Oa, !d(Y)(V.hideNavigation, "time")]
      ]) : z("", !0),
      ut(da, {
        name: d(_)(S.value),
        css: d(C) && !V.timePickerInline
      }, {
        default: _e(() => [
          S.value || V.timePicker || V.timePickerInline ? (D(), H("div", {
            key: 0,
            ref_key: "overlayRef",
            ref: k,
            role: V.timePickerInline ? void 0 : "dialog",
            class: ke({
              dp__overlay: !V.timePickerInline,
              "dp--overlay-absolute": !r.timePicker && !V.timePickerInline,
              "dp--overlay-relative": r.timePicker
            }),
            style: vt(V.timePicker ? { height: `${d(p).modeHeight}px` } : void 0),
            "aria-label": d(x)?.timePicker,
            tabindex: V.timePickerInline ? void 0 : 0
          }, [
            ge("div", {
              class: ke(
                V.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
              ),
              style: { display: "flex" }
            }, [
              V.$slots["time-picker-overlay"] ? se(V.$slots, "time-picker-overlay", {
                key: 0,
                hours: e.hours,
                minutes: e.minutes,
                seconds: e.seconds,
                setHours: he,
                setMinutes: y,
                setSeconds: b
              }) : z("", !0),
              V.$slots["time-picker-overlay"] ? z("", !0) : (D(), H("div", {
                key: 1,
                class: ke(V.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
              }, [
                (D(!0), H(be, null, Ie(ae.value, (T, ie) => $a((D(), Ae(pi, je({ key: ie }, { ref_for: !0 }, {
                  ...V.$props,
                  order: ie,
                  hours: T.hours,
                  minutes: T.minutes,
                  seconds: T.seconds,
                  closeTimePickerBtn: O.value,
                  disabledTimesConfig: e.disabledTimesConfig,
                  disabled: ie === 0 ? d(h).fixedStart : d(h).fixedEnd
                }, {
                  ref_for: !0,
                  ref_key: "timeInputRefs",
                  ref: R,
                  "validate-time": (m, I) => e.validateTime(m, ue(I, ie, m)),
                  "onUpdate:hours": (m) => he(ue(m, ie, "hours")),
                  "onUpdate:minutes": (m) => y(ue(m, ie, "minutes")),
                  "onUpdate:seconds": (m) => b(ue(m, ie, "seconds")),
                  onMounted: g,
                  onOverlayClosed: L,
                  onOverlayOpened: ee,
                  onAmPmChange: K[2] || (K[2] = (m) => V.$emit("am-pm-change", m))
                }), at({ _: 2 }, [
                  Ie(d(ne), (m, I) => ({
                    name: m,
                    fn: _e((M) => [
                      se(V.$slots, m, je({ ref_for: !0 }, M))
                    ])
                  }))
                ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                  [Oa, ie === 0 ? !0 : X.value]
                ])), 128))
              ], 2)),
              !V.timePicker && !V.timePickerInline ? $a((D(), H("button", {
                key: 2,
                ref_key: "closeTimePickerBtn",
                ref: O,
                type: "button",
                class: ke({ ...F.value, "dp--hidden-el": E.value }),
                "aria-label": d(x)?.closeTimePicker,
                tabindex: "0",
                onKeydown: K[3] || (K[3] = (T) => d(rt)(T, () => q(!1))),
                onClick: K[4] || (K[4] = (T) => q(!1))
              }, [
                V.$slots["calendar-icon"] ? se(V.$slots, "calendar-icon", { key: 0 }) : z("", !0),
                V.$slots["calendar-icon"] ? z("", !0) : (D(), Ae(d(ca), { key: 1 }))
              ], 42, wi)), [
                [Oa, !d(Y)(V.hideNavigation, "time")]
              ]) : z("", !0)
            ], 2)
          ], 14, gi)) : z("", !0)
        ]),
        _: 3
      }, 8, ["name", "css"])
    ], 8, hi));
  }
}), Wr = (e, t, n, a) => {
  const { defaultedRange: r } = Ne(e), l = (k, E) => Array.isArray(t[k]) ? t[k][E] : t[k], o = (k) => e.enableSeconds ? Array.isArray(t.seconds) ? t.seconds[k] : t.seconds : 0, v = (k, E) => k ? E !== void 0 ? Ft(k, l("hours", E), l("minutes", E), o(E)) : Ft(k, t.hours, t.minutes, o()) : _r(B(), o(E)), u = (k, E) => {
    t[k] = E;
  }, x = W(() => e.modelAuto && r.value.enabled ? Array.isArray(n.value) ? n.value.length > 1 : !1 : r.value.enabled), f = (k, E) => {
    const X = Object.fromEntries(
      Object.keys(t).map((S) => S === k ? [S, E] : [S, t[S]].slice())
    );
    if (x.value && !r.value.disableTimeRangeValidation) {
      const S = (ae) => n.value ? Ft(
        n.value[ae],
        X.hours[ae],
        X.minutes[ae],
        X.seconds[ae]
      ) : null, N = (ae) => br(n.value[ae], 0);
      return !(De(S(0), S(1)) && (Xt(S(0), N(1)) || la(S(1), N(0))));
    }
    return !0;
  }, p = (k, E) => {
    f(k, E) && (u(k, E), a && a());
  }, h = (k) => {
    p("hours", k);
  }, _ = (k) => {
    p("minutes", k);
  }, C = (k) => {
    p("seconds", k);
  }, Y = (k, E, X, S) => {
    E && h(k), !E && !X && _(k), X && C(k), n.value && S(n.value);
  }, P = (k) => {
    if (k) {
      const E = Array.isArray(k), X = E ? [+k[0].hours, +k[1].hours] : +k.hours, S = E ? [+k[0].minutes, +k[1].minutes] : +k.minutes, N = E ? [+k[0].seconds, +k[1].seconds] : +k.seconds;
      u("hours", X), u("minutes", S), e.enableSeconds && u("seconds", N);
    }
  }, O = (k, E) => {
    const X = {
      hours: Array.isArray(t.hours) ? t.hours[k] : t.hours,
      disabledArr: []
    };
    return (E || E === 0) && (X.hours = E), Array.isArray(e.disabledTimes) && (X.disabledArr = r.value.enabled && Array.isArray(e.disabledTimes[k]) ? e.disabledTimes[k] : e.disabledTimes), X;
  }, R = W(() => (k, E) => {
    if (Array.isArray(e.disabledTimes)) {
      const { disabledArr: X, hours: S } = O(k, E), N = X.filter((ae) => +ae.hours === S);
      return N[0]?.minutes === "*" ? { hours: [S], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: N?.map((ae) => +ae.minutes) ?? [],
        seconds: N?.map((ae) => ae.seconds ? +ae.seconds : void 0) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: u,
    updateHours: h,
    updateMinutes: _,
    updateSeconds: C,
    getSetDateTime: v,
    updateTimeValues: Y,
    getSecondsValue: o,
    assignStartTime: P,
    validateTime: f,
    disabledTimesConfig: R
  };
}, bi = (e, t) => {
  const n = () => {
    e.isTextInputDate && E();
  }, { modelValue: a, time: r } = Ta(e, t, n), { defaultedStartTime: l, defaultedRange: o, defaultedTz: v } = Ne(e), { updateTimeValues: u, getSetDateTime: x, setTime: f, assignStartTime: p, disabledTimesConfig: h, validateTime: _ } = Wr(e, r, a, C);
  function C() {
    t("update-flow-step");
  }
  const Y = (S) => {
    const { hours: N, minutes: ae, seconds: q } = S;
    return { hours: +N, minutes: +ae, seconds: q ? +q : 0 };
  }, P = () => {
    if (e.startTime) {
      if (Array.isArray(e.startTime)) {
        const N = Y(e.startTime[0]), ae = Y(e.startTime[1]);
        return [Re(B(), N), Re(B(), ae)];
      }
      const S = Y(e.startTime);
      return Re(B(), S);
    }
    return o.value.enabled ? [null, null] : null;
  }, O = () => {
    if (o.value.enabled) {
      const [S, N] = P();
      a.value = [
        st(x(S, 0), v.value.timezone),
        st(x(N, 1), v.value.timezone)
      ];
    } else
      a.value = st(x(P()), v.value.timezone);
  }, R = (S) => Array.isArray(S) ? [Ut(B(S[0])), Ut(B(S[1]))] : [Ut(S ?? B())], k = (S, N, ae) => {
    f("hours", S), f("minutes", N), f("seconds", e.enableSeconds ? ae : 0);
  }, E = () => {
    const [S, N] = R(a.value);
    return o.value.enabled ? k(
      [S.hours, N.hours],
      [S.minutes, N.minutes],
      [S.seconds, N.seconds]
    ) : k(S.hours, S.minutes, S.seconds);
  };
  Je(() => {
    if (!e.shadow)
      return p(l.value), a.value ? E() : O();
  });
  const X = () => {
    Array.isArray(a.value) ? a.value = a.value.map((S, N) => S && x(S, N)) : a.value = x(a.value), t("time-update");
  };
  return {
    modelValue: a,
    time: r,
    disabledTimesConfig: h,
    updateTime: (S, N = !0, ae = !1) => {
      u(S, N, ae, X);
    },
    validateTime: _
  };
}, _i = /* @__PURE__ */ Ge({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...kt
  },
  emits: [
    "update:internal-model-value",
    "time-update",
    "am-pm-change",
    "mount",
    "reset-flow",
    "update-flow-step",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, r = e, l = jt(), o = it(l, "timePicker"), v = G(null), { time: u, modelValue: x, disabledTimesConfig: f, updateTime: p, validateTime: h } = bi(r, a);
    return Je(() => {
      r.shadow || a("mount", null);
    }), t({ getSidebarProps: () => ({
      modelValue: x,
      time: u,
      updateTime: p
    }), toggleTimePicker: (_, C = !1, Y = "") => {
      v.value?.toggleTimePicker(_, C, Y);
    } }), (_, C) => (D(), Ae(Na, {
      "multi-calendars": 0,
      stretch: "",
      "is-mobile": _.isMobile
    }, {
      default: _e(() => [
        ut(Hr, je({
          ref_key: "tpRef",
          ref: v
        }, _.$props, {
          hours: d(u).hours,
          minutes: d(u).minutes,
          seconds: d(u).seconds,
          "internal-model-value": _.internalModelValue,
          "disabled-times-config": d(f),
          "validate-time": d(h),
          "onUpdate:hours": C[0] || (C[0] = (Y) => d(p)(Y)),
          "onUpdate:minutes": C[1] || (C[1] = (Y) => d(p)(Y, !1)),
          "onUpdate:seconds": C[2] || (C[2] = (Y) => d(p)(Y, !1, !0)),
          onAmPmChange: C[3] || (C[3] = (Y) => _.$emit("am-pm-change", Y)),
          onResetFlow: C[4] || (C[4] = (Y) => _.$emit("reset-flow")),
          onOverlayClosed: C[5] || (C[5] = (Y) => _.$emit("overlay-toggle", { open: !1, overlay: Y })),
          onOverlayOpened: C[6] || (C[6] = (Y) => _.$emit("overlay-toggle", { open: !0, overlay: Y }))
        }), at({ _: 2 }, [
          Ie(d(o), (Y, P) => ({
            name: Y,
            fn: _e((O) => [
              se(_.$slots, Y, Qe(ot(O)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }, 8, ["is-mobile"]));
  }
}), ki = { class: "dp--header-wrap" }, Mi = {
  key: 0,
  class: "dp__month_year_wrap"
}, xi = { key: 0 }, Ti = { class: "dp__month_year_wrap" }, Di = ["data-dp-element", "aria-label", "data-test-id", "onClick", "onKeydown"], Pi = /* @__PURE__ */ Ge({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...kt
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed", "overlay-opened"],
  setup(e, { expose: t, emit: n }) {
    const a = n, r = e, {
      defaultedTransitions: l,
      defaultedAriaLabels: o,
      defaultedMultiCalendars: v,
      defaultedFilters: u,
      defaultedConfig: x,
      defaultedHighlight: f,
      propDates: p,
      defaultedUI: h
    } = Ne(r), { transitionName: _, showTransition: C } = xa(l), { buildMatrix: Y } = Lt(), { handleMonthYearChange: P, isDisabled: O, updateMonthYear: R } = Xs(r, a), { showLeftIcon: k, showRightIcon: E } = Fa(), X = G(!1), S = G(!1), N = G(!1), ae = G([null, null, null, null]);
    Je(() => {
      a("mount");
    });
    const q = (m) => ({
      get: () => r[m],
      set: (I) => {
        const M = m === ht.month ? ht.year : ht.month;
        a("update-month-year", { [m]: I, [M]: r[M] }), m === ht.month ? L(!0) : ee(!0);
      }
    }), F = W(q(ht.month)), ne = W(q(ht.year)), ue = W(() => (m) => ({
      month: r.month,
      year: r.year,
      items: m === ht.month ? r.months : r.years,
      instance: r.instance,
      updateMonthYear: R,
      toggle: m === ht.month ? L : ee
    })), he = W(() => r.months.find((I) => I.value === r.month) || { text: "", value: 0 }), y = W(() => sa(r.months, (m) => {
      const I = r.month === m.value, M = wa(
        m.value,
        $r(r.year, p.value.minDate),
        Or(r.year, p.value.maxDate)
      ) || u.value.months.includes(m.value), re = Ir(f.value, m.value, r.year);
      return { active: I, disabled: M, highlighted: re };
    })), b = W(() => sa(r.years, (m) => {
      const I = r.year === m.value, M = wa(
        m.value,
        ia(p.value.minDate),
        ia(p.value.maxDate)
      ) || u.value.years.includes(m.value), re = $n(f.value, m.value);
      return { active: I, disabled: M, highlighted: re };
    })), g = (m, I, M) => {
      M !== void 0 ? m.value = M : m.value = !m.value, m.value ? (N.value = !0, a("overlay-opened", I)) : (N.value = !1, a("overlay-closed", I));
    }, L = (m = !1, I) => {
      V(m), g(X, et.month, I);
    }, ee = (m = !1, I) => {
      V(m), g(S, et.year, I);
    }, V = (m) => {
      m || a("reset-flow");
    }, K = (m, I) => {
      r.arrowNavigation && (ae.value[I] = ze(m), Y(ae.value, "monthYear"));
    }, T = W(() => [
      {
        type: ht.month,
        index: 1,
        toggle: L,
        modelValue: F.value,
        updateModelValue: (m) => F.value = m,
        text: he.value.text,
        showSelectionGrid: X.value,
        items: y.value,
        ariaLabel: o.value?.openMonthsOverlay,
        overlayLabel: o.value.monthPicker?.(!0) ?? void 0
      },
      {
        type: ht.year,
        index: 2,
        toggle: ee,
        modelValue: ne.value,
        updateModelValue: (m) => ne.value = m,
        text: Pn(r.year, r.locale),
        showSelectionGrid: S.value,
        items: b.value,
        ariaLabel: o.value?.openYearsOverlay,
        overlayLabel: o.value.yearPicker?.(!0) ?? void 0
      }
    ]), ie = W(() => r.disableYearSelect ? [T.value[0]] : r.yearFirst ? [...T.value].reverse() : T.value);
    return t({
      toggleMonthPicker: L,
      toggleYearPicker: ee,
      handleMonthYearChange: P
    }), (m, I) => (D(), H("div", ki, [
      m.$slots["month-year"] ? (D(), H("div", Mi, [
        se(m.$slots, "month-year", Qe(ot({
          month: e.month,
          year: e.year,
          months: e.months,
          years: e.years,
          updateMonthYear: d(R),
          handleMonthYearChange: d(P),
          instance: e.instance,
          isDisabled: d(O)
        })))
      ])) : (D(), H(be, { key: 1 }, [
        m.$slots["top-extra"] ? (D(), H("div", xi, [
          se(m.$slots, "top-extra", { value: m.internalModelValue })
        ])) : z("", !0),
        ge("div", Ti, [
          d(k)(d(v), e.instance) && !m.vertical ? (D(), Ae(ha, {
            key: 0,
            "aria-label": d(o)?.prevMonth,
            disabled: d(O)(!1),
            class: ke(d(h)?.navBtnPrev),
            "el-name": "action-prev",
            onActivate: I[0] || (I[0] = (M) => d(P)(!1, !0)),
            onSetRef: I[1] || (I[1] = (M) => K(M, 0))
          }, {
            default: _e(() => [
              m.$slots["arrow-left"] ? se(m.$slots, "arrow-left", { key: 0 }) : z("", !0),
              m.$slots["arrow-left"] ? z("", !0) : (D(), Ae(d(wn), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : z("", !0),
          ge("div", {
            class: ke(["dp__month_year_wrap", {
              dp__year_disable_select: m.disableYearSelect
            }])
          }, [
            (D(!0), H(be, null, Ie(ie.value, (M, re) => (D(), H(be, {
              key: M.type
            }, [
              ge("button", {
                ref_for: !0,
                ref: (c) => K(c, re + 1),
                type: "button",
                "data-dp-element": `overlay-${M.type}`,
                class: ke(["dp__btn dp__month_year_select", { "dp--hidden-el": N.value }]),
                "aria-label": `${M.text}-${M.ariaLabel}`,
                "data-test-id": `${M.type}-toggle-overlay-${e.instance}`,
                onClick: M.toggle,
                onKeydown: (c) => d(rt)(c, () => M.toggle(), !0)
              }, [
                m.$slots[M.type] ? se(m.$slots, M.type, {
                  key: 0,
                  text: M.text,
                  value: r[M.type]
                }) : z("", !0),
                m.$slots[M.type] ? z("", !0) : (D(), H(be, { key: 1 }, [
                  Ot(tt(M.text), 1)
                ], 64))
              ], 42, Di),
              ut(da, {
                name: d(_)(M.showSelectionGrid),
                css: d(C)
              }, {
                default: _e(() => [
                  M.showSelectionGrid ? (D(), Ae(Ma, {
                    key: 0,
                    items: M.items,
                    "arrow-navigation": m.arrowNavigation,
                    "hide-navigation": m.hideNavigation,
                    "is-last": m.autoApply && !d(x).keepActionRow,
                    "skip-button-ref": !1,
                    config: m.config,
                    type: M.type,
                    "header-refs": [],
                    "esc-close": m.escClose,
                    "menu-wrap-ref": m.menuWrapRef,
                    "text-input": m.textInput,
                    "aria-labels": m.ariaLabels,
                    "overlay-label": M.overlayLabel,
                    onSelected: M.updateModelValue,
                    onToggle: M.toggle
                  }, at({
                    "button-icon": _e(() => [
                      m.$slots["calendar-icon"] ? se(m.$slots, "calendar-icon", { key: 0 }) : z("", !0),
                      m.$slots["calendar-icon"] ? z("", !0) : (D(), Ae(d(ca), { key: 1 }))
                    ]),
                    _: 2
                  }, [
                    m.$slots[`${M.type}-overlay-value`] ? {
                      name: "item",
                      fn: _e(({ item: c }) => [
                        se(m.$slots, `${M.type}-overlay-value`, {
                          text: c.text,
                          value: c.value
                        })
                      ]),
                      key: "0"
                    } : void 0,
                    m.$slots[`${M.type}-overlay`] ? {
                      name: "overlay",
                      fn: _e(() => [
                        se(m.$slots, `${M.type}-overlay`, je({ ref_for: !0 }, ue.value(M.type)))
                      ]),
                      key: "1"
                    } : void 0,
                    m.$slots[`${M.type}-overlay-header`] ? {
                      name: "header",
                      fn: _e(() => [
                        se(m.$slots, `${M.type}-overlay-header`, {
                          toggle: M.toggle
                        })
                      ]),
                      key: "2"
                    } : void 0
                  ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "menu-wrap-ref", "text-input", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : z("", !0)
                ]),
                _: 2
              }, 1032, ["name", "css"])
            ], 64))), 128))
          ], 2),
          d(k)(d(v), e.instance) && m.vertical ? (D(), Ae(ha, {
            key: 1,
            "aria-label": d(o)?.prevMonth,
            "el-name": "action-prev",
            disabled: d(O)(!1),
            class: ke(d(h)?.navBtnPrev),
            onActivate: I[2] || (I[2] = (M) => d(P)(!1, !0))
          }, {
            default: _e(() => [
              m.$slots["arrow-up"] ? se(m.$slots, "arrow-up", { key: 0 }) : z("", !0),
              m.$slots["arrow-up"] ? z("", !0) : (D(), Ae(d(kn), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : z("", !0),
          d(E)(d(v), e.instance) ? (D(), Ae(ha, {
            key: 2,
            ref: "rightIcon",
            "el-name": "action-next",
            disabled: d(O)(!0),
            "aria-label": d(o)?.nextMonth,
            class: ke(d(h)?.navBtnNext),
            onActivate: I[3] || (I[3] = (M) => d(P)(!0, !0)),
            onSetRef: I[4] || (I[4] = (M) => K(M, m.disableYearSelect ? 2 : 3))
          }, {
            default: _e(() => [
              m.$slots[m.vertical ? "arrow-down" : "arrow-right"] ? se(m.$slots, m.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : z("", !0),
              m.$slots[m.vertical ? "arrow-down" : "arrow-right"] ? z("", !0) : (D(), Ae(Sa(m.vertical ? d(Mn) : d(bn)), { key: 1 }))
            ]),
            _: 3
          }, 8, ["disabled", "aria-label", "class"])) : z("", !0)
        ])
      ], 64))
    ]));
  }
}), Ai = {
  class: "dp__calendar_header",
  role: "row"
}, $i = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, Oi = ["aria-label"], Ci = {
  key: 0,
  class: "dp__calendar_item dp__week_num",
  role: "gridcell"
}, Ri = { class: "dp__cell_inner" }, Yi = ["id", "aria-selected", "aria-disabled", "aria-label", "tabindex", "data-test-id", "onClick", "onTouchend", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], Si = /* @__PURE__ */ Ge({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...kt
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, r = e, { buildMultiLevelMatrix: l } = Lt(), {
      defaultedTransitions: o,
      defaultedConfig: v,
      defaultedAriaLabels: u,
      defaultedMultiCalendars: x,
      defaultedWeekNumbers: f,
      defaultedMultiDates: p,
      defaultedUI: h
    } = Ne(r), _ = G(null), C = G({
      bottom: "",
      left: "",
      transform: ""
    }), Y = G([]), P = G(null), O = G(!0), R = G(""), k = G({ startX: 0, endX: 0, startY: 0, endY: 0 }), E = G([]), X = G({ left: "50%" }), S = G(!1), N = W(() => r.calendar ? r.calendar(r.mappedDates) : r.mappedDates), ae = W(() => r.dayNames ? Array.isArray(r.dayNames) ? r.dayNames : r.dayNames(r.locale, +r.weekStart) : fs(r.formatLocale, r.locale, +r.weekStart));
    Je(() => {
      a("mount", { cmp: "calendar", refs: Y }), v.value.noSwipe || P.value && (P.value.addEventListener("touchstart", K, { passive: !1 }), P.value.addEventListener("touchend", T, { passive: !1 }), P.value.addEventListener("touchmove", ie, { passive: !1 })), r.monthChangeOnScroll && P.value && P.value.addEventListener("wheel", M, { passive: !1 });
    }), ua(() => {
      v.value.noSwipe || P.value && (P.value.removeEventListener("touchstart", K), P.value.removeEventListener("touchend", T), P.value.removeEventListener("touchmove", ie)), r.monthChangeOnScroll && P.value && P.value.removeEventListener("wheel", M);
    });
    const q = (j) => j ? r.vertical ? "vNext" : "next" : r.vertical ? "vPrevious" : "previous", F = (j, we) => {
      if (r.transitions) {
        const J = Ue($t(B(), r.month, r.year));
        R.value = He(Ue($t(B(), j, we)), J) ? o.value[q(!0)] : o.value[q(!1)], O.value = !1, dt(() => {
          O.value = !0;
        });
      }
    }, ne = W(
      () => ({
        ...h.value.calendar ?? {}
      })
    ), ue = W(() => (j) => {
      const we = ps(j);
      return {
        dp__marker_dot: we.type === "dot",
        dp__marker_line: we.type === "line"
      };
    }), he = W(() => (j) => De(j, _.value)), y = W(() => ({
      dp__calendar: !0,
      dp__calendar_next: x.value.count > 0 && r.instance !== 0
    })), b = W(() => (j) => r.hideOffsetDates ? j.current : !0), g = async (j, we) => {
      const { width: J, height: te } = j.getBoundingClientRect();
      _.value = we.value;
      let s = { left: `${J / 2}px` }, le = -50;
      if (await dt(), E.value[0]) {
        const { left: $, width: Me } = E.value[0].getBoundingClientRect();
        $ < 0 && (s = { left: "0" }, le = 0, X.value.left = `${J / 2}px`), window.innerWidth < $ + Me && (s = { right: "0" }, le = 0, X.value.left = `${Me - J / 2}px`);
      }
      C.value = {
        bottom: `${te}px`,
        ...s,
        transform: `translateX(${le}%)`
      };
    }, L = async (j, we, J) => {
      const te = ze(Y.value[we][J]);
      te && (j.marker?.customPosition && j.marker?.tooltip?.length ? C.value = j.marker.customPosition(te) : await g(te, j), a("tooltip-open", j.marker));
    }, ee = async (j, we, J) => {
      if (S.value && p.value.enabled && p.value.dragSelect)
        return a("select-date", j);
      if (a("set-hover-date", j), j.marker?.tooltip?.length) {
        if (r.hideOffsetDates && !j.current) return;
        await L(j, we, J);
      }
    }, V = (j) => {
      _.value && (_.value = null, C.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), a("tooltip-close", j.marker));
    }, K = (j) => {
      k.value.startX = j.changedTouches[0].screenX, k.value.startY = j.changedTouches[0].screenY;
    }, T = (j) => {
      k.value.endX = j.changedTouches[0].screenX, k.value.endY = j.changedTouches[0].screenY, m();
    }, ie = (j) => {
      r.vertical && !r.inline && j.preventDefault();
    }, m = () => {
      const j = r.vertical ? "Y" : "X";
      Math.abs(k.value[`start${j}`] - k.value[`end${j}`]) > 10 && a("handle-swipe", k.value[`start${j}`] > k.value[`end${j}`] ? "right" : "left");
    }, I = (j, we, J) => {
      j && (Array.isArray(Y.value[we]) ? Y.value[we][J] = j : Y.value[we] = [j]), r.arrowNavigation && l(Y.value, "calendar");
    }, M = (j) => {
      r.monthChangeOnScroll && (j.preventDefault(), a("handle-scroll", j));
    }, re = (j) => f.value.type === "local" ? hn(j.value, { weekStartsOn: +r.weekStart }) : f.value.type === "iso" ? mn(j.value) : typeof f.value.type == "function" ? f.value.type(j.value) : "", c = (j) => {
      const we = j[0];
      return f.value.hideOnOffsetDates ? j.some((J) => J.current) ? re(we) : "" : re(we);
    }, i = (j, we, J = !0) => {
      !J && bs() || (!p.value.enabled || v.value.allowPreventDefault) && (Vt(j, v.value), a("select-date", we));
    }, U = (j) => {
      Vt(j, v.value);
    }, Pe = (j) => {
      p.value.enabled && p.value.dragSelect ? (S.value = !0, a("select-date", j)) : p.value.enabled && a("select-date", j);
    };
    return t({ triggerTransition: F }), (j, we) => (D(), H("div", {
      class: ke(y.value)
    }, [
      ge("div", {
        ref_key: "calendarWrapRef",
        ref: P,
        class: ke(ne.value),
        role: "grid"
      }, [
        ge("div", Ai, [
          j.weekNumbers ? (D(), H("div", $i, tt(j.weekNumName), 1)) : z("", !0),
          (D(!0), H(be, null, Ie(ae.value, (J, te) => (D(), H("div", {
            key: te,
            class: "dp__calendar_header_item",
            role: "gridcell",
            "data-test-id": "calendar-header",
            "aria-label": d(u)?.weekDay?.(te)
          }, [
            j.$slots["calendar-header"] ? se(j.$slots, "calendar-header", {
              key: 0,
              day: J,
              index: te
            }) : z("", !0),
            j.$slots["calendar-header"] ? z("", !0) : (D(), H(be, { key: 1 }, [
              Ot(tt(J), 1)
            ], 64))
          ], 8, Oi))), 128))
        ]),
        we[2] || (we[2] = ge("div", { class: "dp__calendar_header_separator" }, null, -1)),
        ut(da, {
          name: R.value,
          css: !!j.transitions
        }, {
          default: _e(() => [
            O.value ? (D(), H("div", {
              key: 0,
              class: "dp__calendar",
              role: "rowgroup",
              onMouseleave: we[1] || (we[1] = (J) => S.value = !1)
            }, [
              (D(!0), H(be, null, Ie(N.value, (J, te) => (D(), H("div", {
                key: te,
                class: "dp__calendar_row",
                role: "row"
              }, [
                j.weekNumbers ? (D(), H("div", Ci, [
                  ge("div", Ri, tt(c(J.days)), 1)
                ])) : z("", !0),
                (D(!0), H(be, null, Ie(J.days, (s, le) => (D(), H("div", {
                  id: d(vn)(s.value),
                  ref_for: !0,
                  ref: ($) => I($, te, le),
                  key: le + te,
                  role: "gridcell",
                  class: "dp__calendar_item",
                  "aria-selected": (s.classData.dp__active_date || s.classData.dp__range_start || s.classData.dp__range_end) ?? void 0,
                  "aria-disabled": s.classData.dp__cell_disabled || void 0,
                  "aria-label": d(u)?.day?.(s),
                  tabindex: !s.current && j.hideOffsetDates ? void 0 : 0,
                  "data-test-id": d(vn)(s.value),
                  onClick: ga(($) => i($, s), ["prevent"]),
                  onTouchend: ($) => i($, s, !1),
                  onKeydown: ($) => d(rt)($, () => j.$emit("select-date", s)),
                  onMouseenter: ($) => ee(s, te, le),
                  onMouseleave: ($) => V(s),
                  onMousedown: ($) => Pe(s),
                  onMouseup: we[0] || (we[0] = ($) => S.value = !1)
                }, [
                  ge("div", {
                    class: ke(["dp__cell_inner", s.classData])
                  }, [
                    j.$slots.day && b.value(s) ? se(j.$slots, "day", {
                      key: 0,
                      day: +s.text,
                      date: s.value
                    }) : z("", !0),
                    j.$slots.day ? z("", !0) : (D(), H(be, { key: 1 }, [
                      Ot(tt(s.text), 1)
                    ], 64)),
                    s.marker && b.value(s) ? (D(), H(be, { key: 2 }, [
                      j.$slots.marker ? se(j.$slots, "marker", {
                        key: 0,
                        marker: s.marker,
                        day: +s.text,
                        date: s.value
                      }) : (D(), H("div", {
                        key: 1,
                        class: ke(ue.value(s.marker)),
                        style: vt(s.marker.color ? { backgroundColor: s.marker.color } : {})
                      }, null, 6))
                    ], 64)) : z("", !0),
                    he.value(s.value) ? (D(), H("div", {
                      key: 3,
                      ref_for: !0,
                      ref_key: "activeTooltip",
                      ref: E,
                      class: "dp__marker_tooltip",
                      style: vt(C.value)
                    }, [
                      s.marker?.tooltip ? (D(), H("div", {
                        key: 0,
                        class: "dp__tooltip_content",
                        onClick: U
                      }, [
                        (D(!0), H(be, null, Ie(s.marker.tooltip, ($, Me) => (D(), H("div", {
                          key: Me,
                          class: "dp__tooltip_text"
                        }, [
                          j.$slots["marker-tooltip"] ? se(j.$slots, "marker-tooltip", {
                            key: 0,
                            tooltip: $,
                            day: s.value
                          }) : z("", !0),
                          j.$slots["marker-tooltip"] ? z("", !0) : (D(), H(be, { key: 1 }, [
                            ge("div", {
                              class: "dp__tooltip_mark",
                              style: vt($.color ? { backgroundColor: $.color } : {})
                            }, null, 4),
                            ge("div", null, tt($.text), 1)
                          ], 64))
                        ]))), 128)),
                        ge("div", {
                          class: "dp__arrow_bottom_tp",
                          style: vt(X.value)
                        }, null, 4)
                      ])) : z("", !0)
                    ], 4)) : z("", !0)
                  ], 2)
                ], 40, Yi))), 128))
              ]))), 128))
            ], 32)) : z("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2)
    ], 2));
  }
}), Kn = (e) => Array.isArray(e), Ii = (e, t, n, a) => {
  const r = G([]), l = G(/* @__PURE__ */ new Date()), o = G(), v = () => T(e.isTextInputDate), { modelValue: u, calendars: x, time: f, today: p } = Ta(e, t, v), {
    defaultedMultiCalendars: h,
    defaultedStartTime: _,
    defaultedRange: C,
    defaultedConfig: Y,
    defaultedTz: P,
    propDates: O,
    defaultedMultiDates: R
  } = Ne(e), { validateMonthYearInRange: k, isDisabled: E, isDateRangeAllowed: X, checkMinMaxRange: S } = Bt(e), { updateTimeValues: N, getSetDateTime: ae, setTime: q, assignStartTime: F, validateTime: ne, disabledTimesConfig: ue } = Wr(e, f, u, a), he = W(
    () => (w) => x.value[w] ? x.value[w].month : 0
  ), y = W(
    () => (w) => x.value[w] ? x.value[w].year : 0
  ), b = (w) => !Y.value.keepViewOnOffsetClick || w ? !0 : !o.value, g = (w, Z, ve, xe = !1) => {
    b(xe) && (x.value[w] || (x.value[w] = { month: 0, year: 0 }), x.value[w].month = Un(Z) ? x.value[w]?.month : Z, x.value[w].year = Un(ve) ? x.value[w]?.year : ve);
  }, L = () => {
    e.autoApply && t("select-date");
  }, ee = () => {
    _.value && F(_.value);
  };
  Je(() => {
    e.shadow || (u.value || (we(), ee()), T(!0), e.focusStartDate && e.startDate && we());
  });
  const V = W(() => e.flow?.length && !e.partialFlow ? e.flowStep === e.flow.length : !0), K = () => {
    e.autoApply && V.value && t("auto-apply", e.partialFlow ? e.flowStep !== e.flow.length : !1);
  }, T = (w = !1) => {
    if (u.value)
      return Array.isArray(u.value) ? (r.value = u.value, i(w)) : I(u.value, w);
    if (h.value.count && w && !e.startDate)
      return m(B(), w);
  }, ie = () => Array.isArray(u.value) && C.value.enabled ? Te(u.value[0]) === Te(u.value[1] ?? u.value[0]) : !1, m = (w = /* @__PURE__ */ new Date(), Z = !1) => {
    if ((!h.value.count || !h.value.static || Z) && g(0, Te(w), ye(w)), h.value.count && (!u.value || ie() || !h.value.solo) && (!h.value.solo || Z))
      for (let ve = 1; ve < h.value.count; ve++) {
        const xe = Re(B(), { month: he.value(ve - 1), year: y.value(ve - 1) }), Q = ar(xe, { months: 1 });
        x.value[ve] = { month: Te(Q), year: ye(Q) };
      }
  }, I = (w, Z) => {
    m(w), q("hours", Ct(w)), q("minutes", Et(w)), q("seconds", ra(w)), h.value.count && Z && j();
  }, M = (w) => {
    if (h.value.count) {
      if (h.value.solo) return 0;
      const Z = Te(w[0]), ve = Te(w[1]);
      return Math.abs(ve - Z) < h.value.count ? 0 : 1;
    }
    return 1;
  }, re = (w, Z) => {
    w[1] && C.value.showLastInRange ? m(w[M(w)], Z) : m(w[0], Z);
    const ve = (xe, Q) => [
      xe(w[0]),
      w[1] ? xe(w[1]) : f[Q][1]
    ];
    q("hours", ve(Ct, "hours")), q("minutes", ve(Et, "minutes")), q("seconds", ve(ra, "seconds"));
  }, c = (w, Z) => {
    if ((C.value.enabled || e.weekPicker) && !R.value.enabled)
      return re(w, Z);
    if (R.value.enabled && Z) {
      const ve = w[w.length - 1];
      return I(ve, Z);
    }
  }, i = (w) => {
    const Z = u.value;
    c(Z, w), h.value.count && h.value.solo && j();
  }, U = (w, Z) => {
    const ve = Re(B(), { month: he.value(Z), year: y.value(Z) }), xe = w < 0 ? bt(ve, 1) : oa(ve, 1);
    k(Te(xe), ye(xe), w < 0, e.preventMinMaxNavigation) && (g(Z, Te(xe), ye(xe)), t("update-month-year", { instance: Z, month: Te(xe), year: ye(xe) }), h.value.count && !h.value.solo && Pe(Z), n());
  }, Pe = (w) => {
    for (let Z = w - 1; Z >= 0; Z--) {
      const ve = oa(Re(B(), { month: he.value(Z + 1), year: y.value(Z + 1) }), 1);
      g(Z, Te(ve), ye(ve));
    }
    for (let Z = w + 1; Z <= h.value.count - 1; Z++) {
      const ve = bt(Re(B(), { month: he.value(Z - 1), year: y.value(Z - 1) }), 1);
      g(Z, Te(ve), ye(ve));
    }
  }, j = () => {
    if (Array.isArray(u.value) && u.value.length === 2) {
      const w = B(
        B(u.value[1] ? u.value[1] : bt(u.value[0], 1))
      ), [Z, ve] = [Te(u.value[0]), ye(u.value[0])], [xe, Q] = [Te(u.value[1]), ye(u.value[1])];
      (Z !== xe || Z === xe && ve !== Q) && h.value.solo && g(1, Te(w), ye(w));
    } else u.value && !Array.isArray(u.value) && (g(0, Te(u.value), ye(u.value)), m(B()));
  }, we = () => {
    e.startDate && (g(0, Te(B(e.startDate)), ye(B(e.startDate))), h.value.count && Pe(0));
  }, J = (w, Z) => {
    if (e.monthChangeOnScroll) {
      const ve = (/* @__PURE__ */ new Date()).getTime() - l.value.getTime(), xe = Math.abs(w.deltaY);
      let Q = 500;
      xe > 1 && (Q = 100), xe > 100 && (Q = 0), ve > Q && (l.value = /* @__PURE__ */ new Date(), U(e.monthChangeOnScroll !== "inverse" ? -w.deltaY : w.deltaY, Z));
    }
  }, te = (w, Z, ve = !1) => {
    e.monthChangeOnArrows && e.vertical === ve && s(w, Z);
  }, s = (w, Z) => {
    U(w === "right" ? -1 : 1, Z);
  }, le = (w) => {
    if (O.value.markers)
      return Ya(w.value, O.value.markers);
  }, $ = (w, Z) => {
    switch (e.sixWeeks === !0 ? "append" : e.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [w == 0, !0];
      case "fair":
        return [w == 0 || Z > w, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, Me = (w, Z, ve, xe) => {
    if (e.sixWeeks && w.length < 6) {
      const Q = 6 - w.length, ce = (Z.getDay() + 7 - xe) % 7, me = 6 - (ve.getDay() + 7 - xe) % 7, [Pt, Mt] = $(ce, me);
      for (let Ht = 1; Ht <= Q; Ht++)
        if (Mt ? !!(Ht % 2) == Pt : Pt) {
          const Yt = w[0].days[0], Ua = fe(ct(Yt.value, -7), Te(Z));
          w.unshift({ days: Ua });
        } else {
          const Yt = w[w.length - 1], Ua = Yt.days[Yt.days.length - 1], Ur = fe(ct(Ua.value, 1), Te(Z));
          w.push({ days: Ur });
        }
    }
    return w;
  }, fe = (w, Z) => {
    const ve = B(w), xe = [];
    for (let Q = 0; Q < 7; Q++) {
      const ce = ct(ve, Q), me = Te(ce) !== Z;
      xe.push({
        text: e.hideOffsetDates && me ? "" : ce.getDate(),
        value: ce,
        current: !me,
        classData: {}
      });
    }
    return xe;
  }, Ke = (w, Z) => {
    const ve = [], xe = new Date(Z, w), Q = new Date(Z, w + 1, 0), ce = e.weekStart, me = _t(xe, { weekStartsOn: ce }), Pt = (Mt) => {
      const Ht = fe(Mt, w);
      if (ve.push({ days: Ht }), !ve[ve.length - 1].days.some(
        (Yt) => De(Ue(Yt.value), Ue(Q))
      )) {
        const Yt = ct(Mt, 7);
        Pt(Yt);
      }
    };
    return Pt(me), Me(ve, xe, Q, ce);
  }, Le = (w) => {
    const Z = Ft(B(w.value), f.hours, f.minutes, Gt());
    t("date-update", Z), R.value.enabled ? On(Z, u, R.value.limit) : u.value = Z, a(), dt().then(() => {
      K();
    });
  }, mt = (w) => C.value.noDisabledRange ? Cr(r.value[0], w).some((Z) => E(Z)) : !1, A = () => {
    r.value = u.value ? u.value.slice() : [], r.value.length === 2 && !(C.value.fixedStart || C.value.fixedEnd) && (r.value = []);
  }, oe = (w, Z) => {
    const ve = [
      B(w.value),
      ct(B(w.value), +C.value.autoRange)
    ];
    X(ve) ? (Z && de(w.value), r.value = ve) : t("invalid-date", w.value);
  }, de = (w) => {
    const Z = Te(B(w)), ve = ye(B(w));
    if (g(0, Z, ve), h.value.count > 0)
      for (let xe = 1; xe < h.value.count; xe++) {
        const Q = Ms(
          Re(B(w), { year: y.value(xe - 1), month: he.value(xe - 1) })
        );
        g(xe, Q.month, Q.year);
      }
  }, Rt = (w) => {
    if (mt(w.value) || !S(w.value, u.value, C.value.fixedStart ? 0 : 1))
      return t("invalid-date", w.value);
    r.value = Lr(B(w.value), u, t, C);
  }, pt = (w, Z) => {
    if (A(), C.value.autoRange) return oe(w, Z);
    if (C.value.fixedStart || C.value.fixedEnd) return Rt(w);
    r.value[0] ? S(B(w.value), u.value) && !mt(w.value) ? Fe(B(w.value), B(r.value[0])) ? (r.value.unshift(B(w.value)), t("range-end", r.value[0])) : (r.value[1] = B(w.value), t("range-end", r.value[1])) : (e.autoApply && t("auto-apply-invalid", w.value), t("invalid-date", w.value)) : (r.value[0] = B(w.value), t("range-start", r.value[0]));
  }, Gt = (w = !0) => e.enableSeconds ? Array.isArray(f.seconds) ? w ? f.seconds[0] : f.seconds[1] : f.seconds : 0, lt = (w) => {
    r.value[w] = Ft(
      r.value[w],
      f.hours[w],
      f.minutes[w],
      Gt(w !== 1)
    );
  }, Ea = () => {
    r.value[0] && r.value[1] && +r.value?.[0] > +r.value?.[1] && (r.value.reverse(), t("range-start", r.value[0]), t("range-end", r.value[1]));
  }, La = () => {
    r.value.length && (r.value[0] && !r.value[1] ? lt(0) : (lt(0), lt(1), a()), Ea(), u.value = r.value.slice(), Va(r.value, t, e.autoApply, e.modelAuto));
  }, Da = (w, Z = !1) => {
    if (E(w.value) || !w.current && e.hideOffsetDates) return t("invalid-date", w.value);
    if (o.value = JSON.parse(JSON.stringify(w)), !C.value.enabled) return Le(w);
    Kn(f.hours) && Kn(f.minutes) && !R.value.enabled && (pt(w, Z), La());
  }, Ba = (w, Z) => {
    g(w, Z.month, Z.year, !0), h.value.count && !h.value.solo && Pe(w), t("update-month-year", { instance: w, month: Z.month, year: Z.year }), n(h.value.solo ? w : void 0);
    const ve = e.flow?.length ? e.flow[e.flowStep] : void 0;
    !Z.fromNav && (ve === et.month || ve === et.year) && a();
  }, Ha = (w, Z) => {
    Er({
      value: w,
      modelValue: u,
      range: C.value.enabled,
      timezone: Z ? void 0 : P.value.timezone
    }), L(), e.multiCalendars && dt().then(() => T(!0));
  }, Wa = () => {
    const w = xn(B(), P.value);
    !C.value.enabled && !R.value.enabled ? u.value = w : u.value && Array.isArray(u.value) && u.value[0] ? R.value.enabled ? u.value = [...u.value, w] : u.value = Fe(w, u.value[0]) ? [w, u.value[0]] : [u.value[0], w] : u.value = [w], L();
  }, qa = () => {
    if (Array.isArray(u.value))
      if (R.value.enabled) {
        const w = za();
        u.value[u.value.length - 1] = ae(w);
      } else
        u.value = u.value.map((w, Z) => w && ae(w, Z));
    else
      u.value = ae(u.value);
    t("time-update");
  }, za = () => Array.isArray(u.value) && u.value.length ? u.value[u.value.length - 1] : null;
  return {
    calendars: x,
    modelValue: u,
    month: he,
    year: y,
    time: f,
    disabledTimesConfig: ue,
    today: p,
    validateTime: ne,
    getCalendarDays: Ke,
    getMarker: le,
    handleScroll: J,
    handleSwipe: s,
    handleArrow: te,
    selectDate: Da,
    updateMonthYear: Ba,
    presetDate: Ha,
    selectCurrentDate: Wa,
    updateTime: (w, Z = !0, ve = !1) => {
      N(w, Z, ve, qa);
    },
    assignMonthAndYear: m,
    setStartTime: ee
  };
}, Ni = { key: 0 }, Vi = /* @__PURE__ */ Ge({
  __name: "DatePicker",
  props: {
    ...kt
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, r = e, {
      calendars: l,
      month: o,
      year: v,
      modelValue: u,
      time: x,
      disabledTimesConfig: f,
      today: p,
      validateTime: h,
      getCalendarDays: _,
      getMarker: C,
      handleArrow: Y,
      handleScroll: P,
      handleSwipe: O,
      selectDate: R,
      updateMonthYear: k,
      presetDate: E,
      selectCurrentDate: X,
      updateTime: S,
      assignMonthAndYear: N,
      setStartTime: ae
    } = Ii(r, a, ie, m), q = jt(), { setHoverDate: F, getDayClassData: ne, clearHoverDate: ue } = eu(u, r), { defaultedMultiCalendars: he } = Ne(r), y = G([]), b = G([]), g = G(null), L = it(q, "calendar"), ee = it(q, "monthYear"), V = it(q, "timePicker"), K = (J) => {
      r.shadow || a("mount", J);
    };
    ft(
      l,
      () => {
        r.shadow || setTimeout(() => {
          a("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    ), ft(
      he,
      (J, te) => {
        J.count - te.count > 0 && N();
      },
      { deep: !0 }
    );
    const T = W(() => (J) => _(o.value(J), v.value(J)).map((te) => ({
      ...te,
      days: te.days.map((s) => (s.marker = C(s), s.classData = ne(s), s))
    })));
    function ie(J) {
      J || J === 0 ? b.value[J]?.triggerTransition(o.value(J), v.value(J)) : b.value.forEach((te, s) => te.triggerTransition(o.value(s), v.value(s)));
    }
    function m() {
      a("update-flow-step");
    }
    const I = (J, te = !1) => {
      R(J, te), r.spaceConfirm && a("select-date");
    }, M = (J, te, s = 0) => {
      y.value[s]?.toggleMonthPicker(J, te);
    }, re = (J, te, s = 0) => {
      y.value[s]?.toggleYearPicker(J, te);
    }, c = (J, te, s) => {
      g.value?.toggleTimePicker(J, te, s);
    }, i = (J, te) => {
      if (!r.range) {
        const s = u.value ? u.value : p, le = te ? new Date(te) : s, $ = J ? _t(le, { weekStartsOn: 1 }) : ur(le, { weekStartsOn: 1 });
        R({
          value: $,
          current: Te(le) === o.value(0),
          text: "",
          classData: {}
        }), document.getElementById(vn($))?.focus();
      }
    }, U = (J) => {
      y.value[0]?.handleMonthYearChange(J, !0);
    }, Pe = (J) => {
      k(0, { month: o.value(0), year: v.value(0) + (J ? 1 : -1), fromNav: !0 });
    }, j = (J, te) => {
      J === et.time && a(`time-picker-${te ? "open" : "close"}`), a("overlay-toggle", { open: te, overlay: J });
    }, we = (J) => {
      a("overlay-toggle", { open: !1, overlay: J }), a("focus-menu");
    };
    return t({
      clearHoverDate: ue,
      presetDate: E,
      selectCurrentDate: X,
      toggleMonthPicker: M,
      toggleYearPicker: re,
      toggleTimePicker: c,
      handleArrow: Y,
      updateMonthYear: k,
      getSidebarProps: () => ({
        modelValue: u,
        month: o,
        year: v,
        time: x,
        updateTime: S,
        updateMonthYear: k,
        selectDate: R,
        presetDate: E
      }),
      changeMonth: U,
      changeYear: Pe,
      selectWeekDate: i,
      setStartTime: ae
    }), (J, te) => (D(), H(be, null, [
      ut(Na, {
        "multi-calendars": d(he).count,
        collapse: J.collapse,
        "is-mobile": J.isMobile
      }, {
        default: _e(({ instance: s, index: le }) => [
          J.disableMonthYearSelect ? z("", !0) : (D(), Ae(Pi, je({
            key: 0,
            ref: ($) => {
              $ && (y.value[le] = $);
            },
            months: d(xr)(J.formatLocale, J.locale, J.monthNameFormat),
            years: d(Tn)(J.yearRange, J.locale, J.reverseYears),
            month: d(o)(s),
            year: d(v)(s),
            instance: s
          }, J.$props, {
            onMount: te[0] || (te[0] = ($) => K(d(zt).header)),
            onResetFlow: te[1] || (te[1] = ($) => J.$emit("reset-flow")),
            onUpdateMonthYear: ($) => d(k)(s, $),
            onOverlayClosed: we,
            onOverlayOpened: te[2] || (te[2] = ($) => J.$emit("overlay-toggle", { open: !0, overlay: $ }))
          }), at({ _: 2 }, [
            Ie(d(ee), ($, Me) => ({
              name: $,
              fn: _e((fe) => [
                se(J.$slots, $, Qe(ot(fe)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          ut(Si, je({
            ref: ($) => {
              $ && (b.value[le] = $);
            },
            "mapped-dates": T.value(s),
            month: d(o)(s),
            year: d(v)(s),
            instance: s
          }, J.$props, {
            onSelectDate: ($) => d(R)($, s !== 1),
            onHandleSpace: ($) => I($, s !== 1),
            onSetHoverDate: te[3] || (te[3] = ($) => d(F)($)),
            onHandleScroll: ($) => d(P)($, s),
            onHandleSwipe: ($) => d(O)($, s),
            onMount: te[4] || (te[4] = ($) => K(d(zt).calendar)),
            onResetFlow: te[5] || (te[5] = ($) => J.$emit("reset-flow")),
            onTooltipOpen: te[6] || (te[6] = ($) => J.$emit("tooltip-open", $)),
            onTooltipClose: te[7] || (te[7] = ($) => J.$emit("tooltip-close", $))
          }), at({ _: 2 }, [
            Ie(d(L), ($, Me) => ({
              name: $,
              fn: _e((fe) => [
                se(J.$slots, $, Qe(ot({ ...fe })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars", "collapse", "is-mobile"]),
      J.enableTimePicker ? (D(), H("div", Ni, [
        J.$slots["time-picker"] ? se(J.$slots, "time-picker", Qe(je({ key: 0 }, { time: d(x), updateTime: d(S) }))) : (D(), Ae(Hr, je({
          key: 1,
          ref_key: "timePickerRef",
          ref: g
        }, J.$props, {
          hours: d(x).hours,
          minutes: d(x).minutes,
          seconds: d(x).seconds,
          "internal-model-value": J.internalModelValue,
          "disabled-times-config": d(f),
          "validate-time": d(h),
          onMount: te[8] || (te[8] = (s) => K(d(zt).timePicker)),
          "onUpdate:hours": te[9] || (te[9] = (s) => d(S)(s)),
          "onUpdate:minutes": te[10] || (te[10] = (s) => d(S)(s, !1)),
          "onUpdate:seconds": te[11] || (te[11] = (s) => d(S)(s, !1, !0)),
          onResetFlow: te[12] || (te[12] = (s) => J.$emit("reset-flow")),
          onOverlayClosed: te[13] || (te[13] = (s) => j(s, !1)),
          onOverlayOpened: te[14] || (te[14] = (s) => j(s, !0)),
          onAmPmChange: te[15] || (te[15] = (s) => J.$emit("am-pm-change", s))
        }), at({ _: 2 }, [
          Ie(d(V), (s, le) => ({
            name: s,
            fn: _e(($) => [
              se(J.$slots, s, Qe(ot($)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : z("", !0)
    ], 64));
  }
}), Fi = (e, t) => {
  const n = G(), {
    defaultedMultiCalendars: a,
    defaultedConfig: r,
    defaultedHighlight: l,
    defaultedRange: o,
    propDates: v,
    defaultedFilters: u,
    defaultedMultiDates: x
  } = Ne(e), { modelValue: f, year: p, month: h, calendars: _ } = Ta(e, t), { isDisabled: C } = Bt(e), { selectYear: Y, groupedYears: P, showYearPicker: O, isDisabled: R, toggleYearPicker: k, handleYearSelect: E, handleYear: X } = Br({
    modelValue: f,
    multiCalendars: a,
    range: o,
    highlight: l,
    calendars: _,
    propDates: v,
    month: h,
    year: p,
    filters: u,
    props: e,
    emit: t
  }), S = (b, g) => [b, g].map((L) => Dt(L, "MMMM", { locale: e.formatLocale })).join("-"), N = W(() => (b) => f.value ? Array.isArray(f.value) ? f.value.some((g) => Wn(b, g)) : Wn(f.value, b) : !1), ae = (b) => {
    if (o.value.enabled) {
      if (Array.isArray(f.value)) {
        const g = De(b, f.value[0]) || De(b, f.value[1]);
        return ba(f.value, n.value, b) && !g;
      }
      return !1;
    }
    return !1;
  }, q = (b, g) => b.quarter === Vn(g) && b.year === ye(g), F = (b) => typeof l.value == "function" ? l.value({ quarter: Vn(b), year: ye(b) }) : !!l.value.quarters.find((g) => q(g, b)), ne = W(() => (b) => {
    const g = Re(/* @__PURE__ */ new Date(), { year: p.value(b) });
    return vl({
      start: ta(g),
      end: ir(g)
    }).map((L) => {
      const ee = qt(L), V = Fn(L), K = C(L), T = ae(ee), ie = F(ee);
      return {
        text: S(ee, V),
        value: ee,
        active: N.value(ee),
        highlighted: ie,
        disabled: K,
        isBetween: T
      };
    });
  }), ue = (b) => {
    On(b, f, x.value.limit), t("auto-apply", !0);
  }, he = (b) => {
    f.value = Cn(f, b, t), Va(f.value, t, e.autoApply, e.modelAuto);
  }, y = (b) => {
    f.value = b, t("auto-apply");
  };
  return {
    defaultedConfig: r,
    defaultedMultiCalendars: a,
    groupedYears: P,
    year: p,
    isDisabled: R,
    quarters: ne,
    showYearPicker: O,
    modelValue: f,
    setHoverDate: (b) => {
      n.value = b;
    },
    selectYear: Y,
    selectQuarter: (b, g, L) => {
      if (!L)
        return _.value[g].month = Te(Fn(b)), x.value.enabled ? ue(b) : o.value.enabled ? he(b) : y(b);
    },
    toggleYearPicker: k,
    handleYearSelect: E,
    handleYear: X
  };
}, Ei = { class: "dp--quarter-items" }, Li = ["data-test-id", "disabled", "onClick", "onMouseover"], Bi = /* @__PURE__ */ Ge({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...kt
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end",
    "overlay-toggle",
    "update-month-year"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, r = e, l = jt(), o = it(l, "yearMode"), {
      defaultedMultiCalendars: v,
      defaultedConfig: u,
      groupedYears: x,
      year: f,
      isDisabled: p,
      quarters: h,
      modelValue: _,
      showYearPicker: C,
      setHoverDate: Y,
      selectQuarter: P,
      toggleYearPicker: O,
      handleYearSelect: R,
      handleYear: k
    } = Fi(r, a);
    return t({ getSidebarProps: () => ({
      modelValue: _,
      year: f,
      selectQuarter: P,
      handleYearSelect: R,
      handleYear: k
    }) }), (E, X) => (D(), Ae(Na, {
      "multi-calendars": d(v).count,
      collapse: E.collapse,
      stretch: "",
      "is-mobile": E.isMobile
    }, {
      default: _e(({ instance: S }) => [
        ge("div", {
          class: "dp-quarter-picker-wrap",
          style: vt({ minHeight: `${d(u).modeHeight}px` })
        }, [
          E.$slots["top-extra"] ? se(E.$slots, "top-extra", {
            key: 0,
            value: E.internalModelValue
          }) : z("", !0),
          ge("div", null, [
            ut(Fr, je(E.$props, {
              items: d(x)(S),
              instance: S,
              "show-year-picker": d(C)[S],
              year: d(f)(S),
              "is-disabled": (N) => d(p)(S, N),
              onHandleYear: (N) => d(k)(S, N),
              onYearSelect: (N) => d(R)(N, S),
              onToggleYearPicker: (N) => d(O)(S, N?.flow, N?.show)
            }), at({ _: 2 }, [
              Ie(d(o), (N, ae) => ({
                name: N,
                fn: _e((q) => [
                  se(E.$slots, N, Qe(ot(q)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          ge("div", Ei, [
            (D(!0), H(be, null, Ie(d(h)(S), (N, ae) => (D(), H("div", { key: ae }, [
              ge("button", {
                type: "button",
                class: ke(["dp--qr-btn", {
                  "dp--qr-btn-active": N.active,
                  "dp--qr-btn-between": N.isBetween,
                  "dp--qr-btn-disabled": N.disabled,
                  "dp--highlighted": N.highlighted
                }]),
                "data-test-id": N.value,
                disabled: N.disabled,
                onClick: (q) => d(P)(N.value, S, N.disabled),
                onMouseover: (q) => d(Y)(N.value)
              }, [
                E.$slots.quarter ? se(E.$slots, "quarter", {
                  key: 0,
                  value: N.value,
                  text: N.text
                }) : (D(), H(be, { key: 1 }, [
                  Ot(tt(N.text), 1)
                ], 64))
              ], 42, Li)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), qr = (e, t) => {
  const n = G(0);
  Je(() => {
    a(), window.addEventListener("resize", a, { passive: !0 });
  }), ua(() => {
    window.removeEventListener("resize", a);
  });
  const a = () => {
    n.value = window.document.documentElement.clientWidth;
  };
  return {
    isMobile: W(
      () => n.value <= e.value.mobileBreakpoint && !t ? !0 : void 0
    )
  };
}, Hi = ["id", "tabindex", "role", "aria-label"], Wi = {
  key: 0,
  class: "dp--menu-load-container"
}, qi = {
  key: 1,
  class: "dp--menu-header"
}, zi = ["data-dp-mobile"], Ui = {
  key: 0,
  class: "dp__sidebar_left"
}, Xi = ["data-dp-mobile"], ji = ["data-test-id", "data-dp-mobile", "onClick", "onKeydown"], Qi = {
  key: 2,
  class: "dp__sidebar_right"
}, Gi = {
  key: 3,
  class: "dp__action_extra"
}, Zn = /* @__PURE__ */ Ge({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...Ia,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    noOverlayFocus: { type: Boolean, default: !1 },
    collapse: { type: Boolean, default: !1 },
    getInputRect: { type: Function, default: () => ({}) },
    isTextInputDate: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "menu-blur"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, r = e, l = G(null), o = W(() => {
      const { openOnTop: A, ...oe } = r;
      return {
        ...oe,
        isMobile: P.value,
        flowStep: he.value,
        menuWrapRef: l.value
      };
    }), { setMenuFocused: v, setShiftKey: u, control: x } = Vr(), f = jt(), { defaultedTextInput: p, defaultedInline: h, defaultedConfig: _, defaultedUI: C, handleEventPropagation: Y } = Ne(r), { isMobile: P } = qr(_, r.shadow), O = G(null), R = G(0), k = G(null), E = G(!1), X = G(null), S = G(!1), N = (A) => {
      S.value = !0, _.value.allowPreventDefault && A.preventDefault(), Vt(A, _.value, !0);
    };
    Je(() => {
      if (!r.shadow) {
        E.value = !0, ae(), window.addEventListener("resize", ae);
        const A = ze(l);
        A && !p.value.enabled && !h.value.enabled && (v(!0), K()), A && (A.addEventListener("pointerdown", N), A.addEventListener("mousedown", N));
      }
      document.addEventListener("mousedown", mt);
    }), ua(() => {
      window.removeEventListener("resize", ae), document.removeEventListener("mousedown", mt);
      const A = ze(l);
      A && (A.removeEventListener("pointerdown", N), A.removeEventListener("mousedown", N));
    });
    const ae = () => {
      const A = ze(k);
      A && (R.value = A.getBoundingClientRect().width);
    }, { arrowRight: q, arrowLeft: F, arrowDown: ne, arrowUp: ue } = Lt(), { flowStep: he, updateFlowStep: y, childMount: b, resetFlow: g, handleFlow: L } = tu(r, a, X), ee = W(() => r.monthPicker ? li : r.yearPicker ? si : r.timePicker ? _i : r.quarterPicker ? Bi : Vi), V = W(() => {
      if (_.value.arrowLeft) return _.value.arrowLeft;
      const A = l.value?.getBoundingClientRect(), oe = r.getInputRect();
      return oe?.width < R?.value && oe?.left <= (A?.left ?? 0) ? `${oe?.width / 2}px` : oe?.right >= (A?.right ?? 0) && oe?.width < R?.value ? `${R?.value - oe?.width / 2}px` : "50%";
    }), K = () => {
      const A = ze(l);
      A && A.focus({ preventScroll: !0 });
    }, T = W(() => X.value?.getSidebarProps() || {}), ie = () => {
      r.openOnTop && a("recalculate-position");
    }, m = it(f, "action"), I = W(() => r.monthPicker || r.yearPicker ? it(f, "monthYear") : r.timePicker ? it(f, "timePicker") : it(f, "shared")), M = W(() => r.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), re = W(() => ({
      dp__menu_disabled: r.disabled,
      dp__menu_readonly: r.readonly,
      "dp-menu-loading": r.loading
    })), c = W(
      () => ({
        dp__menu: !0,
        dp__menu_index: !h.value.enabled,
        dp__relative: h.value.enabled,
        ...C.value.menu ?? {}
      })
    ), i = (A) => {
      Vt(A, _.value, !0);
    }, U = (A) => {
      r.escClose && (a("close-picker"), Y(A));
    }, Pe = (A) => {
      if (r.arrowNavigation) {
        if (A === nt.up) return ue();
        if (A === nt.down) return ne();
        if (A === nt.left) return F();
        if (A === nt.right) return q();
      } else A === nt.left || A === nt.up ? s("handleArrow", nt.left, 0, A === nt.up) : s("handleArrow", nt.right, 0, A === nt.down);
    }, j = (A) => {
      u(A.shiftKey), !r.disableMonthYearSelect && A.code === Se.tab && A.target.classList.contains("dp__menu") && x.value.shiftKeyInMenu && (A.preventDefault(), Vt(A, _.value, !0), a("close-picker"));
    }, we = () => {
      K(), a("time-picker-close");
    }, J = (A) => {
      X.value?.toggleTimePicker(!1, !1), X.value?.toggleMonthPicker(!1, !1, A), X.value?.toggleYearPicker(!1, !1, A);
    }, te = (A, oe = 0) => A === "month" ? X.value?.toggleMonthPicker(!1, !0, oe) : A === "year" ? X.value?.toggleYearPicker(!1, !0, oe) : A === "time" ? X.value?.toggleTimePicker(!0, !1) : J(oe), s = (A, ...oe) => {
      X.value?.[A] && X.value?.[A](...oe);
    }, le = () => {
      s("selectCurrentDate");
    }, $ = (A, oe) => {
      s("presetDate", Jr(A), oe);
    }, Me = () => {
      s("clearHoverDate");
    }, fe = (A, oe) => {
      s("updateMonthYear", A, oe);
    }, Ke = (A, oe) => {
      A.preventDefault(), Pe(oe);
    }, Le = (A) => {
      if (j(A), A.key === Se.home || A.key === Se.end)
        return s(
          "selectWeekDate",
          A.key === Se.home,
          A.target.getAttribute("id")
        );
      switch ((A.key === Se.pageUp || A.key === Se.pageDown) && (A.shiftKey ? (s("changeYear", A.key === Se.pageUp), dn(l.value, "overlay-year")?.focus()) : (s("changeMonth", A.key === Se.pageUp), dn(l.value, A.key === Se.pageUp ? "action-prev" : "action-next")?.focus()), A.target.getAttribute("id") && l.value?.focus({ preventScroll: !0 })), A.key) {
        case Se.esc:
          return U(A);
        case Se.arrowLeft:
          return Ke(A, nt.left);
        case Se.arrowRight:
          return Ke(A, nt.right);
        case Se.arrowUp:
          return Ke(A, nt.up);
        case Se.arrowDown:
          return Ke(A, nt.down);
        default:
          return;
      }
    }, mt = (A) => {
      h.value.enabled && !h.value.input && !l.value?.contains(A.target) && S.value && (S.value = !1, a("menu-blur"));
    };
    return t({
      updateMonthYear: fe,
      switchView: te,
      handleFlow: L,
      onValueCleared: () => {
        X.value?.setStartTime?.();
      }
    }), (A, oe) => (D(), H("div", {
      id: A.uid ? `dp-menu-${A.uid}` : void 0,
      ref_key: "dpMenuRef",
      ref: l,
      tabindex: d(h).enabled ? void 0 : "0",
      role: d(h).enabled ? void 0 : "dialog",
      "aria-label": A.ariaLabels?.menu,
      class: ke(c.value),
      style: vt({ "--dp-arrow-left": V.value }),
      onMouseleave: Me,
      onClick: i,
      onKeydown: Le
    }, [
      (A.disabled || A.readonly) && d(h).enabled || A.loading ? (D(), H("div", {
        key: 0,
        class: ke(re.value)
      }, [
        A.loading ? (D(), H("div", Wi, [...oe[19] || (oe[19] = [
          ge("span", { class: "dp--menu-loader" }, null, -1)
        ])])) : z("", !0)
      ], 2)) : z("", !0),
      A.$slots["menu-header"] ? (D(), H("div", qi, [
        se(A.$slots, "menu-header")
      ])) : z("", !0),
      !d(h).enabled && !A.teleportCenter ? (D(), H("div", {
        key: 2,
        class: ke(M.value)
      }, null, 2)) : z("", !0),
      ge("div", {
        ref_key: "innerMenuRef",
        ref: k,
        class: ke({
          dp__menu_content_wrapper: A.presetDates?.length || !!A.$slots["left-sidebar"] || !!A.$slots["right-sidebar"],
          "dp--menu-content-wrapper-collapsed": e.collapse && (A.presetDates?.length || !!A.$slots["left-sidebar"] || !!A.$slots["right-sidebar"])
        }),
        "data-dp-mobile": d(P),
        style: vt({ "--dp-menu-width": `${R.value}px` })
      }, [
        A.$slots["left-sidebar"] ? (D(), H("div", Ui, [
          se(A.$slots, "left-sidebar", Qe(ot(T.value)))
        ])) : z("", !0),
        A.presetDates.length ? (D(), H("div", {
          key: 1,
          class: ke({ "dp--preset-dates-collapsed": e.collapse, "dp--preset-dates": !0 }),
          "data-dp-mobile": d(P)
        }, [
          (D(!0), H(be, null, Ie(A.presetDates, (de, Rt) => (D(), H(be, { key: Rt }, [
            de.slot ? se(A.$slots, de.slot, {
              key: 0,
              presetDate: $,
              label: de.label,
              value: de.value
            }) : (D(), H("button", {
              key: 1,
              type: "button",
              style: vt(de.style || {}),
              class: ke(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": e.collapse }]),
              "data-test-id": de.testId ?? void 0,
              "data-dp-mobile": d(P),
              onClick: ga((pt) => $(de.value, de.noTz), ["prevent"]),
              onKeydown: (pt) => d(rt)(pt, () => $(de.value, de.noTz), !0)
            }, tt(de.label), 47, ji))
          ], 64))), 128))
        ], 10, Xi)) : z("", !0),
        ge("div", {
          ref_key: "calendarWrapperRef",
          ref: O,
          class: "dp__instance_calendar",
          role: "document"
        }, [
          (D(), Ae(Sa(ee.value), je({
            ref_key: "dynCmpRef",
            ref: X
          }, o.value, {
            "flow-step": d(he),
            onMount: d(b),
            onUpdateFlowStep: d(y),
            onResetFlow: d(g),
            onFocusMenu: K,
            onSelectDate: oe[0] || (oe[0] = (de) => A.$emit("select-date")),
            onDateUpdate: oe[1] || (oe[1] = (de) => A.$emit("date-update", de)),
            onTooltipOpen: oe[2] || (oe[2] = (de) => A.$emit("tooltip-open", de)),
            onTooltipClose: oe[3] || (oe[3] = (de) => A.$emit("tooltip-close", de)),
            onAutoApply: oe[4] || (oe[4] = (de) => A.$emit("auto-apply", de)),
            onRangeStart: oe[5] || (oe[5] = (de) => A.$emit("range-start", de)),
            onRangeEnd: oe[6] || (oe[6] = (de) => A.$emit("range-end", de)),
            onInvalidFixedRange: oe[7] || (oe[7] = (de) => A.$emit("invalid-fixed-range", de)),
            onTimeUpdate: oe[8] || (oe[8] = (de) => A.$emit("time-update")),
            onAmPmChange: oe[9] || (oe[9] = (de) => A.$emit("am-pm-change", de)),
            onTimePickerOpen: oe[10] || (oe[10] = (de) => A.$emit("time-picker-open", de)),
            onTimePickerClose: we,
            onRecalculatePosition: ie,
            onUpdateMonthYear: oe[11] || (oe[11] = (de) => A.$emit("update-month-year", de)),
            onAutoApplyInvalid: oe[12] || (oe[12] = (de) => A.$emit("auto-apply-invalid", de)),
            onInvalidDate: oe[13] || (oe[13] = (de) => A.$emit("invalid-date", de)),
            onOverlayToggle: oe[14] || (oe[14] = (de) => A.$emit("overlay-toggle", de)),
            "onUpdate:internalModelValue": oe[15] || (oe[15] = (de) => A.$emit("update:internal-model-value", de))
          }), at({ _: 2 }, [
            Ie(I.value, (de, Rt) => ({
              name: de,
              fn: _e((pt) => [
                se(A.$slots, de, Qe(ot({ ...pt })))
              ])
            }))
          ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
        ], 512),
        A.$slots["right-sidebar"] ? (D(), H("div", Qi, [
          se(A.$slots, "right-sidebar", Qe(ot(T.value)))
        ])) : z("", !0),
        A.$slots["action-extra"] ? (D(), H("div", Gi, [
          A.$slots["action-extra"] ? se(A.$slots, "action-extra", {
            key: 0,
            selectCurrentDate: le
          }) : z("", !0)
        ])) : z("", !0)
      ], 14, zi),
      !A.autoApply || d(_).keepActionRow ? (D(), Ae(Gs, je({
        key: 3,
        "menu-mount": E.value
      }, o.value, {
        "calendar-width": R.value,
        onClosePicker: oe[16] || (oe[16] = (de) => A.$emit("close-picker")),
        onSelectDate: oe[17] || (oe[17] = (de) => A.$emit("select-date")),
        onInvalidSelect: oe[18] || (oe[18] = (de) => A.$emit("invalid-select")),
        onSelectNow: le
      }), at({ _: 2 }, [
        Ie(d(m), (de, Rt) => ({
          name: de,
          fn: _e((pt) => [
            se(A.$slots, de, Qe(ot({ ...pt })))
          ])
        }))
      ]), 1040, ["menu-mount", "calendar-width"])) : z("", !0)
    ], 46, Hi));
  }
});
var Zt = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(Zt || {});
const Ji = ({
  menuRef: e,
  menuRefInner: t,
  inputRef: n,
  pickerWrapperRef: a,
  inline: r,
  emit: l,
  props: o,
  slots: v
}) => {
  const { defaultedConfig: u } = Ne(o), x = G({}), f = G(!1), p = G({
    top: "0",
    left: "0"
  }), h = G(!1), _ = ya(o, "teleportCenter");
  ft(_, () => {
    p.value = JSON.parse(JSON.stringify({})), X();
  });
  const C = (g) => {
    if (o.teleport) {
      const L = g.getBoundingClientRect();
      return {
        left: L.left + window.scrollX,
        top: L.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, Y = (g, L) => {
    p.value.left = `${g + L - x.value.width}px`;
  }, P = (g) => {
    p.value.left = `${g}px`;
  }, O = (g, L) => {
    o.position === Zt.left && P(g), o.position === Zt.right && Y(g, L), o.position === Zt.center && (p.value.left = `${g + L / 2 - x.value.width / 2}px`);
  }, R = (g) => {
    const { width: L, height: ee } = g.getBoundingClientRect(), { top: V, left: K } = C(g);
    return { top: +V, left: +K, width: L, height: ee };
  }, k = () => {
    p.value.left = "50%", p.value.top = "50%", p.value.transform = "translate(-50%, -50%)", p.value.position = "fixed", delete p.value.opacity;
  }, E = () => {
    const g = ze(n);
    p.value = o.altPosition(g);
  }, X = (g = !0) => {
    if (!r.value.enabled) {
      if (_.value) return k();
      if (o.altPosition !== null) return E();
      if (g) {
        const L = o.teleport ? t.value?.$el : e.value;
        L && (x.value = L.getBoundingClientRect()), l("recalculate-position");
      }
      return ue();
    }
  }, S = ({ inputEl: g, left: L, width: ee }) => {
    window.screen.width > 768 && !f.value && O(L, ee), q(g);
  }, N = (g) => {
    const { top: L, left: ee, height: V, width: K } = R(g);
    p.value.top = `${V + L + +o.offset}px`, h.value = !1, f.value || (p.value.left = `${ee + K / 2 - x.value.width / 2}px`), S({ inputEl: g, left: ee, width: K });
  }, ae = (g) => {
    const { top: L, left: ee, width: V } = R(g);
    p.value.top = `${L - +o.offset - x.value.height}px`, h.value = !0, S({ inputEl: g, left: ee, width: V });
  }, q = (g) => {
    if (o.autoPosition) {
      const { left: L, width: ee } = R(g), { left: V, right: K } = x.value;
      if (!f.value) {
        if (Math.abs(V) !== Math.abs(K)) {
          if (V <= 0)
            return f.value = !0, P(L);
          if (K >= document.documentElement.clientWidth)
            return f.value = !0, Y(L, ee);
        }
        return O(L, ee);
      }
    }
  }, F = () => {
    const g = ze(n);
    if (g) {
      if (o.autoPosition === yt.top) return yt.top;
      if (o.autoPosition === yt.bottom) return yt.bottom;
      const { height: L } = x.value, { top: ee, height: V } = g.getBoundingClientRect(), K = window.innerHeight - ee - V, T = ee;
      return L <= K ? yt.bottom : L > K && L <= T ? yt.top : K >= T ? yt.bottom : yt.top;
    }
    return yt.bottom;
  }, ne = (g) => F() === yt.bottom ? N(g) : ae(g), ue = () => {
    const g = ze(n);
    if (g)
      return o.autoPosition ? ne(g) : N(g);
  }, he = function(g) {
    if (g) {
      const L = g.scrollHeight > g.clientHeight, ee = window.getComputedStyle(g).overflowY.indexOf("hidden") !== -1;
      return L && !ee;
    }
    return !0;
  }, y = function(g) {
    return !g || g === document.body || g.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : he(g) ? g : y(
      g.assignedSlot && u.value.shadowDom ? g.assignedSlot.parentNode : g.parentNode
    );
  }, b = (g) => {
    if (g)
      switch (o.position) {
        case Zt.left:
          return { left: 0, transform: "translateX(0)" };
        case Zt.right:
          return { left: `${g.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${g.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: h,
    menuStyle: p,
    xCorrect: f,
    setMenuPosition: X,
    getScrollableParent: y,
    shadowRender: (g, L, ee) => {
      const V = document.createElement("div"), K = ze(n)?.getBoundingClientRect();
      V.setAttribute("id", "dp--temp-container");
      const T = a.value?.clientWidth ? a.value : document.body;
      T.append(V);
      const ie = b(K), m = u.value.shadowDom ? Object.keys(v).filter(
        (M) => ["right-sidebar", "left-sidebar", "top-extra", "action-extra"].includes(M)
      ) : Object.keys(v), I = Qr(
        L,
        {
          ...ee,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...ie }
        },
        Object.fromEntries(m.map((M) => [M, v[M]]))
      );
      g != null && (I.appContext = g.appContext), Yn(I, V), x.value = I.el?.getBoundingClientRect(), Yn(null, V), T.removeChild(V);
    }
  };
}, It = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] },
  { name: "top-extra", use: ["shared", "month-year"] },
  { name: "tp-inline-arrow-up", use: ["shared", "time"] },
  { name: "tp-inline-arrow-down", use: ["shared", "time"] },
  { name: "menu-header", use: ["menu"] }
], Ki = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], Zi = {
  all: () => It,
  monthYear: () => It.filter((e) => e.use.includes("month-year")),
  input: () => Ki,
  timePicker: () => It.filter((e) => e.use.includes("time")),
  action: () => It.filter((e) => e.use.includes("action")),
  calendar: () => It.filter((e) => e.use.includes("calendar")),
  menu: () => It.filter((e) => e.use.includes("menu")),
  shared: () => It.filter((e) => e.use.includes("shared")),
  yearMode: () => It.filter((e) => e.use.includes("year-mode"))
}, it = (e, t, n) => {
  const a = [];
  return Zi[t]().forEach((r) => {
    e[r.name] && a.push(r.name);
  }), n?.length && n.forEach((r) => {
    r.slot && a.push(r.slot);
  }), a;
}, xa = (e) => {
  const t = W(() => (a) => e.value ? a ? e.value.open : e.value.close : ""), n = W(() => (a) => e.value ? a ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: t, showTransition: !!e.value, menuTransition: n };
}, Ta = (e, t, n) => {
  const { defaultedRange: a, defaultedTz: r } = Ne(e), l = B(st(B(), r.value.timezone)), o = G([{ month: Te(l), year: ye(l) }]), v = (h) => {
    const _ = {
      hours: Ct(l),
      minutes: Et(l),
      seconds: 0
    };
    return a.value.enabled ? [_[h], _[h]] : _[h];
  }, u = _a({
    hours: v("hours"),
    minutes: v("minutes"),
    seconds: v("seconds")
  });
  ft(
    a,
    (h, _) => {
      h.enabled !== _.enabled && (u.hours = v("hours"), u.minutes = v("minutes"), u.seconds = v("seconds"));
    },
    { deep: !0 }
  );
  const x = W({
    get: () => e.internalModelValue,
    set: (h) => {
      !e.readonly && !e.disabled && t("update:internal-model-value", h);
    }
  }), f = W(
    () => (h) => o.value[h] ? o.value[h].month : 0
  ), p = W(
    () => (h) => o.value[h] ? o.value[h].year : 0
  );
  return ft(
    x,
    (h, _) => {
      n && JSON.stringify(h ?? {}) !== JSON.stringify(_ ?? {}) && n();
    },
    { deep: !0 }
  ), {
    calendars: o,
    time: u,
    modelValue: x,
    month: f,
    year: p,
    today: l
  };
}, eu = (e, t) => {
  const {
    defaultedMultiCalendars: n,
    defaultedMultiDates: a,
    defaultedUI: r,
    defaultedHighlight: l,
    defaultedTz: o,
    propDates: v,
    defaultedRange: u
  } = Ne(t), { isDisabled: x } = Bt(t), f = G(null), p = G(st(/* @__PURE__ */ new Date(), o.value.timezone)), h = (c) => {
    !c.current && t.hideOffsetDates || (f.value = c.value);
  }, _ = () => {
    f.value = null;
  }, C = (c) => Array.isArray(e.value) && u.value.enabled && e.value[0] && f.value ? c ? He(f.value, e.value[0]) : Fe(f.value, e.value[0]) : !0, Y = (c, i) => {
    const U = () => e.value ? i ? e.value[0] || null : e.value[1] : null, Pe = e.value && Array.isArray(e.value) ? U() : null;
    return De(B(c.value), Pe);
  }, P = (c) => {
    const i = Array.isArray(e.value) ? e.value[0] : null;
    return c ? !Fe(f.value ?? null, i) : !0;
  }, O = (c, i = !0) => (u.value.enabled || t.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? t.hideOffsetDates && !c.current ? !1 : De(B(c.value), e.value[i ? 0 : 1]) : u.value.enabled ? Y(c, i) && P(i) || De(c.value, Array.isArray(e.value) ? e.value[0] : null) && C(i) : !1, R = (c, i) => {
    if (Array.isArray(e.value) && e.value[0] && e.value.length === 1) {
      const U = De(c.value, f.value);
      return i ? He(e.value[0], c.value) && U : Fe(e.value[0], c.value) && U;
    }
    return !1;
  }, k = (c) => !e.value || t.hideOffsetDates && !c.current ? !1 : u.value.enabled ? t.modelAuto && Array.isArray(e.value) ? De(c.value, e.value[0] ? e.value[0] : p.value) : !1 : a.value.enabled && Array.isArray(e.value) ? e.value.some((i) => De(i, c.value)) : De(c.value, e.value ? e.value : p.value), E = (c) => {
    if (u.value.autoRange || t.weekPicker) {
      if (f.value) {
        if (t.hideOffsetDates && !c.current) return !1;
        const i = ct(f.value, +u.value.autoRange), U = At(B(f.value), t.weekStart);
        return t.weekPicker ? De(U[1], B(c.value)) : De(i, B(c.value));
      }
      return !1;
    }
    return !1;
  }, X = (c) => {
    if (u.value.autoRange || t.weekPicker) {
      if (f.value) {
        const i = ct(f.value, +u.value.autoRange);
        if (t.hideOffsetDates && !c.current) return !1;
        const U = At(B(f.value), t.weekStart);
        return t.weekPicker ? He(c.value, U[0]) && Fe(c.value, U[1]) : He(c.value, f.value) && Fe(c.value, i);
      }
      return !1;
    }
    return !1;
  }, S = (c) => {
    if (u.value.autoRange || t.weekPicker) {
      if (f.value) {
        if (t.hideOffsetDates && !c.current) return !1;
        const i = At(B(f.value), t.weekStart);
        return t.weekPicker ? De(i[0], c.value) : De(f.value, c.value);
      }
      return !1;
    }
    return !1;
  }, N = (c) => ba(e.value, f.value, c.value), ae = () => t.modelAuto && Array.isArray(t.internalModelValue) ? !!t.internalModelValue[0] : !1, q = () => t.modelAuto ? Tr(t.internalModelValue) : !0, F = (c) => {
    if (t.weekPicker) return !1;
    const i = u.value.enabled ? !O(c) && !O(c, !1) : !0;
    return !x(c.value) && !k(c) && !(!c.current && t.hideOffsetDates) && i;
  }, ne = (c) => u.value.enabled ? t.modelAuto ? ae() && k(c) : !1 : k(c), ue = (c) => l.value ? ws(c.value, v.value.highlight) : !1, he = (c) => {
    const i = x(c.value);
    return i && (typeof l.value == "function" ? !l.value(c.value, i) : !l.value.options.highlightDisabled);
  }, y = (c) => typeof l.value == "function" ? l.value(c.value) : l.value.weekdays?.includes(c.value.getDay()), b = (c) => (u.value.enabled || t.weekPicker) && (!(n.value.count > 0) || c.current) && q() && !(!c.current && t.hideOffsetDates) && !k(c) ? N(c) : !1, g = (c) => {
    if (Array.isArray(e.value) && e.value.length === 1) {
      const { before: i, after: U } = Qn(+u.value.maxRange, e.value[0]);
      return la(c.value, i) || Xt(c.value, U);
    }
    return !1;
  }, L = (c) => {
    if (Array.isArray(e.value) && e.value.length === 1) {
      const { before: i, after: U } = Qn(+u.value.minRange, e.value[0]);
      return ba([i, U], e.value[0], c.value);
    }
    return !1;
  }, ee = (c) => u.value.enabled && (u.value.maxRange || u.value.minRange) ? u.value.maxRange && u.value.minRange ? g(c) || L(c) : u.value.maxRange ? g(c) : L(c) : !1, V = (c) => {
    const { isRangeStart: i, isRangeEnd: U } = m(c), Pe = u.value.enabled ? i || U : !1;
    return {
      dp__cell_offset: !c.current,
      dp__pointer: !t.disabled && !(!c.current && t.hideOffsetDates) && !x(c.value) && !ee(c),
      dp__cell_disabled: x(c.value) || ee(c),
      dp__cell_highlight: !he(c) && (ue(c) || y(c)) && !ne(c) && !Pe && !S(c) && !(b(c) && t.weekPicker) && !U,
      dp__cell_highlight_active: !he(c) && (ue(c) || y(c)) && ne(c),
      dp__today: !t.noToday && De(c.value, p.value) && c.current,
      "dp--past": Fe(c.value, p.value),
      "dp--future": He(c.value, p.value)
    };
  }, K = (c) => ({
    dp__active_date: ne(c),
    dp__date_hover: F(c)
  }), T = (c) => {
    if (e.value && !Array.isArray(e.value)) {
      const i = At(e.value, t.weekStart);
      return {
        ...M(c),
        dp__range_start: De(i[0], c.value),
        dp__range_end: De(i[1], c.value),
        dp__range_between_week: He(c.value, i[0]) && Fe(c.value, i[1])
      };
    }
    return {
      ...M(c)
    };
  }, ie = (c) => {
    if (e.value && Array.isArray(e.value)) {
      const i = At(e.value[0], t.weekStart), U = e.value[1] ? At(e.value[1], t.weekStart) : [];
      return {
        ...M(c),
        dp__range_start: De(i[0], c.value) || De(U[0], c.value),
        dp__range_end: De(i[1], c.value) || De(U[1], c.value),
        dp__range_between_week: He(c.value, i[0]) && Fe(c.value, i[1]) || He(c.value, U[0]) && Fe(c.value, U[1]),
        dp__range_between: He(c.value, i[1]) && Fe(c.value, U[0])
      };
    }
    return {
      ...M(c)
    };
  }, m = (c) => {
    const i = n.value.count > 0 ? c.current && O(c) && q() : O(c) && q(), U = n.value.count > 0 ? c.current && O(c, !1) && q() : O(c, !1) && q();
    return { isRangeStart: i, isRangeEnd: U };
  }, I = (c) => {
    const { isRangeStart: i, isRangeEnd: U } = m(c);
    return {
      dp__range_start: i,
      dp__range_end: U,
      dp__range_between: b(c),
      dp__date_hover: De(c.value, f.value) && !i && !U && !t.weekPicker,
      dp__date_hover_start: R(c, !0),
      dp__date_hover_end: R(c, !1)
    };
  }, M = (c) => ({
    ...I(c),
    dp__cell_auto_range: X(c),
    dp__cell_auto_range_start: S(c),
    dp__cell_auto_range_end: E(c)
  }), re = (c) => u.value.enabled ? u.value.autoRange ? M(c) : t.modelAuto ? { ...K(c), ...I(c) } : t.weekPicker ? ie(c) : I(c) : t.weekPicker ? T(c) : K(c);
  return {
    setHoverDate: h,
    clearHoverDate: _,
    getDayClassData: (c) => t.hideOffsetDates && !c.current ? {} : {
      ...V(c),
      ...re(c),
      [t.dayClass ? t.dayClass(c.value, t.internalModelValue) : ""]: !0,
      ...r.value.calendarCell ?? {}
    }
  };
}, Bt = (e) => {
  const { defaultedFilters: t, defaultedRange: n, propDates: a, defaultedMultiDates: r } = Ne(e), l = (y) => a.value.disabledDates ? typeof a.value.disabledDates == "function" ? a.value.disabledDates(B(y)) : !!Ya(y, a.value.disabledDates) : !1, o = (y) => a.value.maxDate ? e.yearPicker ? ye(y) > ye(a.value.maxDate) : He(y, a.value.maxDate) : !1, v = (y) => a.value.minDate ? e.yearPicker ? ye(y) < ye(a.value.minDate) : Fe(y, a.value.minDate) : !1, u = (y) => {
    const b = o(y), g = v(y), L = l(y), ee = t.value.months.map((m) => +m).includes(Te(y)), V = e.disabledWeekDays.length ? e.disabledWeekDays.some((m) => +m === lo(y)) : !1, K = _(y), T = ye(y), ie = Nr(e.yearRange, T);
    return !(b || g || L || ee || ie || V || K);
  }, x = (y, b) => Fe(...Nt(a.value.minDate, y, b)) || De(...Nt(a.value.minDate, y, b)), f = (y, b) => He(...Nt(a.value.maxDate, y, b)) || De(...Nt(a.value.maxDate, y, b)), p = (y, b, g) => {
    let L = !1;
    return a.value.maxDate && g && f(y, b) && (L = !0), a.value.minDate && !g && x(y, b) && (L = !0), L;
  }, h = (y, b, g, L) => {
    let ee = !1;
    return L && (a.value.minDate || a.value.maxDate) ? a.value.minDate && a.value.maxDate ? ee = p(y, b, g) : (a.value.minDate && x(y, b) || a.value.maxDate && f(y, b)) && (ee = !0) : ee = !0, ee;
  }, _ = (y) => Array.isArray(a.value.allowedDates) && !a.value.allowedDates.length ? !0 : a.value.allowedDates ? !Ya(y, a.value.allowedDates, Pr(e.monthPicker, e.yearPicker)) : !1, C = (y) => !u(y), Y = (y) => n.value.noDisabledRange ? !sr({ start: y[0], end: y[1] }).some((b) => C(b)) : !0, P = (y) => {
    if (y) {
      const b = ye(y);
      return b >= +e.yearRange[0] && b <= e.yearRange[1];
    }
    return !0;
  }, O = (y, b) => !!(Array.isArray(y) && y[b] && (n.value.maxRange || n.value.minRange) && P(y[b])), R = (y, b, g = 0) => {
    if (O(b, g) && P(y)) {
      const L = rr(y, b[g]), ee = Cr(b[g], y), V = ee.length === 1 ? 0 : ee.filter((T) => C(T)).length, K = Math.abs(L) - (n.value.minMaxRawRange ? 0 : V);
      if (n.value.minRange && n.value.maxRange)
        return K >= +n.value.minRange && K <= +n.value.maxRange;
      if (n.value.minRange) return K >= +n.value.minRange;
      if (n.value.maxRange) return K <= +n.value.maxRange;
    }
    return !0;
  }, k = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, E = (y) => Array.isArray(y) ? [y[0] ? Ka(y[0]) : null, y[1] ? Ka(y[1]) : null] : Ka(y), X = (y, b, g) => y.find(
    (L) => +L.hours === Ct(b) && L.minutes === "*" ? !0 : +L.minutes === Et(b) && +L.hours === Ct(b)
  ) && g, S = (y, b, g) => {
    const [L, ee] = y, [V, K] = b;
    return !X(L, V, g) && !X(ee, K, g) && g;
  }, N = (y, b) => {
    const g = Array.isArray(b) ? b : [b];
    return Array.isArray(e.disabledTimes) ? Array.isArray(e.disabledTimes[0]) ? S(e.disabledTimes, g, y) : !g.some((L) => X(e.disabledTimes, L, y)) : y;
  }, ae = (y, b) => {
    const g = Array.isArray(b) ? [Ut(b[0]), b[1] ? Ut(b[1]) : void 0] : Ut(b), L = !e.disabledTimes(g);
    return y && L;
  }, q = (y, b) => e.disabledTimes ? Array.isArray(e.disabledTimes) ? N(b, y) : ae(b, y) : b, F = (y) => {
    let b = !0;
    if (!y || k()) return !0;
    const g = !a.value.minDate && !a.value.maxDate ? E(y) : y;
    return (e.maxTime || a.value.maxDate) && (b = jn(
      e.maxTime,
      a.value.maxDate,
      "max",
      Xe(g),
      b
    )), (e.minTime || a.value.minDate) && (b = jn(
      e.minTime,
      a.value.minDate,
      "min",
      Xe(g),
      b
    )), q(y, b);
  }, ne = (y) => {
    if (!e.monthPicker) return !0;
    let b = !0;
    const g = B(wt(y));
    if (a.value.minDate && a.value.maxDate) {
      const L = B(wt(a.value.minDate)), ee = B(wt(a.value.maxDate));
      return He(g, L) && Fe(g, ee) || De(g, L) || De(g, ee);
    }
    if (a.value.minDate) {
      const L = B(wt(a.value.minDate));
      b = He(g, L) || De(g, L);
    }
    if (a.value.maxDate) {
      const L = B(wt(a.value.maxDate));
      b = Fe(g, L) || De(g, L);
    }
    return b;
  }, ue = W(() => (y) => !e.enableTimePicker || e.ignoreTimeValidation ? !0 : F(y)), he = W(() => (y) => e.monthPicker ? Array.isArray(y) && (n.value.enabled || r.value.enabled) ? !y.filter((b) => !ne(b)).length : ne(y) : !0);
  return {
    isDisabled: C,
    validateDate: u,
    validateMonthYearInRange: h,
    isDateRangeAllowed: Y,
    checkMinMaxRange: R,
    isValidTime: F,
    isTimeValid: ue,
    isMonthValid: he
  };
}, Fa = () => {
  const e = W(() => (a, r) => a?.includes(r)), t = W(() => (a, r) => a.count ? a.solo ? !0 : r === 0 : !0), n = W(() => (a, r) => a.count ? a.solo ? !0 : r === a.count - 1 : !0);
  return { hideNavigationButtons: e, showLeftIcon: t, showRightIcon: n };
}, tu = (e, t, n) => {
  const a = G(0), r = _a({
    [zt.timePicker]: !e.enableTimePicker || e.timePicker || e.monthPicker,
    [zt.calendar]: !1,
    [zt.header]: !1
  }), l = W(() => e.monthPicker || e.timePicker), o = (p) => {
    if (e.flow?.length) {
      if (!p && l.value) return f();
      r[p] = !0, Object.keys(r).filter((h) => !r[h]).length || f();
    }
  }, v = () => {
    e.flow?.length && a.value !== -1 && (a.value += 1, t("flow-step", a.value), f()), e.flow?.length === a.value && dt().then(() => u());
  }, u = () => {
    a.value = -1;
  }, x = (p, h, ..._) => {
    e.flow[a.value] === p && n.value && n.value[h]?.(..._);
  }, f = (p = 0) => {
    p && (a.value += p), x(et.month, "toggleMonthPicker", !0), x(et.year, "toggleYearPicker", !0), x(et.calendar, "toggleTimePicker", !1, !0), x(et.time, "toggleTimePicker", !0, !0);
    const h = e.flow[a.value];
    (h === et.hours || h === et.minutes || h === et.seconds) && x(h, "toggleTimePicker", !0, !0, h);
  };
  return { childMount: o, updateFlowStep: v, resetFlow: u, handleFlow: f, flowStep: a };
}, au = {
  key: 1,
  class: "dp__input_wrap"
}, nu = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], ru = {
  key: 2,
  class: "dp--clear-btn"
}, lu = ["aria-label"], ou = /* @__PURE__ */ Ge({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...Ia
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur",
    "text-input"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, r = e, {
      defaultedTextInput: l,
      defaultedAriaLabels: o,
      defaultedInline: v,
      defaultedConfig: u,
      defaultedRange: x,
      defaultedMultiDates: f,
      defaultedUI: p,
      getDefaultPattern: h,
      getDefaultStartTime: _
    } = Ne(r), { checkMinMaxRange: C } = Bt(r), Y = G(), P = G(null), O = G(!1), R = G(!1), k = W(
      () => ({
        dp__pointer: !r.disabled && !r.readonly && !l.value.enabled,
        dp__disabled: r.disabled,
        dp__input_readonly: !l.value.enabled,
        dp__input: !0,
        dp__input_not_clearable: !r.clearable,
        dp__input_icon_pad: !r.hideInputIcon,
        dp__input_valid: typeof r.state == "boolean" ? r.state : !1,
        dp__input_invalid: typeof r.state == "boolean" ? !r.state : !1,
        dp__input_focus: O.value || r.isMenuOpen,
        dp__input_reg: !l.value.enabled,
        ...p.value.input ?? {}
      })
    ), E = () => {
      a("set-input-date", null), r.clearable && r.autoApply && (a("set-empty-date"), Y.value = null);
    }, X = (T) => {
      const ie = _();
      return _s(
        T,
        l.value.format ?? h(),
        ie ?? Rr({}, r.enableSeconds),
        r.inputValue,
        R.value,
        r.formatLocale
      );
    }, S = (T) => {
      const { rangeSeparator: ie } = l.value, [m, I] = T.split(`${ie}`);
      if (m) {
        const M = X(m.trim()), re = I ? X(I.trim()) : void 0;
        if (Xt(M, re)) return;
        const c = M && re ? [M, re] : [M];
        C(re, c, 0) && (Y.value = M ? c : null);
      }
    }, N = () => {
      R.value = !0;
    }, ae = (T) => {
      if (x.value.enabled)
        S(T);
      else if (f.value.enabled) {
        const ie = T.split(";");
        Y.value = ie.map((m) => X(m.trim())).filter((m) => m);
      } else
        Y.value = X(T);
    }, q = (T) => {
      const ie = typeof T == "string" ? T : T.target?.value;
      ie !== "" ? (l.value.openMenu && !r.isMenuOpen && a("open"), ae(ie), a("set-input-date", Y.value)) : E(), R.value = !1, a("update:input-value", ie), a("text-input", T, Y.value);
    }, F = (T) => {
      l.value.enabled ? (ae(T.target.value), l.value.enterSubmit && cn(Y.value) && r.inputValue !== "" ? (a("set-input-date", Y.value, !0), Y.value = null) : l.value.enterSubmit && r.inputValue === "" && (Y.value = null, a("clear"))) : he(T);
    }, ne = (T, ie) => {
      l.value.enabled && l.value.tabSubmit && !ie && ae(T.target.value), l.value.tabSubmit && cn(Y.value) && r.inputValue !== "" ? (a("set-input-date", Y.value, !0, !0), Y.value = null) : l.value.tabSubmit && r.inputValue === "" && (Y.value = null, a("clear", !0));
    }, ue = () => {
      O.value = !0, a("focus"), dt().then(() => {
        l.value.enabled && l.value.selectOnFocus && P.value?.select();
      });
    }, he = (T) => {
      if (Vt(T, u.value, !0), l.value.enabled && l.value.openMenu && !v.value.input) {
        if (l.value.openMenu === "open" && !r.isMenuOpen) return a("open");
        if (l.value.openMenu === "toggle") return a("toggle");
      } else l.value.enabled || a("toggle");
    }, y = () => {
      a("real-blur"), O.value = !1, (!r.isMenuOpen || v.value.enabled && v.value.input) && a("blur"), r.autoApply && l.value.enabled && Y.value && !r.isMenuOpen && (a("set-input-date", Y.value), a("select-date"), Y.value = null);
    }, b = (T) => {
      Vt(T, u.value, !0), a("clear");
    }, g = () => {
      a("close");
    }, L = (T) => {
      if (T.key === "Tab" && ne(T), T.key === "Enter" && F(T), T.key === "Escape" && l.value.escClose && g(), !l.value.enabled) {
        if (T.code === "Tab") return;
        T.preventDefault();
      }
    }, ee = () => {
      P.value?.focus({ preventScroll: !0 });
    }, V = (T) => {
      Y.value = T;
    }, K = (T) => {
      T.key === Se.tab && ne(T, !0);
    };
    return t({
      focusInput: ee,
      setParsedDate: V
    }), (T, ie) => (D(), H("div", { onClick: he }, [
      T.$slots.trigger && !T.$slots["dp-input"] && !d(v).enabled ? se(T.$slots, "trigger", { key: 0 }) : z("", !0),
      !T.$slots.trigger && (!d(v).enabled || d(v).input) ? (D(), H("div", au, [
        T.$slots["dp-input"] && !T.$slots.trigger && (!d(v).enabled || d(v).enabled && d(v).input) ? se(T.$slots, "dp-input", {
          key: 0,
          value: e.inputValue,
          isMenuOpen: e.isMenuOpen,
          onInput: q,
          onEnter: F,
          onTab: ne,
          onClear: b,
          onBlur: y,
          onKeypress: L,
          onPaste: N,
          onFocus: ue,
          openMenu: () => T.$emit("open"),
          closeMenu: () => T.$emit("close"),
          toggleMenu: () => T.$emit("toggle")
        }) : z("", !0),
        T.$slots["dp-input"] ? z("", !0) : (D(), H("input", {
          key: 1,
          id: T.uid ? `dp-input-${T.uid}` : void 0,
          ref_key: "inputRef",
          ref: P,
          "data-test-id": "dp-input",
          name: T.name,
          class: ke(k.value),
          inputmode: d(l).enabled ? "text" : "none",
          placeholder: T.placeholder,
          disabled: T.disabled,
          readonly: T.readonly,
          required: T.required,
          value: e.inputValue,
          autocomplete: T.autocomplete,
          "aria-label": d(o)?.input,
          "aria-disabled": T.disabled || void 0,
          "aria-invalid": T.state === !1 ? !0 : void 0,
          onInput: q,
          onBlur: y,
          onFocus: ue,
          onKeypress: L,
          onKeydown: ie[0] || (ie[0] = (m) => L(m)),
          onPaste: N
        }, null, 42, nu)),
        ge("div", {
          onClick: ie[3] || (ie[3] = (m) => a("toggle"))
        }, [
          T.$slots["input-icon"] && !T.hideInputIcon ? (D(), H("span", {
            key: 0,
            class: "dp__input_icon",
            onClick: ie[1] || (ie[1] = (m) => a("toggle"))
          }, [
            se(T.$slots, "input-icon")
          ])) : z("", !0),
          !T.$slots["input-icon"] && !T.hideInputIcon && !T.$slots["dp-input"] ? (D(), Ae(d(ca), {
            key: 1,
            "aria-label": d(o)?.calendarIcon,
            class: "dp__input_icon dp__input_icons",
            onClick: ie[2] || (ie[2] = (m) => a("toggle"))
          }, null, 8, ["aria-label"])) : z("", !0)
        ]),
        T.$slots["clear-icon"] && (T.alwaysClearable || e.inputValue && T.clearable && !T.disabled && !T.readonly) ? (D(), H("span", ru, [
          se(T.$slots, "clear-icon", { clear: b })
        ])) : z("", !0),
        !T.$slots["clear-icon"] && (T.alwaysClearable || T.clearable && e.inputValue && !T.disabled && !T.readonly) ? (D(), H("button", {
          key: 3,
          "aria-label": d(o)?.clearInput,
          class: "dp--clear-btn",
          type: "button",
          onKeydown: ie[4] || (ie[4] = (m) => d(rt)(m, () => b(m), !0, K)),
          onClick: ie[5] || (ie[5] = ga((m) => b(m), ["prevent"]))
        }, [
          ut(d(Mr), {
            class: "dp__input_icons",
            "data-test-id": "clear-icon"
          })
        ], 40, lu)) : z("", !0)
      ])) : z("", !0)
    ]));
  }
}), su = typeof window < "u" ? window : void 0, rn = () => {
}, iu = (e) => Kr() ? (Zr(e), !0) : !1, uu = (e, t, n, a) => {
  if (!e) return rn;
  let r = rn;
  const l = ft(
    () => d(e),
    (v) => {
      r(), v && (v.removeEventListener(t, n), v.addEventListener(t, n, a), r = () => {
        v.removeEventListener(t, n, a), r = rn;
      });
    },
    { immediate: !0, flush: "post" }
  ), o = () => {
    l(), r();
  };
  return iu(o), o;
}, du = (e, t, n, a = {}) => {
  const { window: r = su, event: l = "pointerdown" } = a;
  return r ? uu(r, l, (o) => {
    const v = ze(e), u = ze(t);
    !v || !u || v === o.target || o.composedPath().includes(v) || o.composedPath().includes(u) || n(o);
  }, { passive: !0 }) : void 0;
}, cu = ["data-dp-mobile"], vu = /* @__PURE__ */ Ge({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...Ia
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "text-input"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, r = e, l = jt(), o = G(!1), v = ya(r, "modelValue"), u = ya(r, "timezone"), x = G(null), f = G(null), p = G(null), h = G(!1), _ = G(null), C = G(!1), Y = G(!1), P = G(!1), O = G(!1), { setMenuFocused: R, setShiftKey: k } = Vr(), { clearArrowNav: E } = Lt(), { validateDate: X, isValidTime: S } = Bt(r), {
      defaultedTransitions: N,
      defaultedTextInput: ae,
      defaultedInline: q,
      defaultedConfig: F,
      defaultedRange: ne,
      defaultedMultiDates: ue
    } = Ne(r), { menuTransition: he, showTransition: y } = xa(N), { isMobile: b } = qr(F), g = Xr();
    Je(() => {
      c(r.modelValue), dt().then(() => {
        q.value.enabled || (m(_.value)?.addEventListener("scroll", $), window?.addEventListener("resize", Me));
      }), q.value.enabled && (o.value = !0), window?.addEventListener("keyup", fe), window?.addEventListener("keydown", Ke);
    }), ua(() => {
      q.value.enabled || (m(_.value)?.removeEventListener("scroll", $), window?.removeEventListener("resize", Me)), window?.removeEventListener("keyup", fe), window?.removeEventListener("keydown", Ke);
    });
    const L = it(l, "all", r.presetDates), ee = it(l, "input");
    ft(
      [v, u],
      () => {
        c(v.value);
      },
      { deep: !0 }
    );
    const { openOnTop: V, menuStyle: K, xCorrect: T, setMenuPosition: ie, getScrollableParent: m, shadowRender: I } = Ji({
      menuRef: x,
      menuRefInner: f,
      inputRef: p,
      pickerWrapperRef: _,
      inline: q,
      emit: a,
      props: r,
      slots: l
    }), {
      inputValue: M,
      internalModelValue: re,
      parseExternalModelValue: c,
      emitModelValue: i,
      formatInputValue: U,
      checkBeforeEmit: Pe
    } = Us(a, r, { isInputFocused: h, isTextInputDate: O }), j = W(
      () => ({
        dp__main: !0,
        dp__theme_dark: r.dark,
        dp__theme_light: !r.dark,
        dp__flex_display: q.value.enabled,
        "dp--flex-display-collapsed": P.value,
        dp__flex_display_with_input: q.value.input
      })
    ), we = W(() => r.dark ? "dp__theme_dark" : "dp__theme_light"), J = W(() => r.teleport ? {
      to: typeof r.teleport == "boolean" ? "body" : r.teleport,
      disabled: !r.teleport || q.value.enabled
    } : {}), te = W(() => ({ class: "dp__outer_menu_wrap" })), s = W(() => q.value.enabled && (r.timePicker || r.monthPicker || r.yearPicker || r.quarterPicker)), le = () => p.value?.$el?.getBoundingClientRect() ?? { width: 0, left: 0, right: 0 }, $ = () => {
      o.value && (F.value.closeOnScroll ? lt() : ie());
    }, Me = () => {
      o.value && ie();
      const Q = f.value?.$el.getBoundingClientRect().width ?? 0;
      P.value = document.body.offsetWidth <= Q;
    }, fe = (Q) => {
      Q.key === "Tab" && !q.value.enabled && !r.teleport && F.value.tabOutClosesMenu && (_.value.contains(document.activeElement) || lt()), Y.value = Q.shiftKey;
    }, Ke = (Q) => {
      Y.value = Q.shiftKey;
    }, Le = () => {
      !r.disabled && !r.readonly && (I(g, Zn, r), ie(!1), o.value = !0, o.value && a("open"), o.value || Gt(), c(r.modelValue));
    }, mt = () => {
      M.value = "", Gt(), f.value?.onValueCleared(), p.value?.setParsedDate(null), a("update:model-value", null), a("update:model-timezone-value", null), a("cleared"), F.value.closeOnClearValue && lt();
    }, A = () => {
      const Q = re.value;
      return !Q || !Array.isArray(Q) && X(Q) ? !0 : Array.isArray(Q) ? ue.value.enabled || Q.length === 2 && X(Q[0]) && X(Q[1]) ? !0 : ne.value.partialRange && !r.timePicker ? X(Q[0]) : !1 : !1;
    }, oe = () => {
      Pe() && A() ? (i(), lt()) : a("invalid-select", re.value);
    }, de = (Q) => {
      Rt(), i(), F.value.closeOnAutoApply && !Q && lt();
    }, Rt = () => {
      p.value && ae.value.enabled && p.value.setParsedDate(re.value);
    }, pt = (Q = !1) => {
      r.autoApply && S(re.value) && A() && (ne.value.enabled && Array.isArray(re.value) ? (ne.value.partialRange || re.value.length === 2) && de(Q) : de(Q));
    }, Gt = () => {
      ae.value.enabled || (re.value = null);
    }, lt = (Q = !1) => {
      Q && re.value && F.value.setDateOnMenuClose && oe(), q.value.enabled || (o.value && (o.value = !1, T.value = !1, R(!1), k(!1), E(), a("closed"), M.value && c(v.value)), Gt(), a("blur"), f.value?.$el?.remove());
    }, Ea = (Q, ce, me = !1) => {
      if (!Q) {
        re.value = null;
        return;
      }
      const Pt = Array.isArray(Q) ? !Q.some((Ht) => !X(Ht)) : X(Q), Mt = S(Q);
      Pt && Mt ? (O.value = !0, re.value = Q, ce ? (C.value = me, oe(), a("text-submit")) : r.autoApply && pt(!0), dt().then(() => {
        O.value = !1;
      })) : a("invalid-date", Q);
    }, La = () => {
      r.autoApply && S(re.value) && i(), Rt();
    }, Da = () => o.value ? lt() : Le(), Ba = (Q) => {
      re.value = Q;
    }, Ha = () => {
      ae.value.enabled && (h.value = !0, U()), a("focus");
    }, Wa = () => {
      ae.value.enabled && (h.value = !1, c(r.modelValue), C.value && gs(_.value, Y.value)?.focus()), a("blur");
    }, qa = (Q) => {
      f.value && f.value.updateMonthYear(0, {
        month: zn(Q.month),
        year: zn(Q.year)
      });
    }, za = (Q) => {
      c(Q ?? r.modelValue);
    }, w = (Q, ce) => {
      f.value?.switchView(Q, ce);
    }, Z = (Q, ce) => F.value.onClickOutside ? F.value.onClickOutside(Q, ce) : lt(!0), ve = (Q = 0) => {
      f.value?.handleFlow(Q);
    }, xe = () => x;
    return du(
      x,
      p,
      (Q) => Z(A, Q)
    ), t({
      closeMenu: lt,
      selectDate: oe,
      clearValue: mt,
      openMenu: Le,
      onScroll: $,
      formatInputValue: U,
      // exposed for testing purposes
      updateInternalModelValue: Ba,
      // modify internal modelValue
      setMonthYear: qa,
      parseModel: za,
      switchView: w,
      toggleMenu: Da,
      handleFlow: ve,
      getDpWrapMenuRef: xe
    }), (Q, ce) => (D(), H("div", {
      ref_key: "pickerWrapperRef",
      ref: _,
      class: ke(j.value),
      "data-datepicker-instance": "",
      "data-dp-mobile": d(b)
    }, [
      ut(ou, je({
        ref_key: "inputRef",
        ref: p,
        "input-value": d(M),
        "onUpdate:inputValue": ce[0] || (ce[0] = (me) => Rn(M) ? M.value = me : null),
        "is-menu-open": o.value
      }, Q.$props, {
        onClear: mt,
        onOpen: Le,
        onSetInputDate: Ea,
        onSetEmptyDate: d(i),
        onSelectDate: oe,
        onToggle: Da,
        onClose: lt,
        onFocus: Ha,
        onBlur: Wa,
        onRealBlur: ce[1] || (ce[1] = (me) => h.value = !1),
        onTextInput: ce[2] || (ce[2] = (me) => Q.$emit("text-input", me))
      }), at({ _: 2 }, [
        Ie(d(ee), (me, Pt) => ({
          name: me,
          fn: _e((Mt) => [
            se(Q.$slots, me, Qe(ot(Mt)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      (D(), Ae(Sa(Q.teleport ? jr : "div"), Qe(ot(J.value)), {
        default: _e(() => [
          ut(da, {
            name: d(he)(d(V)),
            css: d(y) && !d(q).enabled
          }, {
            default: _e(() => [
              o.value ? (D(), H("div", je({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: x
              }, te.value, {
                class: { "dp--menu-wrapper": !d(q).enabled },
                style: d(q).enabled ? void 0 : d(K)
              }), [
                ut(Zn, je({
                  ref_key: "dpMenuRef",
                  ref: f
                }, Q.$props, {
                  "internal-model-value": d(re),
                  "onUpdate:internalModelValue": ce[3] || (ce[3] = (me) => Rn(re) ? re.value = me : null),
                  class: { [we.value]: !0, "dp--menu-wrapper": Q.teleport },
                  "open-on-top": d(V),
                  "no-overlay-focus": s.value,
                  collapse: P.value,
                  "get-input-rect": le,
                  "is-text-input-date": O.value,
                  onClosePicker: lt,
                  onSelectDate: oe,
                  onAutoApply: pt,
                  onTimeUpdate: La,
                  onFlowStep: ce[4] || (ce[4] = (me) => Q.$emit("flow-step", me)),
                  onUpdateMonthYear: ce[5] || (ce[5] = (me) => Q.$emit("update-month-year", me)),
                  onInvalidSelect: ce[6] || (ce[6] = (me) => Q.$emit("invalid-select", d(re))),
                  onAutoApplyInvalid: ce[7] || (ce[7] = (me) => Q.$emit("invalid-select", me)),
                  onInvalidFixedRange: ce[8] || (ce[8] = (me) => Q.$emit("invalid-fixed-range", me)),
                  onRecalculatePosition: d(ie),
                  onTooltipOpen: ce[9] || (ce[9] = (me) => Q.$emit("tooltip-open", me)),
                  onTooltipClose: ce[10] || (ce[10] = (me) => Q.$emit("tooltip-close", me)),
                  onTimePickerOpen: ce[11] || (ce[11] = (me) => Q.$emit("time-picker-open", me)),
                  onTimePickerClose: ce[12] || (ce[12] = (me) => Q.$emit("time-picker-close", me)),
                  onAmPmChange: ce[13] || (ce[13] = (me) => Q.$emit("am-pm-change", me)),
                  onRangeStart: ce[14] || (ce[14] = (me) => Q.$emit("range-start", me)),
                  onRangeEnd: ce[15] || (ce[15] = (me) => Q.$emit("range-end", me)),
                  onDateUpdate: ce[16] || (ce[16] = (me) => Q.$emit("date-update", me)),
                  onInvalidDate: ce[17] || (ce[17] = (me) => Q.$emit("invalid-date", me)),
                  onOverlayToggle: ce[18] || (ce[18] = (me) => Q.$emit("overlay-toggle", me)),
                  onMenuBlur: ce[19] || (ce[19] = (me) => Q.$emit("blur"))
                }), at({ _: 2 }, [
                  Ie(d(L), (me, Pt) => ({
                    name: me,
                    fn: _e((Mt) => [
                      se(Q.$slots, me, Qe(ot({ ...Mt })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "no-overlay-focus", "collapse", "is-text-input-date", "onRecalculatePosition"])
              ], 16)) : z("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16))
    ], 10, cu));
  }
}), zr = /* @__PURE__ */ (() => {
  const e = vu;
  return e.install = (t) => {
    t.component("Vue3DatePicker", e);
  }, e;
})(), fu = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zr
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(fu).forEach(([e, t]) => {
  e !== "default" && (zr[e] = t);
});
export {
  zr as q
};
